export default {
  'pages.layouts.userLayout.title': 'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '请输入正确的账号和密码~',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码',
  'pages.login.submit': '登录',
  'pages.login.next': '下一步',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.login.dinglong.account.placeholder': '账号',
  'pages.login.dinglong.password.placeholder': '密码',
  'pages.login.dinglong.confirmModification': '确认修改',
  'pages.login.dinglong.phoneNumber.placeholder': '请输入与系统绑定的手机号码',
  'pages.login.dinglong.passwordSet.placeholder': '请输入新密码（6~18位）',
  'pages.login.dinglong.passwordSet.invalid': '密码格式错误',
  'pages.login.dinglong.passwordConfirm.placeholder': '请再次输入新密码',
  'pages.login.dinglong.passwordConfirm.invalid': '密码输入错误',
  'pages.login.dinglong.captcha.placeholder':'验证码',
  'pages.welcome.advancedComponent': '高级表格',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.advancedLayout': '高级布局',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.HutManage.AddHut.index.t0': '请求失败，请稍后重试',
  'pages.HutManage.AddHut.index.t1': '请输入正确格式的联系电话！',
  'pages.HutManage.AddHut.index.t2': '请选择小屋地址！',
  'pages.HutManage.AddHut.index.t3': '请填写小屋名称！',
  'pages.HutManage.AddHut.index.t4': '请选择所属部门！',
  'pages.HutManage.AddHut.index.t5': '请填写负责人姓名！',
  'pages.HutManage.AddHut.index.t6': '请输入',
  'pages.HutManage.AddHut.index.t7': '请选择扫码平台！',
  'pages.HutManage.AddHut.index.t8': '请选择客户端！',
  'pages.HutManage.AddHut.index.t9': '请选择报告封面logo',
  'pages.HutManage.AddHut.index.t10': 'EXE界面logo',
  'pages.HutManage.AddHut.index.t11': '微信',
  'pages.HutManage.AddHut.index.t12': '绑定小程序',
  'pages.HutManage.AddHut.index.t13': '请绑定小程序！',
  'pages.HutManage.AddHut.index.t14': '绑定APP',
  'pages.HutManage.AddHut.index.t15': '请绑定APP！',
  'pages.HutManage.ExamRecords.index.t0': '检测编号',
  'pages.HutManage.ExamRecords.index.t1': '设备号',
  'pages.HutManage.ExamRecords.index.t2': '认领人',
  'pages.HutManage.ExamRecords.index.t3': '检测人',
  'pages.HutManage.ExamRecords.index.t4': '性别/年龄',
  'pages.HutManage.ExamRecords.index.t5': '-',
  'pages.HutManage.ExamRecords.index.t6': '手机号',
  'pages.HutManage.ExamRecords.index.t7': '健康小屋',
  'pages.HutManage.ExamRecords.index.t8': '检测进度',
  'pages.HutManage.ExamRecords.index.t9': '检测状态',
  'pages.HutManage.ExamRecords.index.t10': '进行中',
  'pages.HutManage.ExamRecords.index.t11': '已完成',
  'pages.HutManage.ExamRecords.index.t12': '取消',
  'pages.HutManage.ExamRecords.index.t13': '认领状态',
  'pages.HutManage.ExamRecords.index.t14': '已认领',
  'pages.HutManage.ExamRecords.index.t15': '未认领',
  'pages.HutManage.ExamRecords.index.t16': '开始检测时间',
  'pages.HutManage.ExamRecords.index.t17': '检测时间段',
  'pages.HutManage.ExamRecords.index.t18': '结束检测时间',
  'pages.HutManage.ExamRecords.index.t19': '操作人',
  'pages.HutManage.ExamRecords.index.t20': '操作',
  'pages.HutManage.ExamRecords.index.t21': '查看报告',
  'pages.HutManage.ExamRecords.index.t22': '查看数据',
  'pages.HutManage.ExamRecords.index.t23': '认领报告',
  'pages.HutManage.ExamRecords.index.t24': '未选中客户',
  'pages.HutManage.ExamRecords.index.t25': '请先完善个人信息',
  'pages.HutManage.ExamRecords.index.t26': '确认认领？',
  'pages.HutManage.ExamRecords.index.t27': '确认为{name}认领以下报告吗？',
  'pages.HutManage.ExamRecords.index.t28': '检测结果：',
  'pages.HutManage.ExamRecords.index.t29': '检测日期：',
  'pages.HutManage.ExamRecords.index.t30': '来源：',
  'pages.HutManage.ExamRecords.index.t31': '认领成功',
  'pages.HutManage.ExamRecords.index.t32': '查看该客户的健康小屋报告',
  'pages.HutManage.ExamRecords.index.t33': '点击',
  'pages.HutManage.ExamRecords.index.t34': '第1步，共2步',
  'pages.HutManage.ExamRecords.index.t35': '点击认领报告后，客户可在公众号/小程序中查看健康小屋报告',
  'pages.HutManage.ExamRecords.index.t36': '点击',
  'pages.HutManage.ExamRecords.index.t37': '第2步，共2步',
  'pages.HutManage.ExamRecords.index.t38': '结束检测',
  'pages.HutManage.ExamRecords.index.t39': '确认结束检测吗？',
  'pages.HutManage.ExamRecords.index.t40': '取消',
  'pages.HutManage.ExamRecords.DataModal.index.t0': '血压',
  'pages.HutManage.ExamRecords.DataModal.index.t1': '血糖',
  'pages.HutManage.ExamRecords.DataModal.index.t2': '血氧',
  'pages.HutManage.ExamRecords.DataModal.index.t3': '体温',
  'pages.HutManage.ExamRecords.DataModal.index.t4': '尿常规',
  'pages.HutManage.ExamRecords.DataModal.index.t5': '身高体重',
  'pages.HutManage.ExamRecords.DataModal.index.t6': '心电',
  'pages.HutManage.ExamRecords.DataModal.index.t7': '未知',
  'pages.HutManage.ExamRecords.DataModal.index.t8': '男',
  'pages.HutManage.ExamRecords.DataModal.index.t9': '女',
  'pages.HutManage.ExamRecords.DataModal.index.t10': '检测项目',
  'pages.HutManage.ExamRecords.DataModal.index.t11': '身高(cm)',
  'pages.HutManage.ExamRecords.DataModal.index.t12': '体重(kg)',
  'pages.HutManage.ExamRecords.DataModal.index.t13': '体重状态',
  'pages.HutManage.ExamRecords.DataModal.index.t14': '身体质量指数BMI',
  'pages.HutManage.ExamRecords.DataModal.index.t15': 'hwBmi状态',
  'pages.HutManage.ExamRecords.DataModal.index.t16': '腰围(cm)',
  'pages.HutManage.ExamRecords.DataModal.index.t17': '臀围(cm)',
  'pages.HutManage.ExamRecords.DataModal.index.t18': '左眼视力',
  'pages.HutManage.ExamRecords.DataModal.index.t19': '左眼视力状态',
  'pages.HutManage.ExamRecords.DataModal.index.t20': '右眼视力',
  'pages.HutManage.ExamRecords.DataModal.index.t21': '右眼视力状态',
  'pages.HutManage.ExamRecords.DataModal.index.t22': '收缩压(mmHg)',
  'pages.HutManage.ExamRecords.DataModal.index.t23': '收缩压状态',
  'pages.HutManage.ExamRecords.DataModal.index.t24': '舒张压(mmHg)',
  'pages.HutManage.ExamRecords.DataModal.index.t25': '舒张压状态',
  'pages.HutManage.ExamRecords.DataModal.index.t26': '脉搏(分/次)',
  'pages.HutManage.ExamRecords.DataModal.index.t27': '脉搏状态',
  'pages.HutManage.ExamRecords.DataModal.index.t28': '血氧(%)',
  'pages.HutManage.ExamRecords.DataModal.index.t29': '血糖(mmol/L)',
  'pages.HutManage.ExamRecords.DataModal.index.t30': '血糖状态',
  'pages.HutManage.ExamRecords.DataModal.index.t31': '血糖类型',
  'pages.HutManage.ExamRecords.DataModal.index.t32': '体温(℃)',
  'pages.HutManage.ExamRecords.DataModal.index.t33': '体温状态',
  'pages.HutManage.ExamRecords.DataModal.index.t34': '体脂肪率(%)',
  'pages.HutManage.ExamRecords.DataModal.index.t35': '体脂肪率状态',
  'pages.HutManage.ExamRecords.DataModal.index.t36': '体脂肪量(Kg)',
  'pages.HutManage.ExamRecords.DataModal.index.t37': '体水分率(%)',
  'pages.HutManage.ExamRecords.DataModal.index.t38': '体水分率状态',
  'pages.HutManage.ExamRecords.DataModal.index.t39': '体水分量(Kg)',
  'pages.HutManage.ExamRecords.DataModal.index.t40': '基础代谢(Kcal)',
  'pages.HutManage.ExamRecords.DataModal.index.t41': '基础代谢状态',
  'pages.HutManage.ExamRecords.DataModal.index.t42': '去脂体重',
  'pages.HutManage.ExamRecords.DataModal.index.t43': '骨量',
  'pages.HutManage.ExamRecords.DataModal.index.t44': '肌肉量',
  'pages.HutManage.ExamRecords.DataModal.index.t45': '肌肉率',
  'pages.HutManage.ExamRecords.DataModal.index.t46': '肌肉率状态',
  'pages.HutManage.ExamRecords.DataModal.index.t47': '内脏脂肪',
  'pages.HutManage.ExamRecords.DataModal.index.t48': '内脏脂肪状态',
  'pages.HutManage.ExamRecords.DataModal.index.t49': '体型评估',
  'pages.HutManage.ExamRecords.DataModal.index.t50': '胆固醇',
  'pages.HutManage.ExamRecords.DataModal.index.t51': '胆固醇状态',
  'pages.HutManage.ExamRecords.DataModal.index.t52': '尿酸(mmol/L)',
  'pages.HutManage.ExamRecords.DataModal.index.t53': '尿酸状态',
  'pages.HutManage.ExamRecords.DataModal.index.t54': '总胆固醇(mmol/L)',
  'pages.HutManage.ExamRecords.DataModal.index.t55': '总胆固醇状态',
  'pages.HutManage.ExamRecords.DataModal.index.t56': '甘油三脂(mmol/L)',
  'pages.HutManage.ExamRecords.DataModal.index.t57': '甘油三脂状态',
  'pages.HutManage.ExamRecords.DataModal.index.t58': '高密度蛋白(mmol/L)',
  'pages.HutManage.ExamRecords.DataModal.index.t59': '高密度蛋白状态',
  'pages.HutManage.ExamRecords.DataModal.index.t60': '低密度蛋白(mmol/L)',
  'pages.HutManage.ExamRecords.DataModal.index.t61': '低密度蛋白状态',
  'pages.HutManage.ExamRecords.DataModal.index.t62': '骨密度测量部位',
  'pages.HutManage.ExamRecords.DataModal.index.t63': 'T值',
  'pages.HutManage.ExamRecords.DataModal.index.t64': 'Z值',
  'pages.HutManage.ExamRecords.DataModal.index.t65': '血压结论',
  'pages.HutManage.ExamRecords.DataModal.index.t66': '低压（舒张压）',
  'pages.HutManage.ExamRecords.DataModal.index.t67': '脉搏',
  'pages.HutManage.ExamRecords.DataModal.index.t68': '高压（收缩压）',
  'pages.HutManage.ExamRecords.DataModal.index.t69': '矿物质',
  'pages.HutManage.ExamRecords.DataModal.index.t70': '细胞内液',
  'pages.HutManage.ExamRecords.DataModal.index.t71': '体重调节',
  'pages.HutManage.ExamRecords.DataModal.index.t72': '左臂肌肉量',
  'pages.HutManage.ExamRecords.DataModal.index.t73': '右腿肌肉量',
  'pages.HutManage.ExamRecords.DataModal.index.t74': '非脂肪量',
  'pages.HutManage.ExamRecords.DataModal.index.t75': '脂肪调节',
  'pages.HutManage.ExamRecords.DataModal.index.t76': '体脂结论',
  'pages.HutManage.ExamRecords.DataModal.index.t77': '体脂占比',
  'pages.HutManage.ExamRecords.DataModal.index.t78': '右臂肌肉量',
  'pages.HutManage.ExamRecords.DataModal.index.t79': '躯干肌肉量',
  'pages.HutManage.ExamRecords.DataModal.index.t80': '蛋白质含量',
  'pages.HutManage.ExamRecords.DataModal.index.t81': '肌肉量',
  'pages.HutManage.ExamRecords.DataModal.index.t82': '右腿脂肪量',
  'pages.HutManage.ExamRecords.DataModal.index.t83': '体脂肪量',
  'pages.HutManage.ExamRecords.DataModal.index.t84': '基础代谢',
  'pages.HutManage.ExamRecords.DataModal.index.t85': '躯干脂肪量',
  'pages.HutManage.ExamRecords.DataModal.index.t86': '左腿脂肪量',
  'pages.HutManage.ExamRecords.DataModal.index.t87': '左腿肌肉量',
  'pages.HutManage.ExamRecords.DataModal.index.t88': '体水占比',
  'pages.HutManage.ExamRecords.DataModal.index.t89': '水含量',
  'pages.HutManage.ExamRecords.DataModal.index.t90': '右臂脂肪量',
  'pages.HutManage.ExamRecords.DataModal.index.t91': '肌肉调节',
  'pages.HutManage.ExamRecords.DataModal.index.t92': '左臂脂肪量',
  'pages.HutManage.ExamRecords.DataModal.index.t93': '骨骼量',
  'pages.HutManage.ExamRecords.DataModal.index.t94': '细胞外液',
  'pages.HutManage.ExamRecords.DataModal.index.t95': '内脏脂肪等级',
  'pages.HutManage.ExamRecords.DataModal.index.t96': '体温结论',
  'pages.HutManage.ExamRecords.DataModal.index.t97': '体温值',
  'pages.HutManage.ExamRecords.DataModal.index.t98': '血氧结论',
  'pages.HutManage.ExamRecords.DataModal.index.t99': '血氧列表值',
  'pages.HutManage.ExamRecords.DataModal.index.t100': '开始时间',
  'pages.HutManage.ExamRecords.DataModal.index.t101': '脉率列表值',
  'pages.HutManage.ExamRecords.DataModal.index.t102': '结束时间',
  'pages.HutManage.ExamRecords.DataModal.index.t103': '血氧值',
  'pages.HutManage.ExamRecords.DataModal.index.t104': '体重',
  'pages.HutManage.ExamRecords.DataModal.index.t105': '理想体重',
  'pages.HutManage.ExamRecords.DataModal.index.t106': '身高',
  'pages.HutManage.ExamRecords.DataModal.index.t107': '有氧运动目标',
  'pages.HutManage.ExamRecords.DataModal.index.t108': '无氧运动目标',
  'pages.HutManage.ExamRecords.DataModal.index.t109': '高压',
  'pages.HutManage.ExamRecords.DataModal.index.t110': '低压',
  'pages.HutManage.ExamRecords.DataModal.index.t111': '血氧',
  'pages.HutManage.ExamRecords.DataModal.index.t112': '基础代谢',
  'pages.HutManage.ExamRecords.DataModal.index.t113': '检测结果',
  'pages.HutManage.ExamRecords.DataModal.index.t114': '次/分',
  'pages.HutManage.ExamRecords.DataModal.index.t115': '身高：',
  'pages.HutManage.ExamRecords.DataModal.index.t116': '，体重：',
  'pages.HutManage.ExamRecords.DataModal.index.t117': '偏高',
  'pages.HutManage.ExamRecords.DataModal.index.t118': '偏低',
  'pages.HutManage.ExamRecords.DataModal.index.t119': '正常',
  'pages.HutManage.ExamRecords.DataModal.index.t120': '偏瘦',
  'pages.HutManage.ExamRecords.DataModal.index.t121': '超重',
  'pages.HutManage.ExamRecords.DataModal.index.t122': '肥胖',
  'pages.HutManage.ExamRecords.DataModal.index.t123': '低压',
  'pages.HutManage.ExamRecords.DataModal.index.t124': '轻度高血压',
  'pages.HutManage.ExamRecords.DataModal.index.t125': '中度高血压',
  'pages.HutManage.ExamRecords.DataModal.index.t126': '重度高血压',
  'pages.HutManage.ExamRecords.DataModal.index.t127': '空腹',
  'pages.HutManage.ExamRecords.DataModal.index.t128': '饭后',
  'pages.HutManage.ExamRecords.DataModal.index.t129': '随机',
  'pages.HutManage.ExamRecords.DataModal.index.t130': '稍瘦',
  'pages.HutManage.ExamRecords.DataModal.index.t131': '标准',
  'pages.HutManage.ExamRecords.DataModal.index.t132': '超重',
  'pages.HutManage.ExamRecords.DataModal.index.t133': '肥胖',
  'pages.HutManage.ExamRecords.DataModal.index.t134': '低压',
  'pages.HutManage.ExamRecords.DataModal.index.t135': '正常',
  'pages.HutManage.ExamRecords.DataModal.index.t136': '正常高压',
  'pages.HutManage.ExamRecords.DataModal.index.t137': '轻度高压',
  'pages.HutManage.ExamRecords.DataModal.index.t138': '中度高压',
  'pages.HutManage.ExamRecords.DataModal.index.t139': '重度高压',
  'pages.HutManage.ExamRecords.DataModal.index.t140': '低温',
  'pages.HutManage.ExamRecords.DataModal.index.t141': '高温',
  'pages.HutManage.ExamRecords.DataModal.index.t142': '低血氧',
  'pages.HutManage.ExamRecords.DataModal.index.t143': '正常血氧',
  'pages.HutManage.ExamRecords.DataModal.index.t144': '检测人：',
  'pages.HutManage.ExamRecords.DataModal.index.t145': '手机号',
  'pages.HutManage.ExamRecords.LookHHData.index.t0': '未知',
  'pages.HutManage.ExamRecords.LookHHData.index.t1': '男',
  'pages.HutManage.ExamRecords.LookHHData.index.t2': '女',
  'pages.HutManage.ExamRecords.LookHHData.index.t3': '检测人',
  'pages.HutManage.ExamRecords.LookHHData.index.t4': '性别/年龄',
  'pages.HutManage.ExamRecords.LookHHData.index.t5': '手机号',
  'pages.HutManage.ExamRecords.LookHHData.index.t6': '检测项目',
  'pages.HutManage.ExamRecords.LookHHData.index.t7': '检测结果',
  'pages.HutManage.ExamRecords.LookHHData.index.t8': '查看',
  'pages.HutManage.ExamRecords.LookHHReport.index.t0': '未知',
  'pages.HutManage.ExamRecords.LookHHReport.index.t1': '男',
  'pages.HutManage.ExamRecords.LookHHReport.index.t2': '女',
  'pages.HutManage.ExamRecords.LookHHReport.index.t3': '检测人',
  'pages.HutManage.ExamRecords.LookHHReport.index.t4': '性别/年龄',
  'pages.HutManage.ExamRecords.LookHHReport.index.t5': '手机号',
  'pages.HutManage.ExamRecords.LookHHReport.index.t6': '检测项目',
  'pages.HutManage.ExamRecords.LookHHReport.index.t7': '检测结果',
  'pages.HutManage.ExamRecords.LookHHReport.index.t8': '查看',
  'pages.HutManage.Manage.index.t0': '小屋ID',
  'pages.HutManage.Manage.index.t1': '小屋名称',
  'pages.HutManage.Manage.index.t2': '所属部门',
  'pages.HutManage.Manage.index.t3': '所在城市',
  'pages.HutManage.Manage.index.t4': '负责人',
  'pages.HutManage.Manage.index.t5': '签约日期',
  'pages.HutManage.Manage.index.t6': '设备数量',
  'pages.HutManage.Manage.index.t7': '设备号',
  'pages.HutManage.Manage.index.t8': '使用人数',
  'pages.HutManage.Manage.index.t9': '使用人次',
  'pages.HutManage.Manage.index.t10': '营业状态',
  'pages.HutManage.Manage.index.t11': '开放',
  'pages.HutManage.Manage.index.t12': '关闭',
  'pages.HutManage.Manage.index.t13': '开放',
  'pages.HutManage.Manage.index.t14': '关闭',
  'pages.HutManage.Manage.index.t15': '最近检测时间',
  'pages.HutManage.Manage.index.t16': '检测时间段',
  'pages.HutManage.Manage.index.t17': '操作',
  'pages.HutManage.Manage.index.t18': '已关闭',
  'pages.HutManage.Manage.index.t19': '关闭',
  'pages.HutManage.Manage.index.t20': '已开放',
  'pages.HutManage.Manage.index.t21': '开放',
  'pages.HutManage.Manage.index.t22': '共{total}条记录',
  'pages.HutManage.Manage.components.SetAdminModal.t0': '正在新增',
  'pages.HutManage.Manage.components.SetAdminModal.t1': '新增用户成功',
  'pages.HutManage.Manage.components.SetAdminModal.t2': '新增用户失败请重试！',
  'pages.HutManage.Manage.components.SetAdminModal.t3': '新增用户失败请重试！',
  'pages.HutManage.Manage.components.SetAdminModal.t4': '正在更新',
  'pages.HutManage.Manage.components.SetAdminModal.t5': '更新用户信息成功',
  'pages.HutManage.Manage.components.SetAdminModal.t6': '更新用户信息失败请重试！',
  'pages.HutManage.Manage.components.SetAdminModal.t7': '更新用户信息失败请重试！',
  'pages.HutManage.Manage.components.SetAdminModal.t8': '请求出错，请稍后重试',
  'pages.HutManage.Manage.components.SetAdminModal.t9': '请求出错，请稍后重试',
  'pages.HutManage.Manage.components.SetAdminModal.t10': '小屋管理员设置',
  'pages.HutManage.Manage.components.SetAdminModal.t11': '返回',
  'pages.HutManage.Manage.components.SetAdminModal.t12': '将员工账号设置为健康小屋管理员，用于设定登录电脑客户端的账号，以及限定可浏览的健康小屋数据。',
  'pages.HutManage.Manage.components.SetAdminModal.t13': '请选择管理员！',
  'pages.HutManage.Manage.components.SetAdminModal.t14': '该人员已设为管理员',
  'pages.HutManage.Manage.components.SetAdminModal.t15': '请求失败，请稍后重试',
  'pages.HutManage.Manage.components.SetAdminModal.t16': '设为管理员',
  'pages.HutManage.Manage.components.SetAdminModal.t17': '添加员工账号',
  'pages.HutManage.Manage.components.SetAdminModal.t18': '员工ID',
  'pages.HutManage.Manage.components.SetAdminModal.t19': '员工姓名',
  'pages.HutManage.Manage.components.SetAdminModal.t20': '登录账号',
  'pages.HutManage.Manage.components.SetAdminModal.t21': '角色',
  'pages.HutManage.Manage.components.SetAdminModal.t22': '部门',
  'pages.HutManage.Manage.components.SetAdminModal.t23': '操作',
  'pages.HutManage.Manage.components.SetAdminModal.t24': '移除',
  'pages.HutManage.TestReport.index.t0': '男',
  'pages.HutManage.TestReport.index.t1': '女',
  'pages.HutManage.TestReport.index.t2': '未知',
  'pages.HutManage.TestReport.index.t3': '岁',
  "pages.HutManage.TestReport.Electrocardiography.index.t0": "快速心电",
  "pages.HutManage.TestReport.Electrocardiography.index.t1": "结论：",
  'pages.HutManage.TestReport.Arteriosclerosis.index.t0': '动脉僵硬度与高血压、冠心病、肾衰竭、脑卒中等严重心血管疾病有重大关连。而随著年龄增长，血管僵硬度已被研究证实会随之变高，所以探测血管僵硬度对预测心血管疾病有预测价值。',
  'pages.HutManage.TestReport.Arteriosclerosis.index.t1': '检测建议',
  'pages.HutManage.TestReport.Arteriosclerosis.index.t2': '指标名称',
  'pages.HutManage.TestReport.Arteriosclerosis.index.t3': '检测值',
  'pages.HutManage.TestReport.Arteriosclerosis.index.t4': '参考值',
  'pages.HutManage.TestReport.Arteriosclerosis.index.t5': '动脉硬化评估',
  'pages.HutManage.TestReport.Arteriosclerosis.index.t6': '中心动脉硬度指标（AVI）',
  'pages.HutManage.TestReport.Arteriosclerosis.index.t7': '上臂动脉硬度指标（API）',
  'pages.HutManage.TestReport.BloodPressure.index.t0': '检测建议',
  'pages.HutManage.TestReport.BloodPressure.index.t1': '分级',
  'pages.HutManage.TestReport.BloodPressure.index.t2': '收缩压(mmHg)',
  'pages.HutManage.TestReport.BloodPressure.index.t3': '舒张压(mmHg)',
  'pages.HutManage.TestReport.BloodPressure.index.t4': '正常血压',
  'pages.HutManage.TestReport.BloodPressure.index.t5': '和',
  'pages.HutManage.TestReport.BloodPressure.index.t6': '正常高值',
  'pages.HutManage.TestReport.BloodPressure.index.t7': '和（或）',
  'pages.HutManage.TestReport.BloodPressure.index.t8': '高血压',
  'pages.HutManage.TestReport.BloodPressure.index.t9': '和（或）',
  'pages.HutManage.TestReport.BloodPressure.index.t10': '1级高血压（轻度）',
  'pages.HutManage.TestReport.BloodPressure.index.t11': '和（或）',
  'pages.HutManage.TestReport.BloodPressure.index.t12': '2级高血压（中度）',
  'pages.HutManage.TestReport.BloodPressure.index.t13': '3级高血压（重度）',
  'pages.HutManage.TestReport.BloodPressure.index.t14': '单纯收缩期高血压',
  'pages.HutManage.TestReport.BloodPressure.index.t15': '血压检测',
  'pages.HutManage.TestReport.BloodPressure.index.t16': '收缩压（高压）',
  'pages.HutManage.TestReport.BloodPressure.index.t17': '舒张压（低压）',
  'pages.HutManage.TestReport.BloodPressure.index.t18': '心率',
  'pages.HutManage.TestReport.BloodPressure.index.t19': '次/分',
  'pages.HutManage.TestReport.BloodPressure.index.t20': '收缩压/舒张压',
  'pages.HutManage.TestReport.BMI.index.t0': '检测建议',
  'pages.HutManage.TestReport.BMI.index.t1': '身高体重检测',
  'pages.HutManage.TestReport.BMI.index.t2': '身高',
  'pages.HutManage.TestReport.BMI.index.t3': '体重',
  'pages.HutManage.TestReport.BMI.index.t4': '体重指数（BMI）',
  'pages.HutManage.TestReport.BMI.index.t5': 'BMI结果分布',
  'pages.HutManage.TestReport.BodyComposition.index.t0': '检测建议',
  'pages.HutManage.TestReport.BodyComposition.index.t1': '指标',
  'pages.HutManage.TestReport.BodyComposition.index.t2': '测量值',
  'pages.HutManage.TestReport.BodyComposition.index.t3': '参考值',
  'pages.HutManage.TestReport.BodyComposition.index.t4': '结果',
  'pages.HutManage.TestReport.BodyComposition.index.t5': '未知',
  'pages.HutManage.TestReport.BodyComposition.index.t6': '水分',
  'pages.HutManage.TestReport.BodyComposition.index.t7': '蛋白质',
  'pages.HutManage.TestReport.BodyComposition.index.t8': '脂肪量',
  'pages.HutManage.TestReport.BodyComposition.index.t9': '骨量',
  'pages.HutManage.TestReport.BodyComposition.index.t10': '岁',
  'pages.HutManage.TestReport.BodyComposition.index.t11': '人体成分检测',
  'pages.HutManage.TestReport.BodyComposition.index.t12': '全身数据',
  'pages.HutManage.TestReport.BodyComposition.index.t13': '人体成分组成',
  'pages.HutManage.TestReport.BodyComposition.index.t14': '体型判断',
  'pages.HutManage.TestReport.BodyComposition.index.t15': '模特型',
  'pages.HutManage.TestReport.BodyComposition.index.t16': '运动型',
  'pages.HutManage.TestReport.BodyComposition.index.t17': '肥胖型',
  'pages.HutManage.TestReport.BodyComposition.index.t18': '苗条型',
  'pages.HutManage.TestReport.BodyComposition.index.t19': '健康型',
  'pages.HutManage.TestReport.BodyComposition.index.t20': '偏胖型',
  'pages.HutManage.TestReport.BodyComposition.index.t21': '消瘦型',
  'pages.HutManage.TestReport.BodyComposition.index.t22': '偏瘦型',
  'pages.HutManage.TestReport.BodyComposition.index.t23': '隐性肥胖型',
  'pages.HutManage.TestReport.BodyStatus.index.t0': '肌肉综合检测',
  'pages.HutManage.TestReport.BodyStatus.index.t1': '肌肉',
  'pages.HutManage.TestReport.BodyStatus.index.t2': '公斤',
  'pages.HutManage.TestReport.BodyStatus.index.t3': '脂肪综合评价',
  'pages.HutManage.TestReport.BodyStatus.index.t4': '脂肪',
  'pages.HutManage.TestReport.BodyStatus.index.t5': '公斤',
  'pages.HutManage.TestReport.BodyStatus.index.t6': '右上肢',
  'pages.HutManage.TestReport.BodyStatus.index.t7': '躯干',
  'pages.HutManage.TestReport.BodyStatus.index.t8': '左上肢',
  'pages.HutManage.TestReport.BodyStatus.index.t9': '右下肢',
  'pages.HutManage.TestReport.BodyStatus.index.t10': '左下肢',
  'pages.HutManage.TestReport.BodyStatus.index.t11': '偏低',
  'pages.HutManage.TestReport.BodyStatus.index.t12': '标准',
  'pages.HutManage.TestReport.BodyStatus.index.t13': '偏高',
  'pages.HutManage.TestReport.BoneDensity.index.t0': '检测建议',
  'pages.HutManage.TestReport.BoneDensity.index.t1': '指标名称',
  'pages.HutManage.TestReport.BoneDensity.index.t2': '检测值',
  'pages.HutManage.TestReport.BoneDensity.index.t3': '参考值',
  'pages.HutManage.TestReport.BoneDensity.index.t4': '未知',
  'pages.HutManage.TestReport.BoneDensity.index.t5': '左脚',
  'pages.HutManage.TestReport.BoneDensity.index.t6': '右脚',
  'pages.HutManage.TestReport.BoneDensity.index.t7': '骨密度检测',
  'pages.HutManage.TestReport.BoneDensity.index.t8': '值',
  'pages.HutManage.TestReport.ECG.index.t0': '分级',
  'pages.HutManage.TestReport.ECG.index.t1': '参数',
  'pages.HutManage.TestReport.ECG.index.t2': '检测值',
  'pages.HutManage.TestReport.ECG.index.t3': '参考值',
  'pages.HutManage.TestReport.ECG.index.t4': '结果',
  'pages.HutManage.TestReport.ECG.index.t5': '正常血压',
  'pages.HutManage.TestReport.ECG.index.t6': '和',
  'pages.HutManage.TestReport.ECG.index.t7': '结论和建议',
  'pages.HutManage.TestReport.ECG.index.t8': '心电检测',
  'pages.HutManage.TestReport.ECG.index.t9': '心电图',
  'pages.HutManage.TestReport.FrontCover.index.t0': '男',
  'pages.HutManage.TestReport.FrontCover.index.t1': '女',
  'pages.HutManage.TestReport.FrontCover.index.t2': '未知',
  'pages.HutManage.TestReport.FrontCover.index.t3': '如家人般 关爱您的健康',
  'pages.HutManage.TestReport.FrontCover.index.t4': '检测用户：',
  'pages.HutManage.TestReport.FrontCover.index.t5': '性别年龄：',
  'pages.HutManage.TestReport.FrontCover.index.t6': '手机号码：',
  'pages.HutManage.TestReport.FrontCover.index.t7': '检测地点：',
  'pages.HutManage.TestReport.FrontCover.index.t8': '检测编号：',
  'pages.HutManage.TestReport.FrontCover.index.t9': '检测时间：',
  'pages.HutManage.TestReport.Glu.index.t0': '检测建议',
  'pages.HutManage.TestReport.Glu.index.t1': '血糖检测',
  'pages.HutManage.TestReport.Glu.index.t2': '值',
  'pages.HutManage.TestReport.PersonalData.index.t0': '性别：',
  'pages.HutManage.TestReport.PersonalData.index.t1': '年龄：',
  'pages.HutManage.TestReport.PersonalData.index.t2': '身高：',
  'pages.HutManage.TestReport.PersonalData.index.t3': '检测时间：',
  'pages.HutManage.TestReport.Urine.index.t0': '参数',
  'pages.HutManage.TestReport.Urine.index.t1': '检测值',
  'pages.HutManage.TestReport.Urine.index.t2': '参考值',
  'pages.HutManage.TestReport.Urine.index.t3': '结果',
  'pages.HutManage.TestReport.Urine.index.t4': '正常血压',
  'pages.HutManage.TestReport.Urine.index.t5': '和',
  'pages.HutManage.TestReport.Urine.index.t6': '尿常规检测',

  'pages.HutManage.TestReport.uricAcid.index.t1': '检测建议',
  'pages.HutManage.TestReport.uricAcid.index.t2': '检测',
  'pages.HutManage.TestReport.uricAcid.index.t3': '值',
  'pages.HutManage.TestReport.uricAcid.index.t4': '测量结果分布',

  'pages.HutManage.TestReport.lungFunction.t0': '肺功能检测',
  'pages.HutManage.TestReport.lungFunction.t1': '肺功能检查是呼吸系统疾病的必要检查之一，主要用于检测呼吸道的通畅程度、肺容量的大小，对于早期检出肺、气道病变，评估疾病的病情严重程度及预后，评定药物或其他治疗方法的疗效，鉴别呼吸困难的原因，诊断病变部位、评估肺功能对手术的耐受力或劳动强度耐受力及对危重病人的监护等方面有重要的临床价值。',
  'pages.HutManage.TestReport.lungFunction.t2': '全部指标',
  'pages.HutManage.TestReport.lungFunction.t3': '指标名称',
  'pages.HutManage.TestReport.lungFunction.t4': '实测',
  'pages.HutManage.TestReport.lungFunction.t5': '预测',
  'pages.HutManage.TestReport.lungFunction.t6': '单位',

  'pages.HutManage.TestReport.PhysicalIndicators.t1': '体质指标',
  'pages.HutManage.TestReport.PhysicalIndicators.t2': '综合评价',
  'pages.HutManage.TestReport.PhysicalIndicators.t3': '重点关注',

  'pages.Inquiry.InquiryHistory.index.t0': '不满意',
  'pages.Inquiry.InquiryHistory.index.t1': '一般',
  'pages.Inquiry.InquiryHistory.index.t2': '满意',
  'pages.Inquiry.InquiryHistory.index.t3': '非常满意',
  'pages.Inquiry.InquiryHistory.index.t4': '在线问诊',
  'pages.Inquiry.InquiryHistory.index.t5': '服务咨询',
  'pages.Inquiry.InquiryHistory.index.t6': '患者信息',
  'pages.Inquiry.InquiryHistory.index.t7': '选择客户',
  'pages.Inquiry.InquiryHistory.index.t8': '请输入客户姓名、手机号码',
  'pages.Inquiry.InquiryHistory.index.t9': '岁',
  'pages.Inquiry.InquiryHistory.index.t10': '手机号码',
  'pages.Inquiry.InquiryHistory.index.t11': '选择科室',
  'pages.Inquiry.InquiryHistory.index.t12': '接诊医生',
  'pages.Inquiry.InquiryHistory.index.t13': '咨询费用',
  'pages.Inquiry.InquiryHistory.index.t14': '问题概述',
  'pages.Inquiry.InquiryHistory.index.t15': '咨询开始时间',
  'pages.Inquiry.InquiryHistory.index.t16': '咨询时间段',
  'pages.Inquiry.InquiryHistory.index.t17': '咨询时长',
  'pages.Inquiry.InquiryHistory.index.t18': '客户评价',
  'pages.Inquiry.InquiryHistory.index.t19': '操作',
  'pages.Inquiry.InquiryHistory.index.t20': '查看对话',
  'pages.Inquiry.InquiryHistory.index.t21': '服务人员',
  'pages.Inquiry.InquiryHistory.components.DrawerInquiryItem.index.t0': '您的浏览器不支持音频播放，建议您使用谷歌浏览器',
  'pages.Inquiry.Schedule.index.t0': '工作日设置',
  'pages.Inquiry.Schedule.index.t1': '休息日设置',
  'pages.Inquiry.Schedule.index.t2': '批量排班',
  'pages.Inquiry.Schedule.index.t3': '咨询设置',
  'pages.Inquiry.Schedule.index.t4': '在线问诊',
  'pages.Inquiry.Schedule.index.t5': '服务咨询',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t0': '保存成功',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t1': '操作失败，请稍后重试',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t2': '请选择排班日期',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t3': '请选择并添加坐诊医生',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t4': '排除',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t5': '不排除',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t6': '请选择是否排除休息日',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t7': '添加',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t8': '请选择并添加',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t9': '服务人员',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t10': '角色',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t11': '部门',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t12': '操作',
  'pages.Inquiry.Schedule.components.BatchScheduleSetting.index.t13': '删除',
  'pages.Inquiry.Schedule.components.InquirySetting.index.t0': '保存成功',
  'pages.Inquiry.Schedule.components.InquirySetting.index.t1': '操作失败，请稍后重试',
  'pages.Inquiry.Schedule.components.InquirySetting.index.t2': '请输入可咨询时长',
  'pages.Inquiry.Schedule.components.InquirySetting.index.t3': '请输入每次咨询费用',
  'pages.Inquiry.Schedule.components.InquirySetting.index.t4': '请输入数字',
  'pages.Inquiry.Schedule.components.OffdaySetting.index.t0': '保存成功',
  'pages.Inquiry.Schedule.components.OffdaySetting.index.t1': '操作失败，请稍后重试',
  'pages.Inquiry.Schedule.components.OffdaySetting.index.t2': '请选择休息日期',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t0': '保存成功',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t1': '操作失败，请稍后重试',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t2': '否',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t3': '是',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t4': '请选择是否设为休息日',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t5': '请选择并添加坐诊医生',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t7': '添加',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t8': '请选择并添加',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t9': '服务人员',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t10': '角色',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t11': '部门',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t12': '操作',
  'pages.Inquiry.Schedule.components.ScheduleSetting.index.t13': '删除',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t0': '保存成功',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t1': '操作失败，请稍后重试',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t2': '星期一',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t3': '星期二',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t4': '星期三',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t5': '星期四',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t6': '星期五',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t7': '星期六',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t8': '星期天',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t9': '请选择每周工作日',
  'pages.Inquiry.Schedule.components.WorkdaySetting.index.t10': '请选择每天工作时间',
  'pages.OperationManage.Information.index.t0': '发表',
  'pages.OperationManage.Information.index.t1': '撤回',
  'pages.OperationManage.Information.index.t2': '成功',
  'pages.OperationManage.Information.index.t3': '添加图文',
  'pages.OperationManage.Information.index.t4': '添加视频',
  'pages.OperationManage.Information.index.t5': '添加音频',
  'pages.OperationManage.Information.index.t6': '标题',
  'pages.OperationManage.Information.index.t7': '类型',
  'pages.OperationManage.Information.index.t8': '所属频道',
  'pages.OperationManage.Information.index.t9': '标签',
  'pages.OperationManage.Information.index.t10': '发表状态',
  'pages.OperationManage.Information.index.t11': '已发表',
  'pages.OperationManage.Information.index.t12': '未发表',
  'pages.OperationManage.Information.index.t13': '权限类型',
  'pages.OperationManage.Information.index.t14': '系统',
  'pages.OperationManage.Information.index.t15': '自定义',
  'pages.OperationManage.Information.index.t16': '编辑',
  'pages.OperationManage.Information.index.t17': '查看',
  'pages.OperationManage.Information.index.t18': '复制',
  'pages.OperationManage.Information.index.t19': '确认要{handle}该健康资讯？',
  'pages.OperationManage.Information.index.t20': '添加新作品',
  'pages.OperationManage.Information.index.t21': '图文',
  'pages.OperationManage.Information.index.t22': '视频',
  'pages.OperationManage.Information.index.t23': '音频',
  'pages.OperationManage.InformationUpdate.index.t0': '资讯',
  'pages.OperationManage.InformationUpdate.index.t1': '保存成功',
  'pages.OperationManage.InformationUpdate.index.t2': '未知错误',
  'pages.OperationManage.InformationUpdate.index.t3': '请输入标题',
  'pages.OperationManage.InformationUpdate.index.t4': '请选择所属频道',
  'pages.OperationManage.InformationUpdate.index.t5': '请选择标签',
  'pages.OperationManage.InformationUpdate.index.t6': '请选择封面图片',
  'pages.OperationManage.InformationUpdate.index.t7': '请上传一张封面图，支持png、jpg图片，建议图片高宽比例为16:9或1:1，高或宽必须大于300px。',
  'pages.OperationManage.InformationUpdate.index.t8': '请选择推荐封面图片',
  'pages.OperationManage.InformationUpdate.index.t9': '请上传一张推荐封面图，支持png、jpg图片，建议图片宽高比例为4:3。',
  'pages.OperationManage.InformationUpdate.index.t10': '资讯详情',
  'pages.OperationManage.InformationUpdate.index.t11': '音频介绍',
  'pages.OperationManage.InformationUpdate.index.t12': '提交',
  'pages.OperationManage.InformationUpdate.index.t13': '关闭',
  'pages.OperationManage.InformationUpdate.index.t14': '新增',
  'pages.OperationManage.InformationUpdate.index.t15': '编辑',
  'pages.OperationManage.InformationUpdate.index.t16': '复制',
  'pages.OperationManage.InformationUpdate.index.t17': '查看',
  'pages.OperationManage.InformationUpdate.AudioUploadTable.index.t0': '至少上传一个音频文件',
  'pages.OperationManage.InformationUpdate.AudioUploadTable.index.t1': '第{num}行标题为空',
  'pages.OperationManage.InformationUpdate.AudioUploadTable.index.t2': '第{num}行音频文件为空',
  'pages.OperationManage.InformationUpdate.AudioUploadTable.index.t3': '排序',
  'pages.OperationManage.InformationUpdate.AudioUploadTable.index.t4': '标题',
  'pages.OperationManage.InformationUpdate.AudioUploadTable.index.t5': '音频文件',
  'pages.OperationManage.InformationUpdate.AudioUploadTable.index.t6': '删除',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t0': '待支付',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t1': '待审核',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t2': '待发货',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t3': '已发货',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t4': '已完成',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t5': '已关闭',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t6': '订单待支付',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t7': '订单待审核',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t8': '订单待发货',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t9': '订单已发货',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t10': '订单已完成',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t11': '订单已关闭',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t12': '实物商品',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t13': '服务套餐',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t14': '微信支付',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t15': '已发货',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t16': '已收货',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t17': '订单信息获取失败',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t18': '请求失败，请稍后重试',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t19': '缺少订单id',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t20': '商品名称',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t21': '所属店铺',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t22': '商品单价',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t23': '购买数量',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t24': '商品金额',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t25': '运费',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t26': '应付合计',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t27': '应付合计',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t28': '状态未知',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t29': '买家留言：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t30': '买家信息：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t31': '收货地址：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t32': '订单信息',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t33': '订单编号：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t34': '订单金额：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t35': '商品属性：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t36': '支付方式：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t37': '下单时间：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t38': '下单时间：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t39': '发货时间：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t40': '发货信息',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t41': '发货方式：快递运输',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t42': '快递单号：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t43': '查看物流',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t44': '快递公司：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t45': '发货状态：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t46': '发货方式：客户自提',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t47': '发货状态：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t48': '商品信息',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t49': '物流动态',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.index.t50': '返回',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.component.DeliveryInfo.index.t0': '运单号：',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.component.DeliveryInfo.index.t1': '物流详情',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.component.DeliveryInfo.DeliveryStatus.t0': '待揽收',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.component.DeliveryInfo.DeliveryStatus.t1': '已发货',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.component.DeliveryInfo.DeliveryStatus.t2': '运输中',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.component.DeliveryInfo.DeliveryStatus.t3': '派件中',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.component.DeliveryInfo.DeliveryStatus.t4': '已签收',
  'pages.OperationManage.MicroMedicalOrders.DetailListOrder.component.DeliveryInfo.DeliveryStatus.t5': '签收失败',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.index.t0': '订单编号',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.index.t1': '下单时间',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.index.t2': '客户姓名',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.index.t3': '服务权益',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.index.t4': '绑定手机号',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.index.t5': '订单状态',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.index.t6': '已绑定',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.index.t7': '操作',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.index.t8': '详情',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.index.t9': '添加客户权益',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t0': '提交失败',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t1': '添加客户权益',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t2': '添加客户权益',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t3': '客户姓名',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t4': '请输入客户姓名',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t5': '请输入客户姓名',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t6': '服务权益',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t7': '请选择服务权益',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t8': '请选择服务权益',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t9': '绑定手机号',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t10': '请输入手机号',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t11': '请输入手机号',
  'pages.OperationManage.MicroMedicalOrders.MicroOrderList.components.AddEquityModal.t12': '请输入正确格式的手机号',
  'pages.OrderAdministrate.CategoryAddEdit.index.t0': '本店暂不支持随时退，过期退。\n若需修改预约时间或取消订单，请主动联系商家。',
  'pages.OrderAdministrate.CategoryAddEdit.index.t1': '创建项目',
  'pages.OrderAdministrate.CategoryAddEdit.index.t2': '编辑项目',
  'pages.OrderAdministrate.CategoryAddEdit.index.t3': '查看项目',
  'pages.OrderAdministrate.CategoryAddEdit.index.t4': '说明：若日常服务时间内，存在不可预约的日期，请添加该时间段。',
  'pages.OrderAdministrate.CategoryAddEdit.index.t5': '提交成功',
  'pages.OrderAdministrate.CategoryAddEdit.index.t6': '此项为必填项',
  'pages.OrderAdministrate.CategoryAddEdit.index.t7': '返回上一步',
  'pages.OrderAdministrate.CategoryAddEdit.index.t8': '项目基本信息设置',
  'pages.OrderAdministrate.CategoryAddEdit.index.t9': '请选择',
  'pages.OrderAdministrate.CategoryAddEdit.index.t10': '所属店铺',
  'pages.OrderAdministrate.CategoryAddEdit.index.t11': '项目类目',
  'pages.OrderAdministrate.CategoryAddEdit.index.t12': '项目名称：',
  'pages.OrderAdministrate.CategoryAddEdit.index.t13': '选择对应服务项目',
  'pages.OrderAdministrate.CategoryAddEdit.index.t14': '服务项目',
  'pages.OrderAdministrate.CategoryAddEdit.index.t15': '开启',
  'pages.OrderAdministrate.CategoryAddEdit.index.t16': '关闭',
  'pages.OrderAdministrate.CategoryAddEdit.index.t17': '请选择图片',
  'pages.OrderAdministrate.CategoryAddEdit.index.t18': '人工审核',
  'pages.OrderAdministrate.CategoryAddEdit.index.t19': '自动审核',
  'pages.OrderAdministrate.CategoryAddEdit.index.t20': '在线支付',
  'pages.OrderAdministrate.CategoryAddEdit.index.t21': '线下支付',
  'pages.OrderAdministrate.CategoryAddEdit.index.t22': '到店服务',
  'pages.OrderAdministrate.CategoryAddEdit.index.t23': '上门服务',
  'pages.OrderAdministrate.CategoryAddEdit.index.t24': '销售价格',
  'pages.OrderAdministrate.CategoryAddEdit.index.t25': '请输入销售价格',
  'pages.OrderAdministrate.CategoryAddEdit.index.t26': '在线支付销售价格必须大于0',
  'pages.OrderAdministrate.CategoryAddEdit.index.t27': '线下支付销售价格不能小于0',
  'pages.OrderAdministrate.CategoryAddEdit.index.t28': '销售价格最多只能输入两位小数',
  'pages.OrderAdministrate.CategoryAddEdit.index.t29': '划线价/原价',
  'pages.OrderAdministrate.CategoryAddEdit.index.t30': '划线价/原价必须大于0',
  'pages.OrderAdministrate.CategoryAddEdit.index.t31': '原价最多只能输入两位小数',
  'pages.OrderAdministrate.CategoryAddEdit.index.t32': '分钟',
  'pages.OrderAdministrate.CategoryAddEdit.index.t33': '添加',
  'pages.OrderAdministrate.CategoryAddEdit.index.t34': '人',
  'pages.OrderAdministrate.CategoryAddEdit.index.t35': '请设置预约排期',
  'pages.OrderAdministrate.CategoryAddEdit.index.t36': '编辑',
  'pages.OrderAdministrate.CategoryAddEdit.index.t37': '说明：用于客户可提前预约的时间范畴。',
  'pages.OrderAdministrate.CategoryAddEdit.index.t38': '天至',
  'pages.OrderAdministrate.CategoryAddEdit.index.t39': '可预约范围设置有误',
  'pages.OrderAdministrate.CategoryAddEdit.index.t40': '天',
  'pages.OrderAdministrate.CategoryAddEdit.index.t41': '新增预约排期',
  'pages.OrderAdministrate.CategoryAddEdit.index.t42': '编辑预约排期',
  'pages.OrderAdministrate.CategoryAddEdit.index.t43': '查看预约排期',
  'pages.OrderAdministrate.CategoryAddEdit.index.t44': '自定义页面',
  'pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.t0': '确认添加',
  'pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.t1': '姓名',
  'pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.t2': '角色',
  'pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.t3': '部门',
  'pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.t4': '操作',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceList.index.t0': '周一',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceList.index.t1': '周二',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceList.index.t2': '周三',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceList.index.t3': '周四',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceList.index.t4': '周五',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceList.index.t5': '周六',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceList.index.t6': '周日',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceList.index.t7': '每周预约日',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceList.index.t8': '每日预约时间点',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.t0': '周一',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.t1': '周二',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.t2': '周三',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.t3': '周四',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.t4': '周五',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.t5': '周六',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.t6': '周日',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.t7': '请选择时间',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.t8': '请选择每周预约日',
  'pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.t9': '每日预约时间点',
  'pages.OrderAdministrate.CategoryAddEdit.components.CustomerInfoTable.index.c1': '联系电话',
  'pages.OrderAdministrate.CategoryAddEdit.components.CustomerInfoTable.index.c2': '性别',
  'pages.OrderAdministrate.CategoryAddEdit.components.CustomerInfoTable.index.c3': '年龄',
  'pages.OrderAdministrate.CategoryAddEdit.components.CustomerInfoTable.index.c4': '身份证',
  'pages.OrderAdministrate.CategoryAddEdit.components.CustomerInfoTable.index.c5': '备注',
  'pages.OrderAdministrate.CategoryAddEdit.components.CustomerInfoTable.index.c6': '信息',
  'pages.OrderAdministrate.CategoryAddEdit.components.CustomerInfoTable.index.c7': '必填项',
  'pages.OrderAdministrate.CategoryAddEdit.components.CustomerInfoTable.index.c8': '阅读并同意',

  'pages.OrderAdministrate.CategoryController.index.t0': '该类目已有项目使用，暂时不能关闭，请先删除项目或修改项目类目之后再关闭',
  'pages.OrderAdministrate.CategoryController.index.t1': '修改成功',
  'pages.OrderAdministrate.CategoryController.index.t2': '项目类目ID',
  'pages.OrderAdministrate.CategoryController.index.t3': '项目类目名称',
  'pages.OrderAdministrate.CategoryController.index.t4': '类目名称',
  'pages.OrderAdministrate.CategoryController.index.t5': '项目数量',
  'pages.OrderAdministrate.CategoryController.index.t6': '适用店铺',
  'pages.OrderAdministrate.CategoryController.index.t7': '不限',
  'pages.OrderAdministrate.CategoryController.index.t8': '类目排序',
  'pages.OrderAdministrate.CategoryController.index.t9': '可用状态',
  'pages.OrderAdministrate.CategoryController.index.t10': '创建时间',
  'pages.OrderAdministrate.CategoryController.index.t11': '最后更新时间',
  'pages.OrderAdministrate.CategoryController.index.t12': '操作',
  'pages.OrderAdministrate.CategoryController.index.t13': '编辑',
  'pages.OrderAdministrate.CategoryController.index.t14': '确定{handle}吗？',
  'pages.OrderAdministrate.CategoryController.index.t15': '关闭',
  'pages.OrderAdministrate.CategoryController.index.t16': '开启',
  'pages.OrderAdministrate.CategoryController.index.t17': '该类目下已有项目，暂时不可关闭，请先删除项目或修改项目类别之后再关闭。',
  'pages.OrderAdministrate.CategoryController.index.t18': '修改成功',
  'pages.OrderAdministrate.CategoryController.index.t19': '新增项目类目',
  'pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.t0': '新增',
  'pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.t1': '编辑',
  'pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.t2': '{handle}类目',
  'pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.t3': '{handle}成功',
  'pages.OrderAdministrate.ItemController.index.t0': '请求失败，请稍后重试',
  'pages.OrderAdministrate.ItemController.index.t1': '项目名称',
  'pages.OrderAdministrate.ItemController.index.t2': '所属店铺',
  'pages.OrderAdministrate.ItemController.index.t3': '项目类目',
  'pages.OrderAdministrate.ItemController.index.t4': '审核类型',
  'pages.OrderAdministrate.ItemController.index.t5': '支付类型',
  'pages.OrderAdministrate.ItemController.index.t6': '服务形式',
  'pages.OrderAdministrate.ItemController.index.t7': '售价',
  'pages.OrderAdministrate.ItemController.index.t8': '排序',
  'pages.OrderAdministrate.ItemController.index.t9': '创建时间',
  'pages.OrderAdministrate.ItemController.index.t10': '上架状态',
  'pages.OrderAdministrate.ItemController.index.t11': '操作',
  'pages.OrderAdministrate.ItemController.index.t12': '分享',
  'pages.OrderAdministrate.ItemController.index.t13': '查看',
  'pages.OrderAdministrate.ItemController.index.t14': '编辑',
  'pages.OrderAdministrate.ItemController.index.t15': '修改成功',
  'pages.OrderAdministrate.ItemController.index.t16': '下架',
  'pages.OrderAdministrate.ItemController.index.t17': '上架',
  'pages.OrderAdministrate.ItemController.index.t18': '删除成功',
  'pages.OrderAdministrate.ItemController.index.t19': '删除',
  'pages.OrderAdministrate.ItemController.index.t20': '创建项目',
  'pages.OrderAdministrate.ItemController.index.t21': '请选择客户端',
  'pages.OrderAdministrate.ItemController.index.t22': '下载图片',
  'pages.OrderAdministrate.ItemController.index.t23': '{name}为您分享了一个宝贝',
  'pages.OrderAdministrate.ItemController.index.t24': '最近更新',
  'pages.OrderAdministrate.ItemController.index.t25': '已下架',
  'pages.OrderAdministrate.ItemController.index.t26': '已上架',
  'pages.OrderAdministrate.ItemController.index.t27': '人工审核',
  'pages.OrderAdministrate.ItemController.index.t28': '自动审核',
  'pages.OrderAdministrate.ItemController.index.t29': '在线支付',
  'pages.OrderAdministrate.ItemController.index.t30': '线下支付',
  'pages.OrderAdministrate.ItemController.index.t31': '到店服务',
  'pages.OrderAdministrate.ItemController.index.t32': '上门服务',
  'pages.OrderAdministrate.ItemController.index.t33': '选择扫码平台',
  'pages.OrderAdministrate.ItemController.index.t34': '请选择扫码平台',
  'pages.OrderAdministrate.ItemController.index.t35': '微信小程序',
  'pages.OrderAdministrate.OrderForm.index.t0': '是',
  'pages.OrderAdministrate.OrderForm.index.t1': '否',
  'pages.OrderAdministrate.OrderForm.index.t2': '预约订单导出',
  'pages.OrderAdministrate.OrderForm.index.t3': '订单编号',
  'pages.OrderAdministrate.OrderForm.index.t4': '预约时间',
  'pages.OrderAdministrate.OrderForm.index.t5': '项目名称',
  'pages.OrderAdministrate.OrderForm.index.t6': '实收金额',
  'pages.OrderAdministrate.OrderForm.index.t7': '预约者',
  'pages.OrderAdministrate.OrderForm.index.t8': '订单状态',
  'pages.OrderAdministrate.OrderForm.index.t9': '支付类型',
  'pages.OrderAdministrate.OrderForm.index.t10': '支付状态',
  'pages.OrderAdministrate.OrderForm.index.t11': '权益抵扣',
  'pages.OrderAdministrate.OrderForm.index.t12': '客户留言',
  'pages.OrderAdministrate.OrderForm.index.t13': '任务编号',
  'pages.OrderAdministrate.OrderForm.index.t14': '服务形式',
  'pages.OrderAdministrate.OrderForm.index.t15': '项目类目',
  'pages.OrderAdministrate.OrderForm.index.t16': '所属店铺',
  'pages.OrderAdministrate.OrderForm.index.t17': '下单时间',
  'pages.OrderAdministrate.OrderForm.index.t18': '操作',
  'pages.OrderAdministrate.OrderForm.index.t19': '详情',
  'pages.OrderAdministrate.OrderForm.index.t20': '确认',
  'pages.OrderAdministrate.OrderForm.index.t21': '修改',
  'pages.OrderAdministrate.OrderForm.index.t22': '取消',
  'pages.OrderAdministrate.OrderForm.index.t23': '新增预约订单',
  'pages.OrderAdministrate.OrderForm.index.t24': '导出数据',
  'pages.OrderAdministrate.OrderForm.index.t25': '待支付',
  'pages.OrderAdministrate.OrderForm.index.t26': '待确认',
  'pages.OrderAdministrate.OrderForm.index.t27': '待处理',
  'pages.OrderAdministrate.OrderForm.index.t28': '已处理',
  'pages.OrderAdministrate.OrderForm.index.t29': '已完成',
  'pages.OrderAdministrate.OrderForm.index.t30': '已关闭',
  'pages.OrderAdministrate.OrderForm.index.t31': '已取消',
  'pages.OrderAdministrate.OrderForm.index.t32': '在线支付',
  'pages.OrderAdministrate.OrderForm.index.t33': '线下支付',
  'pages.OrderAdministrate.OrderForm.index.t34': '未支付',
  'pages.OrderAdministrate.OrderForm.index.t35': '已支付',
  'pages.OrderAdministrate.OrderForm.index.t36': '免费',
  'pages.OrderAdministrate.OrderForm.index.t37': '到店服务',
  'pages.OrderAdministrate.OrderForm.index.t38': '上门服务',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t0': '数据获取失败',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t1': '重新获取服务人员数据',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t2': '重新获取到店时间数据',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t3': '新建成功',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t4': '新建失败，请稍后重试',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t5': '您所选择的时间已过期，请重新选择',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t6': '取消',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t7': '重置',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t8': '提交',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t9': '请选择店铺',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t10': '请选择项目类别',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t11': '请选择服务项目',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t12': '请选择客户',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t13': '请选择到店日期',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t14': '请选择到店时间',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t15': '请选择服务人员',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t16': '请选择地址',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t17': '新增',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t18': '，已使用权益抵扣一次，仍需支付',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t19': '在线支付',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t20': '线下支付',
  'pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.t21': '确认派单',
  'pages.OrderAdministrate.OrderForm.components.OrderCancelModal.index.t0': '取消成功',
  'pages.OrderAdministrate.OrderForm.components.OrderCancelModal.index.t1': '取消后发送短信通知',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t0': '订单确认',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t1': '订单修改',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t2': '确认预约时间',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t3': '请选择预约时间',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t4': '修改预约时间',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t5': '请修改预约时间',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t6': '提交成功',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t7': '修改成功',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t8': '项目名称：',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t9': '订单编号：',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t10': '预约店铺：',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t11': '预约者：',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t12': '服务时长：',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t13': '分钟',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t14': '支付类型：',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t15': '支付状态：',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t16': '权益抵扣：',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t17': '是',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t18': '否',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t19': '客户留言：',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t20': '个人',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t21': '团队',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t22': '请选择执行者类型',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t23': '请选择执行者',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t24': '发送',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t25': '不发送',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t26': '服务者：',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t27': '未支付',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t28': '已支付',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t29': '免费',
  'pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.t30': '将客户绑定给服务团队',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t0': '请求失败，请稍后重试',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t1': '订单待支付',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t2': '订单待确认',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t3': '订单待处理',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t4': '订单待处理中',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t5': '订单已完成',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t6': '订单已关闭',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t7': '订单已取消',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t8': '状态未知',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t9': '分钟',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t10': '是',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t11': '否',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t12': '在线支付',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t13': '线下支付',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t14': '未支付',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t15': '已支付',
  'pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.t16': '免费',
  'pages.PhysicalManage.ReportList.index.t0': '操作成功',
  'pages.PhysicalManage.ReportList.index.t1': '网络或服务器错误',
  'pages.PhysicalManage.ReportList.index.t2': '报告ID',
  'pages.PhysicalManage.ReportList.index.t3': '报告id',
  'pages.PhysicalManage.ReportList.index.t4': '请输入关键词',
  'pages.PhysicalManage.ReportList.index.t5': '报告格式',
  'pages.PhysicalManage.ReportList.index.t6': '数据报告',
  'pages.PhysicalManage.ReportList.index.t7': '图片报告',
  'pages.PhysicalManage.ReportList.index.t8': 'PDF报告',
  'pages.PhysicalManage.ReportList.index.t9': 'Excel报告',
  'pages.PhysicalManage.ReportList.index.t10': '检测状态',
  'pages.PhysicalManage.ReportList.index.t11': '进行中',
  'pages.PhysicalManage.ReportList.index.t12': '已完成',
  'pages.PhysicalManage.ReportList.index.t13': '导入时间',
  'pages.PhysicalManage.ReportList.index.t14': '导入日期段',
  'pages.PhysicalManage.ReportList.index.t15': '体检人',
  'pages.PhysicalManage.ReportList.index.t16': '请输入姓名或手机号',
  'pages.PhysicalManage.ReportList.index.t17': '性别/年龄',
  'pages.PhysicalManage.ReportList.index.t18': '手机号',
  'pages.PhysicalManage.ReportList.index.t19': '证件',
  'pages.PhysicalManage.ReportList.index.t20': '体检中心',
  'pages.PhysicalManage.ReportList.index.t21': '到检日期',
  'pages.PhysicalManage.ReportList.index.t22': '发布状态',
  'pages.PhysicalManage.ReportList.index.t23': '已删除',
  'pages.PhysicalManage.ReportList.index.t24': '已发布',
  'pages.PhysicalManage.ReportList.index.t25': '未发布',
  'pages.PhysicalManage.ReportList.index.t26': '操作人',
  'pages.PhysicalManage.ReportList.index.t27': '操作',
  'pages.PhysicalManage.ReportList.index.t28': '查看报告',
  'pages.PhysicalManage.ReportList.index.t29': '发布',
  'pages.PhysicalManage.ReportList.index.t30': '删除',
  'pages.PhysicalManage.ReportList.index.t31': '导入新报告',
  'pages.PhysicalManage.ReportList.index.t32': '查看该客户的体检报告',
  'pages.PhysicalManage.ReportList.index.t33': '点击',
  'pages.PhysicalManage.ReportList.index.t34': '证件号码',
  'pages.PhysicalManage.ReportUpload.index.t0': '导入成功',
  'pages.PhysicalManage.ReportUpload.index.t1': '网络或服务器错误',
  'pages.PhysicalManage.ReportUpload.index.t2': '解析错误',
  'pages.PhysicalManage.ReportUpload.index.t3': '解析失败',
  'pages.PhysicalManage.ReportUpload.index.t4': '下载报告模板',
  'pages.PhysicalManage.ReportUpload.index.t5': '正在解析报告...',
  'pages.PhysicalManage.ReportUpload.index.t6': '取消',
  'pages.PhysicalManage.ReportUpload.index.t7': '确认导入',
  'pages.PhysicalManage.ReportUpload.index.t8': '确认下载',
  'pages.PhysicalManage.ReportUpload.index.t9': '返回',
  'pages.PhysicalManage.ReportUpload.index.t10': '请选择体检报告模板',
  'pages.PhysicalManage.ReportUpload.index.t11': '通用模板',
  'pages.PhysicalManage.ReportUpload.index.t12': '报告上传成功',
  'pages.PhysicalManage.ReportUpload.index.t13': '查看记录',
  'pages.PhysicalManage.ReportUpload.index.t14': '再次上传',
  'pages.PhysicalManage.ReportUpload.index.t15': '出错了！',
  'pages.PhysicalManage.ReportUpload.index.t16': '报告上传失败，请重新上传，报错原因请参看下图提示。',
  'pages.PhysicalManage.ReportUpload.index.t17': '返回重新上传',
  'pages.PhysicalManage.ReportUpload.index.t18': '报错文件',
  'pages.PhysicalManage.ReportUpload.index.t19': '出错原因',
  'pages.PhysicalManage.ReportUpload.components.DraggerUploader.index.t0': '点击或将文件拖拽到这里上传',
  'pages.PhysicalManage.ReportUpload.components.DraggerUploader.index.t1': '支持文件格式：.pdf .jpg .jpeg .png .bmp',
  'pages.PhysicalManage.ReportUpload.components.DraggerUploader.index.t2': '每次最多可上传一个pdf文件，或最多99张图片',
  'pages.Service.BindRecords.index.t0': '序号',
  'pages.Service.BindRecords.index.t1': '使用者',
  'pages.Service.BindRecords.index.t2': '服务套餐',
  'pages.Service.BindRecords.index.t3': '绑定方式',
  'pages.Service.BindRecords.index.t4': '人工绑定',
  'pages.Service.BindRecords.index.t5': '商城购买',
  'pages.Service.BindRecords.index.t6': '购买者',
  'pages.Service.BindRecords.index.t7': '套餐价格',
  'pages.Service.BindRecords.index.t8': '套餐期限',
  'pages.Service.BindRecords.index.t9': '服务开始时间',
  'pages.Service.BindRecords.index.t10': '服务截止时间',
  'pages.Service.BindRecords.components.BindDetailModal.index.t0': '订单编号',
  'pages.Service.BindRecords.components.BindDetailModal.index.t1': '服务套餐',
  'pages.Service.BindRecords.components.BindDetailModal.index.t2': '使用者',
  'pages.Service.BindRecords.components.BindDetailModal.index.t3': '绑定方式',
  'pages.Service.BindRecords.components.BindDetailModal.index.t4': '人工绑定',
  'pages.Service.BindRecords.components.BindDetailModal.index.t5': '商城购买',
  'pages.Service.BindRecords.components.BindDetailModal.index.t6': '购买者',
  'pages.Service.BindRecords.components.BindDetailModal.index.t7': '绑定者',
  'pages.Service.BindRecords.components.BindDetailModal.index.t8': '审核者',
  'pages.Service.BindRecords.components.BindDetailModal.index.t9': '套餐价格',
  'pages.Service.BindRecords.components.BindDetailModal.index.t10': '套餐期限',
  'pages.Service.BindRecords.components.BindDetailModal.index.t11': '绑定时间',
  'pages.Service.BindRecords.components.BindDetailModal.index.t12': '服务开始时间',
  'pages.Service.BindRecords.components.BindDetailModal.index.t13': '服务截止时间',
  'pages.Service.BindRecords.components.BindDetailModal.index.t14': '关闭',
  'pages.Service.PackageAdd.index.t0': '删除成功',
  'pages.Service.PackageAdd.index.t1': '删除失败，请稍后重试',
  'pages.Service.PackageAdd.index.t2': '返回',
  'pages.Service.PackageAdd.index.t3': '确定',
  'pages.Service.PackageAdd.components.BasisForm.index.t0': '请输入套餐名称',
  'pages.Service.PackageAdd.components.BasisForm.index.t1': '开启',
  'pages.Service.PackageAdd.components.BasisForm.index.t2': '关闭',
  'pages.Service.PackageAdd.components.BasisForm.index.t3': '请选择可用状态',
  'pages.Service.PackageAdd.components.BasisForm.index.t4': '请输入套餐期限',
  'pages.Service.PackageAdd.components.BasisForm.index.t5': '请选择套餐期限单位',
  'pages.Service.PackageAdd.components.BasisForm.index.t6': '天',
  'pages.Service.PackageAdd.components.BasisForm.index.t7': '周',
  'pages.Service.PackageAdd.components.BasisForm.index.t8': '月',
  'pages.Service.PackageAdd.components.BasisForm.index.t9': '年',
  'pages.Service.PackageAdd.components.BasisForm.index.t10': '请输入套餐价格',
  'pages.Service.PackageAdd.components.BasisForm.index.t11': '说明：支持png、jpg图片，建议分辨率为：，最多上传9张',
  'pages.Service.PackageAdd.components.ServiceRights.index.t0': '服务权益',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.t0': '序号',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.t1': '服务项目',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.t2': '服务类型',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.t3': '服务条件',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.t4': '服务次数',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.t5': '操作',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.t6': '确认要删除该服务权益吗？',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.t7': '删除',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.t8': '添加',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.t0': '新增成功',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.t1': '新增失败，请稍后重试',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.t2': '请选择服务类型',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.t3': '请选择服务条件',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.t4': '请选择服务项目',
  'pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.t5': '请输入服务次数',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.t0': '序号',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.t1': '服务项目',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.t2': '服务类型',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.t3': '服务条件',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.t4': '服务频率',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.t5': '操作',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.t6': '确认要删除该服务权益吗？',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.t7': '删除',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.t8': '添加',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.UpdateModal.t0': '新增成功',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.UpdateModal.t1': '新增失败，请稍后重试',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.UpdateModal.t2': '请选择服务类型',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.UpdateModal.t3': '请选择服务条件',
  'pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.UpdateModal.t4': '请选择服务项目',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t0': '序号',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t1': '第{num}次',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t2': '服务项目',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t3': '服务类型',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t4': '服务条件',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t5': '服务时间',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t6': '套餐生效后的第{d1}天开始，处理时长{d2}天',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t7': '在上次干预计划开始后的第{d1}天开始，处理时长{d2}天',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t8': '操作',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t9': '确认要删除该服务权益吗？',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t10': '删除',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t11': '添加',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t12': '排序成功',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.t13': '排序失败，请稍后重试',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t0': '新增成功',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t1': '新增失败，请稍后重试',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t2': '第{n}次',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t3': '请选择服务类型',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t4': '请选择服务条件',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t5': '请选择服务项目',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t6': '请输入处理时间',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t7': '套餐生效后的第',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t8': '在上次干预计划开始后的第',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t9': '天开始',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t10': '请输入处理时长',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t11': '天',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.t12': '插入',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t0': '定期干预',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t1': '成功',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t2': '失败，请稍后重试',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t3': '请选择服务类型',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t4': '请选择服务条件',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t5': '请选择服务项目',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t6': '请输入处理时间',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t7': '在上次干预计划开始后的第',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t8': '天开始',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t9': '请输入处理时长',
  'pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.t10': '天',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.index.t0': '序号',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.index.t1': '服务项目',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.index.t2': '服务类型',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.index.t3': '服务条件',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.index.t4': '操作',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.index.t5': '确认要删除该服务权益吗？',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.index.t6': '删除',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.index.t7': '添加',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.UpdateModal.t0': '新增成功',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.UpdateModal.t1': '新增失败，请稍后重试',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.UpdateModal.t2': '请选择服务类型',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.UpdateModal.t3': '请选择服务条件',
  'pages.Service.PackageAdd.components.ServiceRights.components.Results.UpdateModal.t4': '请选择服务项目',
  'pages.Service.PackageManage.index.t0': '删除成功',
  'pages.Service.PackageManage.index.t1': '启用',
  'pages.Service.PackageManage.index.t2': '关闭',
  'pages.Service.PackageManage.index.t3': '成功',
  'pages.Service.PackageManage.index.t4': '确认要{handle}该服务套餐？',
  'pages.Service.PackageManage.index.t5': '序号',
  'pages.Service.PackageManage.index.t6': '服务套餐',
  'pages.Service.PackageManage.index.t7': '套餐价格',
  'pages.Service.PackageManage.index.t8': '{price}',
  'pages.Service.PackageManage.index.t9': '套餐期限',
  'pages.Service.PackageManage.index.t10': '可用状态',
  'pages.Service.PackageManage.index.t11': '套餐描述',
  'pages.Service.PackageManage.index.t12': '当前使用人数',
  'pages.Service.PackageManage.index.t13': '最近更新时间',
  'pages.Service.PackageManage.index.t14': '基本信息',
  'pages.Service.PackageManage.index.t15': '配置权益',
  'pages.Service.PackageManage.index.t16': '查看',
  'pages.Service.PackageManage.index.t17': '编辑',
  'pages.Service.PackageManage.index.t18': '删除',
  'pages.Service.PackageManage.index.t19': '新增服务套餐',
  'pages.Service.PackageManage.index.t20': '天',
  'pages.Service.PackageManage.index.t21': '周',
  'pages.Service.PackageManage.index.t22': '月',
  'pages.Service.PackageManage.index.t23': '年',
  'pages.Service.PackageManage.index.t24': '年创建服务套餐之前需先设置服务项目，再新增服务套餐，默认状态为关闭',
  'pages.Service.PackageManage.index.t25': '点击',
  'pages.Service.PackageManage.index.t26': '第1步，共3步',
  'pages.Service.PackageManage.index.t27': '新增服务套餐后需绑定服务项目，设置完成开启服务套餐',
  'pages.Service.PackageManage.index.t28': '点击',
  'pages.Service.PackageManage.index.t29': '第2步，共3步',
  'pages.Service.PackageManage.index.t30': '根据业务需要开启/关闭服务套餐',
  'pages.Service.PackageManage.index.t31': '点击',
  'pages.Service.PackageManage.index.t32': '第3步，共3步',
  "pages.Service.PackageManage.index.t33": "开启",
  "pages.Service.PackageManage.index.t34": "关闭",
  "pages.Service.PackageManage.index.t35": "套餐名称",
  "pages.Service.PackageManage.index.t36": "价格",
  "pages.Service.PackageManage.index.t37": "周期",
  'pages.Service.PackageManage.components.UpdateModal.t0': '套餐',
  'pages.Service.PackageManage.components.UpdateModal.t1': '成功',
  'pages.Service.PackageManage.components.UpdateModal.t2': '失败，请稍后重试',
  'pages.Service.PackageManage.components.UpdateModal.t3': '请输入套餐名称',
  'pages.Service.PackageManage.components.UpdateModal.t4': '开启',
  'pages.Service.PackageManage.components.UpdateModal.t5': '关闭',
  'pages.Service.PackageManage.components.UpdateModal.t6': '请选择可用状态',
  'pages.Service.PackageManage.components.UpdateModal.t7': '请输入套餐期限',
  'pages.Service.PackageManage.components.UpdateModal.t8': '请选择套餐期限单位',
  'pages.Service.PackageManage.components.UpdateModal.t9': '天',
  'pages.Service.PackageManage.components.UpdateModal.t10': '周',
  'pages.Service.PackageManage.components.UpdateModal.t11': '月',
  'pages.Service.PackageManage.components.UpdateModal.t12': '年',
  'pages.Service.PackageManage.components.UpdateModal.t13': '请输入套餐价格',
  'pages.Service.PackageManage.components.UpdateModal.t14': '说明：支持png、jpg图片，图片高度比例建议为1：1，宽高尺寸需大于300px，最多上传9张',
  'pages.Service.PackageManage.components.UpdateModal.t15': '套餐名称',
  'pages.Service.PackageManage.components.UpdateModal.t16': '周期',
  'pages.Service.PackageManage.components.UpdateModal.t17': '请输入周期',
  'pages.Service.PackageManage.components.UpdateModal.t18': '请选择周期单位',
  'pages.Service.PackageManage.components.UpdateModal.t19': '价格',
  'pages.Service.PackageManage.components.UpdateModal.t20': '请输入价格',
  "pages.Service.PackageManage.components.PackageConfigDrawer.t0": "权益服务",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t1": "智能服务",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t2": "干预计划",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t3": "服务项目",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t4": "次",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t5": "确认要删除吗？",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t6": "取消选择",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t7": "批量删除",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t8": "确认要全部删除吗？",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t9": "根据提前设置的服务计划模型，在套餐生效时，自动按模型设定的时间周期来批量创建服务跟进计划，请在以下列表中选择所需的模型；也可以添加新模型后再选择。",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t10": "添加模型",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t11": "健康干预模型",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t12": "选择",
  "pages.Service.PackageManage.components.PackageConfigDrawer.t13": "已选择",
  "pages.Service.PackageManage.components.AddPackageEquityModal.t0": "添加套餐权益",
  "pages.Service.PackageManage.components.AddPackageEquityModal.t1": "服务类型",
  "pages.Service.PackageManage.components.AddPackageEquityModal.t2": "服务项目（可多选）",
  "pages.Service.PackageManage.components.AddPackageEquityModal.t3": "服务项目",
  "pages.Service.PackageManage.components.AddPackageEquityModal.t4": "服务次数",
  "pages.Service.PackageManage.components.AddPackageEquityModal.t5": "移除",
  "pages.Service.PackageManage.components.AddInterventionModelModal.t0": "添加健康干预模型",
  "pages.Service.PackageManage.components.AddInterventionModelModal.t1": "健康干预模型（可多选）",
  'pages.Service.ServiceRecordCreate.index.t0': '添加服务记录',
  'pages.Service.ServiceRecordCreate.index.t1': '保存',
  'pages.Service.ServiceRecordCreate.index.t2': '取消',
  'pages.Service.ServiceRecordCreate.index.t3': '保存成功',
  'pages.Service.ServiceRecordCreate.index.t4': '保存失败，请稍后重试',
  'pages.Service.ServiceRecordCreate.index.t5': '网络错误，请稍后重试',
  'pages.Service.ServiceRecordCreate.index.t6': '服务对象',
  'pages.Service.ServiceRecordCreate.index.t7': '请添加服务对象',
  'pages.Service.ServiceRecordCreate.index.t8': '选择用户',
  'pages.Service.ServiceRecordCreate.index.t9': '新增客户',
  'pages.Service.ServiceRecordCreate.index.t10': '已选择{n}人',
  'pages.Service.ServiceRecordCreate.index.t11': '服务内容',
  'pages.Service.ServiceRecordCreate.index.t12': '请选择服务内容',
  'pages.Service.ServiceRecordCreate.index.t13': '请选择',
  'pages.Service.ServiceRecordCreate.index.t14': '服务形式',
  'pages.Service.ServiceRecordCreate.index.t15': '请选择服务形式',
  'pages.Service.ServiceRecordCreate.index.t16': '服务结果',
  'pages.Service.ServiceRecordCreate.index.t17': '请选择服务结果',
  'pages.Service.ServiceRecordCreate.index.t18': '实际执行者',
  'pages.Service.ServiceRecordCreate.index.t19': '请选择实际执行者',
  'pages.Service.ServiceRecordCreate.index.t20': '完成时间',
  'pages.Service.ServiceRecordCreate.index.t21': '请选择完成时间',
  'pages.Service.ServiceRecordCreate.index.t22': '服务备注',
  'pages.Service.ServiceRecordCreate.index.t23': '描述本次服务情况，便于下次服务或其他服务人员提供服务时参考，不对客户显示',
  'pages.Service.ServiceRecordCreate.index.t24': '服务评价',
  'pages.Service.ServiceRecordCreate.index.t25': '请选择服务评价',
  'pages.Service.ServiceRecordCreate.index.t26': '推送通知消息',
  'pages.Service.ServiceRecordCreate.index.t27': '短信',
  'pages.Service.ServiceRecordCreate.index.t28': '微信',
  'pages.Service.ServiceRecordCreate.index.t29': '服务总结',
  'pages.Service.ServiceRecordCreate.index.t30': '用于向客户介绍本次服务整体情况，客户可见',
  'pages.Service.ServiceRecordCreate.index.t31': '测量数据：',
  'pages.Service.ServiceRecordCreate.index.t32': '选择的时间应小于当前时间',
  'pages.Service.Services.components.ServiceItem.index.t0': '删除成功',
  'pages.Service.Services.components.ServiceItem.index.t1': '服务条件',
  'pages.Service.Services.components.ServiceItem.index.t2': '服务条件：指相关服务项目的触发条件，根据触发条件（人工发起、按照一定规则等）和服务形式（人工服务、系统服务），分为3类：',
  'pages.Service.Services.components.ServiceItem.index.t3': '结果触发：基于用户的检测结果和检测习惯而提供的相关人工服务，判断规则由系统预设。',
  'pages.Service.Services.components.ServiceItem.index.t4': '系统自发：根据系统预设的规则，系统自主提供的服务，无需人工介入。',
  'pages.Service.Services.components.ServiceItem.index.t5': '人工触发：由服务人员或客户发起的人工服务。',
  'pages.Service.Services.components.ServiceItem.index.t6': '关闭',
  'pages.Service.Services.components.ServiceItem.index.t7': '开启',
  'pages.Service.Services.components.ServiceItem.index.t8': '{handle}成功',
  'pages.Service.Services.components.ServiceItem.index.t9': '{handle}失败，请稍后重试',
  'pages.Service.Services.components.ServiceItem.index.t10': '序号',
  'pages.Service.Services.components.ServiceItem.index.t11': '服务项目',
  'pages.Service.Services.components.ServiceItem.index.t12': '服务类型',
  'pages.Service.Services.components.ServiceItem.index.t13': '服务频率',
  'pages.Service.Services.components.ServiceItem.index.t14': '可用状态',
  'pages.Service.Services.components.ServiceItem.index.t15': '启用',
  'pages.Service.Services.components.ServiceItem.index.t16': '服务描述',
  'pages.Service.Services.components.ServiceItem.index.t17': '编辑',
  'pages.Service.Services.components.ServiceItem.index.t18': '确认要{handle}该服务项目？',
  'pages.Service.Services.components.ServiceItem.index.t19': '删除',
  'pages.Service.Services.components.ServiceItem.index.t20': '新增服务项目',
  'pages.Service.Services.components.ServiceItem.index.t21': '每天',
  'pages.Service.Services.components.ServiceItem.index.t22': '每周',
  'pages.Service.Services.components.ServiceItem.index.t23': '每月',
  'pages.Service.Services.components.ServiceItem.index.t24': '号',
  'pages.Service.Services.components.ServiceItem.index.t25': '周一',
  'pages.Service.Services.components.ServiceItem.index.t26': '周二',
  'pages.Service.Services.components.ServiceItem.index.t27': '周三',
  'pages.Service.Services.components.ServiceItem.index.t28': '周四',
  'pages.Service.Services.components.ServiceItem.index.t29': '周五',
  'pages.Service.Services.components.ServiceItem.index.t30': '周六',
  'pages.Service.Services.components.ServiceItem.index.t31': '周日',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t0': '周一',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t1': '周二',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t2': '周三',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t3': '周四',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t4': '周五',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t5': '周六',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t6': '周日',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t7': '{num}号',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t8': '{handle}服务项目',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t9': '{handle}成功',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t10': '{handle}失败，请稍后重试',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t11': '说明：只能创建服务条件为“主动服务”、“预约服务”的服务项目。',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t12': '请选择服务类型',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t13': '请选择服务条件',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t14': '结果触发',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t15': '系统自发',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t16': '人工触发',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t17': '请输入服务项目名称',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t18': '请选择服务频率',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t19': '每',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t20': '天',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t21': '周',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t22': '月',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t23': '开启',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t24': '关闭',
  'pages.Service.Services.components.ServiceItem.components.UpdateModal.index.t25': '请选择可用状态',
  'pages.Service.Services.components.ServiceType.index.t0': '删除成功',
  'pages.Service.Services.components.ServiceType.index.t1': '序号',
  'pages.Service.Services.components.ServiceType.index.t2': '服务类型名称',
  'pages.Service.Services.components.ServiceType.index.t3': '服务项目数量',
  'pages.Service.Services.components.ServiceType.index.t4': '服务类型描述',
  'pages.Service.Services.components.ServiceType.index.t5': '编辑',
  'pages.Service.Services.components.ServiceType.index.t6': '删除',
  'pages.Service.Services.components.ServiceType.index.t7': '新增服务类型',
  'pages.Service.Services.components.ServiceType.components.UpdateModal.index.t0': '服务类型',
  'pages.Service.Services.components.ServiceType.components.UpdateModal.index.t1': '成功',
  'pages.Service.Services.components.ServiceType.components.UpdateModal.index.t2': '失败，请稍后重试',
  'pages.Service.Services.components.ServiceType.components.UpdateModal.index.t3': '请输入服务类型名称',
  'pages.Service.Services.components.ServiceType.components.UpdateModal.index.t4': '新增',
  'pages.Service.Services.components.ServiceType.components.UpdateModal.index.t5': '编辑',
  "pages.Service.Services.components.ServiceItemTable.index.t0": "服务类型",
  "pages.Service.Services.components.ServiceItemTable.index.t1": "请输入关键词",
  "pages.Service.Services.components.ServiceItemTable.index.t2": "加载更多",
  "pages.Service.Services.components.ServiceItemTable.index.t3": "已全部加载",
  "pages.Service.Services.components.ServiceItemTable.index.t4": "新增项目",
  "pages.Service.Services.components.ServiceItemTable.index.t5": "服务项目",
  "pages.Service.Services.components.ServiceItemTable.index.t6": "请输入服务项目",
  "pages.Service.Services.components.ServiceItemTable.index.t7": "服务形式",
  "pages.Service.Services.components.ServiceItemTable.index.t8": "处理形式",
  "pages.Service.Services.components.ServiceItemTable.index.t9": "可用状态",
  "pages.Service.Services.components.ServiceItemTable.index.t10": "启用",
  "pages.Service.Services.components.ServiceItemTable.index.t11": "关闭",
  "pages.Service.Services.components.ServiceItemTable.index.t12": "服务描述",
  "pages.Service.Services.components.ServiceItemTable.index.t13": "确认要启用该服务项目吗？",
  "pages.Service.Services.components.ServiceItemTable.index.t14": "确认要关闭该服务项目吗？",
  "pages.Service.Services.components.ServiceTypeModal.index.t0": "服务类型",
  "pages.Service.Services.components.ServiceTypeModal.index.t1": "分类名称",
  "pages.Service.Services.components.ServiceTypeModal.index.t2": "排序",
  "pages.Service.Services.components.ServiceTypeModal.index.t3": "数字越大越靠前",
  "pages.Service.Services.components.ServiceTypeModal.index.t4": "描述",
  "pages.Service.Services.components.ServiceItemEditDrawer.index.t0": "服务项目",
  "pages.Service.Services.components.ServiceItemEditDrawer.index.t1": "项目名称",
  "pages.Service.Services.components.ServiceItemEditDrawer.index.t2": "服务描述",
  "pages.Service.Services.components.ServiceItemEditDrawer.index.t3": "服务处理形式",
  "pages.Service.Services.components.ServiceItemEditDrawer.index.t4": "请选择服务处理形式",
  "pages.Service.Services.components.ServiceItemEditDrawer.index.t5": "可用状态",
  "pages.Service.Services.components.ServiceItemEditDrawer.index.t6": "请选择可用状态",
  "pages.Service.Services.components.ServiceItemEditDrawer.index.t7": "关闭",
  "pages.Service.Services.components.ServiceItemEditDrawer.index.t8": "启用",
  "pages.Service.Services.components.ServiceItemEditDrawer.index.t9": "服务类型",
  'pages.Service.ServiceUpdate.index.t0': '周一',
  'pages.Service.ServiceUpdate.index.t1': '周二',
  'pages.Service.ServiceUpdate.index.t2': '周三',
  'pages.Service.ServiceUpdate.index.t3': '周四',
  'pages.Service.ServiceUpdate.index.t4': '周五',
  'pages.Service.ServiceUpdate.index.t5': '周六',
  'pages.Service.ServiceUpdate.index.t6': '周日',
  'pages.Service.ServiceUpdate.index.t7': '{num}号',
  'pages.Service.ServiceUpdate.index.t8': '编辑',
  'pages.Service.ServiceUpdate.index.t9': '新增',
  'pages.Service.ServiceUpdate.index.t10': '{handle}服务项目',
  'pages.Service.ServiceUpdate.index.t11': '请先完成自定义服务记录单的填写',
  'pages.Service.ServiceUpdate.index.t12': '自定义服务记录单保存失败',
  'pages.Service.ServiceUpdate.index.t13': '{handle}成功`',
  'pages.Service.ServiceUpdate.index.t14': '{handle}失败，请稍后重试`',
  'pages.Service.ServiceUpdate.index.t15': '请选择服务类型',
  'pages.Service.ServiceUpdate.index.t16': '请选择服务条件',
  'pages.Service.ServiceUpdate.index.t17': '结果触发',
  'pages.Service.ServiceUpdate.index.t18': '系统自发',
  'pages.Service.ServiceUpdate.index.t19': '人工触发',
  'pages.Service.ServiceUpdate.index.t20': '请输入服务项目名称',
  'pages.Service.ServiceUpdate.index.t21': '请选择服务频率',
  'pages.Service.ServiceUpdate.index.t22': '每',
  'pages.Service.ServiceUpdate.index.t23': '天',
  'pages.Service.ServiceUpdate.index.t24': '周',
  'pages.Service.ServiceUpdate.index.t25': '月',
  'pages.Service.ServiceUpdate.index.t26': '开启',
  'pages.Service.ServiceUpdate.index.t27': '关闭',
  'pages.Service.ServiceUpdate.index.t28': '请选择可用状态',
  'pages.Service.ServiceUpdate.index.t29': '服务处理形式',
  'pages.Service.ServiceUpdate.index.t30': '人工回访',
  'pages.Service.ServiceUpdate.index.t31': '电话通知',
  'pages.Service.ServiceUpdate.index.t32': '短信通知',
  'pages.Service.ServiceUpdate.index.t33': '请选择服务处理形式',
  'pages.Service.ServiceUpdate.index.t34': '电话话术选择',
  'pages.Service.ServiceUpdate.index.t35': '请添加电话话术',
  'pages.Service.ServiceUpdate.index.t36': '短信模板选择',
  'pages.Service.ServiceUpdate.index.t37': '请添加短信模板',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t0': '客户本人',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t1': '客户亲友',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t2': '健管师',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t3': '推送对象',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t4': '话术标题',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t5': '话术内容',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t6': '操作',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t7': '编辑',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t8': '移除',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t9': '选择话术模板',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t10': '话术标题',
  'pages.Service.ServiceUpdate.components.PhoneTable.index.t11': '话术内容',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t0': '输入框',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t1': '富文本',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t2': '数值',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t3': '搜索框',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t4': '日期',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t5': '日期段',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t6': '时间',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t7': '日期时间',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t8': '单选框',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t9': '多选框',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t10': '文本框',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t11': '图片',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t12': '排序',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t13': '字段名称',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t14': '字段类型',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t15': '字段配置',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t16': '是否支持二次编辑',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t17': '是',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t18': '否',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t19': '操作',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t20': '删除',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t21': '自定义服务记录单：',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t22': '添加',
  'pages.Service.ServiceUpdate.components.ServiceRecordTable.index.t23': '如需要在处理任务的过程中填写固定格式的表单信息，可配置表单信息，健管师填写完成后支持打印出来给客户签字。',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t0': '客户本人',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t1': '客户亲友',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t2': '健管师',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t3': '推送对象',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t4': '短信模板',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t5': '短信内容',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t6': '操作',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t7': '编辑',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t8': '移除',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t9': '选择短信模板',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t10': '话术标题',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t11': '短信内容',
  'pages.Service.ServiceUpdate.components.SmSTable.index.t12': '短信内容',
  'pages.ShoppingManage.CategoryManger.index.t0': '类目ID',
  'pages.ShoppingManage.CategoryManger.index.t1': '类目名称',
  'pages.ShoppingManage.CategoryManger.index.t2': '请输入关键字',
  'pages.ShoppingManage.CategoryManger.index.t3': '商品属性',
  'pages.ShoppingManage.CategoryManger.index.t4': '实物商品',
  'pages.ShoppingManage.CategoryManger.index.t5': '服务套餐',
  'pages.ShoppingManage.CategoryManger.index.t6': '适用店铺',
  'pages.ShoppingManage.CategoryManger.index.t7': '不限',
  'pages.ShoppingManage.CategoryManger.index.t8': '类目排序',
  'pages.ShoppingManage.CategoryManger.index.t9': '商品数量',
  'pages.ShoppingManage.CategoryManger.index.t10': '创建时间',
  'pages.ShoppingManage.CategoryManger.index.t11': '可用状态',
  'pages.ShoppingManage.CategoryManger.index.t12': '关闭',
  'pages.ShoppingManage.CategoryManger.index.t13': '操作',
  'pages.ShoppingManage.CategoryManger.index.t14': '编辑',
  'pages.ShoppingManage.CategoryManger.index.t15': '浏览商品',
  'pages.ShoppingManage.CategoryManger.index.t16': '该类目已有商品使用，暂时不能关闭，请先删除商品或修改商品类目之后再关闭。',
  'pages.ShoppingManage.CategoryManger.index.t17': '开启',
  'pages.ShoppingManage.CategoryManger.index.t18': '新增类目',
  'pages.ShoppingManage.CategoryManger.components.CategoryModal.index.t0': '新增类目',
  'pages.ShoppingManage.CategoryManger.components.CategoryModal.index.t1': '添加成功',
  'pages.ShoppingManage.CategoryManger.components.CategoryModal.index.t2': '请求失败，请稍后重试',
  'pages.ShoppingManage.CategoryManger.components.CategoryModal.index.t3': '未知错误',
  'pages.ShoppingManage.CategoryManger.components.CategoryModal.index.t4': '实物商品',
  'pages.ShoppingManage.CategoryManger.components.CategoryModal.index.t5': '服务套餐',
  'pages.ShoppingManage.CategoryManger.components.CategoryModal.index.t6': '请选择套餐类型',
  'pages.ShoppingManage.CategoryManger.components.CategoryModal.index.t7': '类目名称：',
  'pages.ShoppingManage.CategoryManger.components.CategoryModal.index.t8': '请输入类型名称',
  'pages.ShoppingManage.CategoryManger.components.CategoryModal.index.t9': '类目排序：',
  'pages.ShoppingManage.CommodityManger.index.t0': '请求失败，请稍后重试',
  'pages.ShoppingManage.CommodityManger.index.t1': '商品编号',
  'pages.ShoppingManage.CommodityManger.index.t2': '商品标题',
  'pages.ShoppingManage.CommodityManger.index.t3': '请输入商品标题',
  'pages.ShoppingManage.CommodityManger.index.t4': '所属店铺',
  'pages.ShoppingManage.CommodityManger.index.t5': '商品属性',
  'pages.ShoppingManage.CommodityManger.index.t6': '实物商品',
  'pages.ShoppingManage.CommodityManger.index.t7': '服务套餐',
  'pages.ShoppingManage.CommodityManger.index.t8': '商品类目',
  'pages.ShoppingManage.CommodityManger.index.t9': '服务套餐',
  'pages.ShoppingManage.CommodityManger.index.t10': '上架状态',
  'pages.ShoppingManage.CommodityManger.index.t11': '出售中',
  'pages.ShoppingManage.CommodityManger.index.t12': '已下架',
  'pages.ShoppingManage.CommodityManger.index.t13': '自定义上架时间',
  'pages.ShoppingManage.CommodityManger.index.t14': '商品价格',
  'pages.ShoppingManage.CommodityManger.index.t15': '',
  'pages.ShoppingManage.CommodityManger.index.t16': '显示排序',
  'pages.ShoppingManage.CommodityManger.index.t17': '销量',
  'pages.ShoppingManage.CommodityManger.index.t18': '最新更新时间',
  'pages.ShoppingManage.CommodityManger.index.t19': '操作说明',
  'pages.ShoppingManage.CommodityManger.index.t20': '分享',
  'pages.ShoppingManage.CommodityManger.index.t21': '查看',
  'pages.ShoppingManage.CommodityManger.index.t22': '编辑',
  'pages.ShoppingManage.CommodityManger.index.t23': '是否确认',
  'pages.ShoppingManage.CommodityManger.index.t24': '下架',
  'pages.ShoppingManage.CommodityManger.index.t25': '上架',
  'pages.ShoppingManage.CommodityManger.index.t26': '修改时出错',
  'pages.ShoppingManage.CommodityManger.index.t27': '删除时出错',
  'pages.ShoppingManage.CommodityManger.index.t28': '删除',
  'pages.ShoppingManage.CommodityManger.index.t29': '创建商品',
  'pages.ShoppingManage.CommodityManger.index.t30': '请选择客户端',
  'pages.ShoppingManage.CommodityManger.index.t31': '下载图片',
  'pages.ShoppingManage.CommodityManger.index.t32': '为您分享了一个宝贝',
  'pages.ShoppingManage.CommodityManger.index.t33': '选择扫码平台',
  'pages.ShoppingManage.CommodityManger.index.t34': '请选择扫码平台',
  'pages.ShoppingManage.CommodityManger.index.t35': '微信小程序',
  'pages.ShoppingManage.CommodityOptions.index.t0': '请上传图片',
  'pages.ShoppingManage.CommodityOptions.index.t1': '提交成功',
  'pages.ShoppingManage.CommodityOptions.index.t2': '未知错误',
  'pages.ShoppingManage.CommodityOptions.index.t3': '此项为必填项',
  'pages.ShoppingManage.CommodityOptions.index.t4': '返回',
  'pages.ShoppingManage.CommodityOptions.index.t5': '取消',
  'pages.ShoppingManage.CommodityOptions.index.t6': '返回上一步',
  'pages.ShoppingManage.CommodityOptions.index.t7': '请选择',
  'pages.ShoppingManage.CommodityOptions.index.t8': '实物商品',
  'pages.ShoppingManage.CommodityOptions.index.t9': '服务套餐',
  'pages.ShoppingManage.CommodityOptions.index.t10': '-选择商品类目-',
  'pages.ShoppingManage.CommodityOptions.index.t11': '上架',
  'pages.ShoppingManage.CommodityOptions.index.t12': '不上架',
  'pages.ShoppingManage.CommodityOptions.index.t13': '自定义上架时间',
  'pages.ShoppingManage.CommodityOptions.index.t14': '只能输入非负整数',
  'pages.ShoppingManage.CommodityOptions.index.t15': '请输入商品价格',
  'pages.ShoppingManage.CommodityOptions.index.t16': '商品价格必须大于0',
  'pages.ShoppingManage.CommodityOptions.index.t17': '商品价格最多只能输入两位小数',
  'pages.ShoppingManage.CommodityOptions.index.t18': '划线价(选填)',
  'pages.ShoppingManage.CommodityOptions.index.t19': '划线价必须大于0',
  'pages.ShoppingManage.CommodityOptions.index.t20': '划线价最多只能输入两位小数',
  'pages.ShoppingManage.CommodityOptions.index.t21': '包邮',
  'pages.ShoppingManage.CommodityOptions.index.t22': '不包邮',
  'pages.ShoppingManage.CommodityOptions.index.t23': '请选择',
  'pages.ShoppingManage.CommodityOptions.index.t24': '设置其他方案',
  'pages.ShoppingManage.CommodityOptions.index.t25': '只能输入正整数',
  'pages.ShoppingManage.CommodityOptions.index.t26': '件内',
  'pages.ShoppingManage.CommodityOptions.index.t27': '最多只能输入两位小数',
  'pages.ShoppingManage.CommodityOptions.index.t28': '；每增加',
  'pages.ShoppingManage.CommodityOptions.index.t29': '只能输入正整数',
  'pages.ShoppingManage.CommodityOptions.index.t30': '件，运费增加',
  'pages.ShoppingManage.CommodityOptions.index.t31': '。',
  'pages.ShoppingManage.CommodityOptions.index.t32': '商品价格',
  'pages.ShoppingManage.CommodityOptions.index.t33': '划线价必须大于商品价格',
  'pages.ShoppingManage.CommodityOptions.index.t34': '极速问诊',
  'pages.ShoppingManage.DetailListOrder.index.t0': '待支付',
  'pages.ShoppingManage.DetailListOrder.index.t1': '待审核',
  'pages.ShoppingManage.DetailListOrder.index.t2': '待发货',
  'pages.ShoppingManage.DetailListOrder.index.t3': '已发货',
  'pages.ShoppingManage.DetailListOrder.index.t4': '已完成',
  'pages.ShoppingManage.DetailListOrder.index.t5': '已关闭',
  'pages.ShoppingManage.DetailListOrder.index.t6': '订单待支付',
  'pages.ShoppingManage.DetailListOrder.index.t7': '订单待审核',
  'pages.ShoppingManage.DetailListOrder.index.t8': '订单待发货',
  'pages.ShoppingManage.DetailListOrder.index.t9': '订单已发货',
  'pages.ShoppingManage.DetailListOrder.index.t10': '订单已完成',
  'pages.ShoppingManage.DetailListOrder.index.t11': '订单已关闭',
  'pages.ShoppingManage.DetailListOrder.index.t12': '实物商品',
  'pages.ShoppingManage.DetailListOrder.index.t13': '服务套餐',
  'pages.ShoppingManage.DetailListOrder.index.t14': '微信支付',
  'pages.ShoppingManage.DetailListOrder.index.t15': '已发货',
  'pages.ShoppingManage.DetailListOrder.index.t16': '已收货',
  'pages.ShoppingManage.DetailListOrder.index.t17': '订单信息获取失败',
  'pages.ShoppingManage.DetailListOrder.index.t18': '请求失败，请稍后重试',
  'pages.ShoppingManage.DetailListOrder.index.t19': '缺少订单id',
  'pages.ShoppingManage.DetailListOrder.index.t20': '商品名称',
  'pages.ShoppingManage.DetailListOrder.index.t21': '所属店铺',
  'pages.ShoppingManage.DetailListOrder.index.t22': '商品单价',
  'pages.ShoppingManage.DetailListOrder.index.t23': '购买数量',
  'pages.ShoppingManage.DetailListOrder.index.t24': '商品金额',
  'pages.ShoppingManage.DetailListOrder.index.t25': '运费',
  'pages.ShoppingManage.DetailListOrder.index.t26': '应付合计',
  'pages.ShoppingManage.DetailListOrder.index.t27': '状态未知',
  'pages.ShoppingManage.DetailListOrder.index.t28': '买家留言：',
  'pages.ShoppingManage.DetailListOrder.index.t29': '买家信息：',
  'pages.ShoppingManage.DetailListOrder.index.t30': '订单编号：',
  'pages.ShoppingManage.DetailListOrder.index.t31': '订单金额：',
  'pages.ShoppingManage.DetailListOrder.index.t32': '商品属性：',
  'pages.ShoppingManage.DetailListOrder.index.t33': '支付方式：',
  'pages.ShoppingManage.DetailListOrder.index.t34': '下单时间：',
  'pages.ShoppingManage.DetailListOrder.index.t35': '发货时间：',
  'pages.ShoppingManage.DetailListOrder.index.t36': '付款时间：',
  'pages.ShoppingManage.DetailListOrder.index.t37': '完成时间：',
  'pages.ShoppingManage.DetailListOrder.index.t38': '发货方式：快递运输',
  'pages.ShoppingManage.DetailListOrder.index.t39': '查看物流',
  'pages.ShoppingManage.DetailListOrder.index.t40': '快递公司：',
  'pages.ShoppingManage.DetailListOrder.index.t41': '发货状态：',
  'pages.ShoppingManage.DetailListOrder.index.t42': '发货方式：客户自提',
  'pages.ShoppingManage.DetailListOrder.index.t43': '修改成功',
  'pages.ShoppingManage.DetailListOrder.index.t44': '修改失败',
  'pages.ShoppingManage.DetailListOrder.index.t45': '请求失败，请稍后重试',
  'pages.ShoppingManage.DetailListOrder.index.t46': '修改',
  'pages.ShoppingManage.DetailListOrder.index.t47': '提交',
  'pages.ShoppingManage.DetailListOrder.index.t48': '取消',
  'pages.ShoppingManage.DetailListOrder.index.t49': '返回',
  'pages.ShoppingManage.DetailListOrder.components.DeliveryInfo.index.t0': '运单号：',
  'pages.ShoppingManage.DetailListOrder.components.DeliveryInfo.index.t1': '物流详情',
  'pages.ShoppingManage.DetailListOrder.components.DeliveryInfo.DeliveryStatus.t0': '待揽收',
  'pages.ShoppingManage.DetailListOrder.components.DeliveryInfo.DeliveryStatus.t1': '已发货',
  'pages.ShoppingManage.DetailListOrder.components.DeliveryInfo.DeliveryStatus.t2': '运输中',
  'pages.ShoppingManage.DetailListOrder.components.DeliveryInfo.DeliveryStatus.t3': '派件中',
  'pages.ShoppingManage.DetailListOrder.components.DeliveryInfo.DeliveryStatus.t4': '已签收',
  'pages.ShoppingManage.DetailListOrder.components.DeliveryInfo.DeliveryStatus.t5': '签收失败',
  'pages.ShoppingManage.Inquiry.index.t1': '下单时间',
  'pages.ShoppingManage.Inquiry.index.t2': '客户姓名',
  'pages.ShoppingManage.Inquiry.index.t3': '服务权益',
  'pages.ShoppingManage.Inquiry.index.t4': '登录手机号',
  'pages.ShoppingManage.Inquiry.index.t5': '共 {total} 条记录',
  'pages.ShoppingManage.Inquiry.index.t6': '订单编号',
  'pages.ShoppingManage.Inquiry.index.t7': '订单状态',
  'pages.ShoppingManage.Inquiry.index.t8': '操作',
  'pages.ShoppingManage.Inquiry.index.t9': '详情',
  'pages.ShoppingManage.Inquiry.index.t10': '已绑定',
  'pages.ShoppingManage.Inquiry.index.t11': '未绑定',
  'pages.ShoppingManage.Inquiry.components.AddEquityModal.t1': '提交失败',
  'pages.ShoppingManage.Inquiry.components.AddEquityModal.t2': '添加客户权益',
  'pages.ShoppingManage.Inquiry.components.AddEquityModal.t3': '客户姓名',
  'pages.ShoppingManage.Inquiry.components.AddEquityModal.t4': '请输入客户姓名',
  'pages.ShoppingManage.Inquiry.components.AddEquityModal.t5': '服务权益',
  'pages.ShoppingManage.Inquiry.components.AddEquityModal.t6': '请选择服务权益',
  'pages.ShoppingManage.Inquiry.components.AddEquityModal.t7': '登录手机号',
  'pages.ShoppingManage.Inquiry.components.AddEquityModal.t8': '请输入手机号',
  'pages.ShoppingManage.Inquiry.components.AddEquityModal.t9': '请输入正确格式的手机号',
  'pages.ShoppingManage.MallCreate.index.t0': '请输入正确格式的客服电话',
  'pages.ShoppingManage.MallCreate.index.t1': '返回',
  'pages.ShoppingManage.MallCreate.index.t2': '取消',
  'pages.ShoppingManage.MallCreate.index.t3': '下一步',
  'pages.ShoppingManage.MallCreate.index.t4': '上一步',
  'pages.ShoppingManage.MallCreate.index.t5': '请输入店铺名称',
  'pages.ShoppingManage.MallCreate.index.t6': '请选择',
  'pages.ShoppingManage.MallCreate.index.t7': '请输入，格式参考',
  'pages.ShoppingManage.MallCreate.index.t8': '请输入营业时间',
  'pages.ShoppingManage.MallCreate.index.t9': '请输入门店地址',
  'pages.ShoppingManage.MallCreate.index.t10': '地图选点',
  'pages.ShoppingManage.MallCreate.index.t11': '门店地址选取成功',
  'pages.ShoppingManage.MallCreate.index.t12': '重置',
  'pages.ShoppingManage.MallCreate.index.t13': '门店地址不能为空，请输入',
  'pages.ShoppingManage.MallCreate.index.t14': '请选择店铺Logo',
  'pages.ShoppingManage.MallCreate.index.t15': '请选择店铺图片',
  'pages.ShoppingManage.MallCreate.index.t16': '开放',
  'pages.ShoppingManage.MallCreate.index.t17': '禁用（默认）',
  'pages.ShoppingManage.MallCreate.index.t18': '请选择商城可用状态',
  'pages.ShoppingManage.MallCreate.index.t19': '只能输入非负整数',
  'pages.ShoppingManage.MallCreate.index.t20': '小时',
  'pages.ShoppingManage.MallCreate.index.t21': '分钟',
  'pages.ShoppingManage.MallCreate.index.t22': '请选择预约可用状态',
  'pages.ShoppingManage.MallCreate.index.t23': '通过任务处理（默认）',
  'pages.ShoppingManage.MallCreate.index.t24': '提前',
  'pages.ShoppingManage.MallCreate.index.t25': '天',
  'pages.ShoppingManage.MallCreate.index.t26': '请选取门店地址',
  'pages.ShoppingManage.MallCreate.index.t27': '积分兑换',
  'pages.ShoppingManage.MallCreate.index.t28': '开启',
  'pages.ShoppingManage.MallCreate.index.t29': '关闭',
  'pages.ShoppingManage.MallFreight.index.t0': '模板名称',
  'pages.ShoppingManage.MallFreight.index.t1': '起计（件）',
  'pages.ShoppingManage.MallFreight.index.t2': '运费',
  'pages.ShoppingManage.MallFreight.index.t3': '续件（件）',
  'pages.ShoppingManage.MallFreight.index.t4': '续费',
  'pages.ShoppingManage.MallFreight.index.t5': '操作',
  'pages.ShoppingManage.MallFreight.index.t6': '编辑',
  'pages.ShoppingManage.MallFreight.index.t7': '删除成功',
  'pages.ShoppingManage.MallFreight.index.t8': '删除',
  'pages.ShoppingManage.MallFreight.index.t9': '新增模板',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t0': '编辑',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t1': '新增',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t2': '模板',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t3': '添加成功',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t4': '模板名称：',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t5': '请输入模板名称',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t6': '起计件数：',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t7': '请输入起计件数',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t8': '起计件数只能为正整数，请重新输入',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t9': '运费：',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t10': '请输入运费',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t11': '运费只能输入最多两位小数，请重新输入',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t12': '续件件数：',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t13': '请输入续件件数',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t14': '续计件数只能为正整数，请重新输入',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t15': '续费：',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t16': '请输入续费',
  'pages.ShoppingManage.MallFreight.components.FreightModal.index.t17': '续费只能输入最多两位小数，请重新输入',
  'pages.ShoppingManage.MallShop.index.t0': '序号',
  'pages.ShoppingManage.MallShop.index.t1': '店铺名称',
  'pages.ShoppingManage.MallShop.index.t2': '所属部门',
  'pages.ShoppingManage.MallShop.index.t3': '商城可用状态',
  'pages.ShoppingManage.MallShop.index.t4': '关闭',
  'pages.ShoppingManage.MallShop.index.t5': '关闭',
  'pages.ShoppingManage.MallShop.index.t6': '正常',
  'pages.ShoppingManage.MallShop.index.t7': '预约可用状态',
  'pages.ShoppingManage.MallShop.index.t8': '关闭',
  'pages.ShoppingManage.MallShop.index.t9': '关闭',
  'pages.ShoppingManage.MallShop.index.t10': '正常',
  'pages.ShoppingManage.MallShop.index.t11': '商品数量',
  'pages.ShoppingManage.MallShop.index.t12': '销量',
  'pages.ShoppingManage.MallShop.index.t13': '预约项目数量',
  'pages.ShoppingManage.MallShop.index.t14': '创建时间',
  'pages.ShoppingManage.MallShop.index.t15': '最近更新时间',
  'pages.ShoppingManage.MallShop.index.t16': '操作说明',
  'pages.ShoppingManage.MallShop.index.t17': '查看',
  'pages.ShoppingManage.MallShop.index.t18': '编辑',
  'pages.ShoppingManage.MallShop.index.t19': '运费模板',
  'pages.ShoppingManage.MallShop.index.t20': '当前店铺：',
  'pages.ShoppingManage.MallShop.index.t21': '，还有商品，暂时无法删除',
  'pages.ShoppingManage.MallShop.index.t22': '删除',
  'pages.ShoppingManage.MallShop.index.t23': '删除成功',
  'pages.ShoppingManage.MallShop.index.t24': '删除',
  'pages.ShoppingManage.MallShop.index.t25': '添加店铺',
  'pages.ShoppingManage.OrderManage.index.t0': '订单编号',
  'pages.ShoppingManage.OrderManage.index.t1': '下单时间',
  'pages.ShoppingManage.OrderManage.index.t2': '商品属性',
  'pages.ShoppingManage.OrderManage.index.t3': '实物商品',
  'pages.ShoppingManage.OrderManage.index.t4': '服务套餐',
  'pages.ShoppingManage.OrderManage.index.t5': '商品名称',
  'pages.ShoppingManage.OrderManage.index.t6': '购买数量',
  'pages.ShoppingManage.OrderManage.index.t7': '应付金额',
  'pages.ShoppingManage.OrderManage.index.t8': '买家',
  'pages.ShoppingManage.OrderManage.index.t9': '买家备注',
  'pages.ShoppingManage.OrderManage.index.t10': '订单状态',
  'pages.ShoppingManage.OrderManage.index.t11': '商品类目',
  'pages.ShoppingManage.OrderManage.index.t12': '所属店铺',
  'pages.ShoppingManage.OrderManage.index.t13': '订单信息',
  'pages.ShoppingManage.OrderManage.index.t14': '订单编号、客户姓名或档案编号',
  'pages.ShoppingManage.OrderManage.index.t15': '操作',
  'pages.ShoppingManage.OrderManage.index.t16': '详情',
  'pages.ShoppingManage.OrderManage.index.t17': '发货',
  'pages.ShoppingManage.OrderManage.index.t18': '审核',
  'pages.ShoppingManage.OrderManage.index.t19': '订单取消成功',
  'pages.ShoppingManage.OrderManage.index.t20': '订单取消时失败',
  'pages.ShoppingManage.OrderManage.index.t21': '请求失败，请稍后重试',
  'pages.ShoppingManage.OrderManage.index.t22': '取消',
  'pages.ShoppingManage.OrderManage.index.t23': '发货成功',
  'pages.ShoppingManage.OrderManage.index.t24': '发货失败',
  'pages.ShoppingManage.OrderManage.index.t25': '请求失败，请稍后重试',
  'pages.ShoppingManage.OrderManage.index.t26': '订单编号：',
  'pages.ShoppingManage.OrderManage.index.t27': '快递发货',
  'pages.ShoppingManage.OrderManage.index.t28': '客户自提',
  'pages.ShoppingManage.OrderManage.index.t29': '请选择快递公司',
  'pages.ShoppingManage.OrderManage.index.t30': '快递单号',
  'pages.ShoppingManage.OrderManage.index.t31': '请输入快递单号',
  'pages.ShoppingManage.OrderManage.index.t32': '审核成功',
  'pages.ShoppingManage.OrderManage.index.t33': '审核失败',
  'pages.ShoppingManage.OrderManage.index.t34': '请求失败，请稍后重试',
  'pages.ShoppingManage.OrderManage.index.t35': '订单编号：',
  'pages.ShoppingManage.OrderManage.index.t36': '客户：',
  'pages.ShoppingManage.OrderManage.index.t37': '请选择服务套餐',
  'pages.ShoppingManage.OrderManage.index.t38': '请选择服务团队',
  'pages.ShoppingManage.OrderManage.index.t39': '待支付',
  'pages.ShoppingManage.OrderManage.index.t40': '待发货',
  'pages.ShoppingManage.OrderManage.index.t41': '待审核',
  'pages.ShoppingManage.OrderManage.index.t42': '已发货',
  'pages.ShoppingManage.OrderManage.index.t43': '已完成',
  'pages.ShoppingManage.OrderManage.index.t44': '已关闭',
  'pages.ShoppingManage.OrderManage.index.t45': '已取消',
  'pages.ShoppingManage.OrderManage.index.t46': '实物商品',
  'pages.ShoppingManage.OrderManage.index.t47': '服务套餐',
  'pages.ShoppingManage.OrderManage.index.t48': '视频问诊',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t0': '下单时间：',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t1': '订单编号：',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t2': '所属店铺：',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t3': '发货',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t4': '订单取消成功',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t5': '取消时出错',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t6': '取消',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t7': '审核',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t8': '订单详情',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t9': '商品类型：',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t10': '实物商品',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t11': '服务套餐',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t12': '共',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t13': '件商品，合计：S$',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t14': '客户：',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t15': '收货地址：',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t16': '买家备注：',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t17': '提交成功',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t18': '订单编号：',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t19': '快递发货',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t20': '客户自提',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t21': '请选择快递公司',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t22': '快递单号',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t23': '请输入快递单号',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t24': '提交成功',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t25': '订单编号：',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t26': '客户：',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t27': '请选择服务套餐',
  'pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.t28': '请选择服务团队',
  'pages.ShoppingManage.PromoteOrder.index.t0': '下单时间',
  'pages.ShoppingManage.PromoteOrder.index.t1': '订单来源',
  'pages.ShoppingManage.PromoteOrder.index.t2': '健康商城',
  'pages.ShoppingManage.PromoteOrder.index.t3': '服务预约',
  'pages.ShoppingManage.PromoteOrder.index.t4': '推客类型',
  'pages.ShoppingManage.PromoteOrder.index.t5': '管理员',
  'pages.ShoppingManage.PromoteOrder.index.t6': '客户',
  'pages.ShoppingManage.PromoteOrder.index.t7': '推客',
  'pages.ShoppingManage.PromoteOrder.index.t8': '管理员',
  'pages.ShoppingManage.PromoteOrder.index.t9': '客户',
  'pages.ShoppingManage.PromoteOrder.index.t10': '订单名称',
  'pages.ShoppingManage.PromoteOrder.index.t11': '订单金额',
  'pages.ShoppingManage.PromoteOrder.index.t12': '订单状态',
  'pages.ShoppingManage.PromoteOrder.index.t13': '买家信息',
  'pages.ShoppingManage.PromoteOrder.index.t14': '所属店铺',
  'pages.ShoppingManage.PromoteOrder.index.t15': '操作',
  'pages.ShoppingManage.PromoteOrder.index.t16': '详情',
  'pages.ShoppingManage.PromoteOrder.index.t17': '详情',
  'pages.ShoppingManage.PromoteOrder.index.t18': '健康商城',
  'pages.ShoppingManage.PromoteOrder.index.t19': '服务预约',
  'pages.ShoppingManage.PromoteOrder.index.t20': '管理员',
  'pages.ShoppingManage.PromoteOrder.index.t21': '客户',
  'pages.ShoppingManage.PromoteOrder.index.t22': '待支付',
  'pages.ShoppingManage.PromoteOrder.index.t23': '待发货',
  'pages.ShoppingManage.PromoteOrder.index.t24': '待审核',
  'pages.ShoppingManage.PromoteOrder.index.t25': '已发货',
  'pages.ShoppingManage.PromoteOrder.index.t26': '已完成',
  'pages.ShoppingManage.PromoteOrder.index.t27': '已关闭',
  'pages.ShoppingManage.PromoteOrder.index.t28': '已取消',
  'pages.ShoppingManage.Promotion.index.t0': '全部',
  'pages.ShoppingManage.Promotion.index.t1': '进行中',
  'pages.ShoppingManage.Promotion.index.t2': '未开始',
  'pages.ShoppingManage.Promotion.index.t3': '已结束',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t0': '活动名称',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t1': '商品名称',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t2': '活动时间',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t3': '永久有效',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t4': '客户限购',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t5': '限购',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t6': '次',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t7': '仅首次购买',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t8': '活动商品数量',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t9': '状态',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t10': '未开始',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t11': '已结束',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t12': '进行中',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t13': '操作',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t14': '查看',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t15': '编辑',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t16': '确认删除该活动？',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t17': '已删除',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t18': '请求出错，请稍后重试',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t19': '删除',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t20': '共{total}条记录',
  'pages.ShoppingManage.Promotion.PromotionStatus.index.t21': '添加活动',
  'pages.ShoppingManage.PromotionAdd.index.t0': '活动',
  'pages.ShoppingManage.PromotionAdd.index.t1': '保存成功',
  'pages.ShoppingManage.PromotionAdd.index.t2': '未知错误',
  'pages.ShoppingManage.PromotionAdd.index.t3': '活动名称',
  'pages.ShoppingManage.PromotionAdd.index.t4': '活动时间',
  'pages.ShoppingManage.PromotionAdd.index.t5': '永久有效',
  'pages.ShoppingManage.PromotionAdd.index.t6': '限时活动',
  'pages.ShoppingManage.PromotionAdd.index.t7': '客户限购',
  'pages.ShoppingManage.PromotionAdd.index.t8': '仅首次购买',
  'pages.ShoppingManage.PromotionAdd.index.t9': '限购',
  'pages.ShoppingManage.PromotionAdd.index.t10': '次',
  'pages.ShoppingManage.PromotionAdd.index.t11': '活动商品',
  'pages.ShoppingManage.PromotionAdd.index.t12': '添加商品',
  'pages.ShoppingManage.PromotionAdd.index.t13': '提交',
  'pages.ShoppingManage.PromotionAdd.index.t14': '关闭',
  'pages.ShoppingManage.PromotionAdd.index.t15': '未选中商品',
  'pages.ShoppingManage.PromotionAdd.index.t16': '选项存在已添加商品，请重新选择',
  'pages.ShoppingManage.PromotionAdd.index.t17': '添加',
  'pages.ShoppingManage.PromotionAdd.index.t18': '编辑',
  'pages.ShoppingManage.PromotionAdd.index.t19': '查看',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t0': '商品名称',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t1': '请输入商品关键字',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t2': '商品类型',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t3': '请选择商品类型',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t4': '商城商品',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t5': '预约项目',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t6': '商城商品',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t7': '预约项目',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t8': '店铺',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t9': '请选择店铺',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t10': '销售价格',
  'pages.ShoppingManage.PromotionAdd.GoodsAddModal.index.t11': '添加商品',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t0': '至少添加一个商品',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t1': '优惠价格不能为空',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t2': '商品名称',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t3': '商品类型',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t4': '商城商品',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t5': '预约项目',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t6': '销售价格',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t7': '优惠方式',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t8': '打折',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t9': '打折价',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t10': '优惠价格',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t11': '打',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t12': '折',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t13': '售',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t14': '',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t15': '操作',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t16': '确认要删除该行吗？',
  'pages.ShoppingManage.PromotionAdd.GoodsUpdateTable.index.t17': '删除',
  'pages.Statistics.Customer.components.CustomerConsumptionCard.index.t0': '服务客户消费情况分析',
  'pages.Statistics.Customer.components.CustomerConsumptionCard.index.t1': '{n}以下',
  'pages.Statistics.Customer.components.CustomerConsumptionCard.index.t2': '{n}',
  'pages.Statistics.Customer.components.CustomerConsumptionCard.index.t3': '{n}以上',
  'pages.Statistics.Customer.components.CustomerConsumptionCard.index.t4': '客户数量',
  'pages.Statistics.Customer.components.CustomerPackageCard.index.t0': '服务客户套餐分析',
  'pages.Statistics.Customer.components.CustomerPackageCard.index.t1': '客户数量',
  'pages.Statistics.Customer.components.CustomerTagLevelCard.index.t0': '客户数量',
  'pages.Statistics.Customer.components.CustomerTagLevelCard.index.t1': '客户数量',
  'pages.Statistics.Customer.components.StatisticsCardBox.index.t0': '服务客户总数',
  'pages.Statistics.Customer.components.StatisticsCardBox.index.t1': '人',
  'pages.Statistics.Customer.components.StatisticsCardBox.index.t2': '昨日变化',
  'pages.Statistics.Customer.components.StatisticsCardBox.index.t3': '新增服务客户数（近30天）',
  'pages.Statistics.Customer.components.StatisticsCardBox.index.t4': '近30天环比',
  'pages.Statistics.Customer.components.StatisticsCardBox.index.t5': '服务到期客户数（近30天）',
  'pages.Statistics.Customer.components.StatisticsCardBox.index.t6': '昨日到期',
  'pages.Statistics.Customer.components.StatisticsCardBox.index.t7': '潜在客户数',
  'pages.Statistics.Service.index.t0': '统计数据截止',
  'pages.Statistics.Service.components.SatisfactionCard.index.t0': '团队名称',
  'pages.Statistics.Service.components.SatisfactionCard.index.t1': '评价次数',
  'pages.Statistics.Service.components.SatisfactionCard.index.t2': '非常满意',
  'pages.Statistics.Service.components.SatisfactionCard.index.t3': '满意',
  'pages.Statistics.Service.components.SatisfactionCard.index.t4': '一般',
  'pages.Statistics.Service.components.SatisfactionCard.index.t5': '不满意',
  'pages.Statistics.Service.components.SatisfactionCard.index.t6': '非常不满意',
  'pages.Statistics.Service.components.SatisfactionCard.index.t7': '整体满意度',
  'pages.Statistics.Service.components.SatisfactionCard.index.t8': '团队名称',
  'pages.Statistics.Service.components.SatisfactionCard.index.t9': '服务人员',
  'pages.Statistics.Service.components.SatisfactionCard.index.t10': '整体满意度',
  'pages.Statistics.Service.components.SatisfactionCard.index.t11': '仪容仪表',
  'pages.Statistics.Service.components.SatisfactionCard.index.t12': '服务态度',
  'pages.Statistics.Service.components.SatisfactionCard.index.t13': '专业技能',
  'pages.Statistics.Service.components.SatisfactionCard.index.t14': '平均客户得分',
  'pages.Statistics.Service.components.SatisfactionCard.index.t15': '非常满意人数',
  'pages.Statistics.Service.components.SatisfactionCard.index.t16': '非常不满意人数',
  'pages.Statistics.Service.components.SatisfactionCard.index.t17': '近一周',
  'pages.Statistics.Service.components.SatisfactionCard.index.t18': '近30天',
  'pages.Statistics.Service.components.SatisfactionCard.index.t19': '全部',
  'pages.Statistics.Service.components.SatisfactionCard.index.t20': '满意度汇总.xlsx',
  'pages.Statistics.Service.components.SatisfactionCard.index.t21': '操作',
  'pages.Statistics.Service.components.SatisfactionCard.index.t22': '详情',
  'pages.Statistics.Service.components.ServiceItemCard.index.t0': '服务项目',
  'pages.Statistics.Service.components.ServiceItemCard.index.t1': '服务分类',
  'pages.Statistics.Service.components.ServiceItemCard.index.t2': '待服务次数',
  'pages.Statistics.Service.components.ServiceItemCard.index.t3': '已服务次数',
  'pages.Statistics.Service.components.ServiceItemCard.index.t4': '平均服务时长',
  'pages.Statistics.Service.components.ServiceItemCard.index.t5': '整体满意度',
  'pages.Statistics.Service.components.ServiceItemCard.index.t6': '服务内容分析',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t0': '团队',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t1': '个人',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t2': '项',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t3': '服务方式分析',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t4': '服务结果分析',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t5': '电话服务',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t6': '微信服务',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t7': '短信服务',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t8': '线下服务',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t9': '电话接通',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t10': '电话挂断',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t11': '无人接听',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t12': '电话关机',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t13': '号码有误',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t14': '电话停机',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t15': '发送短信',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t16': '联系不上',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t17': '联系成功',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t18': '未回消息',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t19': '拒绝服务',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t20': '联系不上',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t21': '已服务',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t22': '未服务',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t23': '电话服务',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t24': '短信',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t25': '微信服务',
  'pages.Statistics.Service.components.ServiceTypeCard.index.t26': '线下服务',
  'pages.Statistics.Service.components.StatisticsCardList.index.t0': '服务客户总数',
  'pages.Statistics.Service.components.StatisticsCardList.index.t1': '昨日变化',
  'pages.Statistics.Service.components.StatisticsCardList.index.t2': '周环比',
  'pages.Statistics.Service.components.StatisticsCardList.index.t3': '月环比',
  'pages.Statistics.Service.components.StatisticsCardList.index.t4': '健管团队数 | 健管人员数',
  'pages.Statistics.Service.components.StatisticsCardList.index.t5': '昨日变化：',
  'pages.Statistics.Service.components.StatisticsCardList.index.t6': '健管团队',
  'pages.Statistics.Service.components.StatisticsCardList.index.t7': '健管人员',
  'pages.Statistics.Service.components.StatisticsCardList.index.t8': '每团队平均服务人数',
  'pages.Statistics.Service.components.StatisticsCardList.index.t9': '昨日变化',
  'pages.Statistics.Service.components.StatisticsCardList.index.t10': '未完成任务数',
  'pages.Statistics.Service.components.StatisticsCardList.index.t11': '昨日变化',
  "pages.Statistics.Service.components.StatisticsCardList.index.t12": "所有绑定服务团队的客户",
  "pages.Statistics.Service.components.StatisticsCardList.index.t13": "健管团队：所有开启状态的服务团队；健管人员数：所有有效服务团队的健管人数",
  "pages.Statistics.Service.components.StatisticsCardList.index.t14": "服务客户总数/健管团队数",
  "pages.Statistics.Service.components.StatisticsCardList.index.t15": "服务计划完成时间≤ 数据统计时间，仍未处理完成的所有服务数",
  'pages.Statistics.Service.components.WorkEfficientCard.index.t0': '团队名称',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t1': '计划任务数',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t2': '计划任务待处理',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t3': '计划任务处理中',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t4': '计划任务已完成',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t5': '逾期',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t6': '实际已完成',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t7': '已关闭',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t8': '及时处理率',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t9': '团队名称',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t10': '服务人员',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t11': '计划任务数',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t12': '计划任务待处理',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t13': '计划任务处理中',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t14': '计划任务已完成',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t15': '逾期占比',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t16': '实际已完成',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t17': '计划任务数及时处理率',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t18': '按时完成',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t19': '延迟完成',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t20': '未完成',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t21': '任务数量',
  'pages.Statistics.Service.components.WorkEfficientCard.index.t22': '及时处理率',
  'pages.Statistics.Service.components.ServiceStatistics.index.t0': '全部',
  'pages.Statistics.Service.components.ServiceStatistics.index.t1': '服务人数',
  'pages.Statistics.Service.components.ServiceStatistics.index.t2': '服务人次',
  'pages.Statistics.Service.components.ServiceStatistics.index.t3': '重复服务人数',
  'pages.Statistics.Service.components.ServiceStatistics.index.t4': '金额',
  'pages.Statistics.Service.components.ServiceStatistics.index.t5': '佣金',
  'pages.Statistics.Service.components.ServiceStatistics.index.t6': '平均服务得分',
  'pages.Statistics.Service.components.ServiceStatistics.index.t7': '近一周',
  'pages.Statistics.Service.components.ServiceStatistics.index.t8': '近30天',
  'pages.Statistics.Service.components.ServiceStatistics.index.t9': '团队名称',
  'pages.Statistics.Service.components.ServiceStatistics.index.t10': '健管人员总数',
  'pages.Statistics.Service.components.ServiceStatistics.index.t11': '服务客户人次',
  'pages.Statistics.Service.components.ServiceStatistics.index.t12': '金额/S$',
  'pages.Statistics.Service.components.ServiceStatistics.index.t13': '佣金/S$',
  'pages.Statistics.Service.components.ServiceStatistics.index.t14': '服务团队',
  'pages.Statistics.Service.components.ServiceStatistics.index.t15': '服务人员',
  'pages.Statistics.Service.components.ServiceStatistics.index.t16': '客户姓名',
  'pages.Statistics.Service.components.ServiceStatistics.index.t17': '服务内容',
  'pages.Statistics.Service.components.ServiceStatistics.index.t18': '服务时间',
  'pages.Statistics.Service.components.ServiceStatistics.index.t19': '服务时长/h',
  'pages.Statistics.Service.components.ServiceStatistics.index.t20': '服务得分',
  'pages.Statistics.Service.components.ServiceStatistics.index.t21': '客户得分',
  'pages.Statistics.Service.components.ServiceStatistics.index.t22': '服务统计汇总.xlsx',
  'pages.System.EmployerManage.index.t0': '正在新增',
  'pages.System.EmployerManage.index.t1': '新增用户成功',
  'pages.System.EmployerManage.index.t2': '新增用户失败请重试！',
  'pages.System.EmployerManage.index.t3': '正在更新',
  'pages.System.EmployerManage.index.t4': '更新用户信息成功',
  'pages.System.EmployerManage.index.t5': '更新用户信息失败请重试！',
  'pages.System.EmployerManage.index.t6': '禁用',
  'pages.System.EmployerManage.index.t7': '启用',
  'pages.System.EmployerManage.index.t8': '正在',
  'pages.System.EmployerManage.index.t9': '成功',
  'pages.System.EmployerManage.index.t10': '失败请重试！',
  'pages.System.EmployerManage.index.t11': '正在设置',
  'pages.System.EmployerManage.index.t12': '设置成功',
  'pages.System.EmployerManage.index.t13': '设置失败请重试！',
  'pages.System.EmployerManage.index.t14': '员工ID',
  'pages.System.EmployerManage.index.t15': '姓名',
  'pages.System.EmployerManage.index.t16': '登录名',
  'pages.System.EmployerManage.index.t17': '角色',
  'pages.System.EmployerManage.index.t18': '部门',
  'pages.System.EmployerManage.index.t19': '状态',
  'pages.System.EmployerManage.index.t20': '登录次数',
  'pages.System.EmployerManage.index.t21': '最近登录时间',
  'pages.System.EmployerManage.index.t22': '操作',
  'pages.System.EmployerManage.index.t23': '请输入新密码！',
  'pages.System.EmployerManage.index.t24': '用户',
  'pages.System.EmployerManage.index.t25': '禁用本人账号，将会终止本次访问并退出系统登录。',
  'pages.System.EmployerManage.index.t26': '请确认是否禁用{name}的账号？',
  'pages.System.EmployerManage.index.t27': '请确认是否启用{name}的账号？',
  'pages.System.EmployerManage.index.t28': '注：密码长度需大于6位（含），支持输入字母、数字和字符，且必须包含2项以上。设置成功后需重新登录。',
  'pages.System.EmployerManage.index.t29': '点击创建部门员工账号，且绑定该员工角色',
  'pages.System.EmployerManage.index.t30': '点击',
  'pages.System.EmployerManage.index.t31': '第1步，共2步',
  'pages.System.EmployerManage.index.t32': '设置该员工所属部门',
  'pages.System.EmployerManage.index.t33': '点击',
  'pages.System.EmployerManage.index.t34': '第2步，共2步',
  'pages.System.EmployerManage.index.t35': '请设置正确的密码格式！',
  'pages.System.EmployerManage.AuthSetting.index.t0': '操作成功',
  'pages.System.EmployerManage.AuthSetting.index.t1': '操作失败，请稍后重试',
  'pages.System.EmployerManage.InfoForm.index.t0': '上传中',
  'pages.System.EmployerManage.InfoForm.index.t1': '上传成功',
  'pages.System.EmployerManage.InfoForm.index.t2': '上传失败，请稍后重试',
  'pages.System.EmployerManage.InfoForm.index.t3': '请输入姓名！',
  'pages.System.EmployerManage.InfoForm.index.t4': '请输入登录名！',
  'pages.System.EmployerManage.InfoForm.index.t5': '请选择所属部门！',
  'pages.System.EmployerManage.InfoForm.index.t6': '请输入正确的手机/固话号码！',
  'pages.System.EmployerManage.InfoForm.index.t7': '男',
  'pages.System.EmployerManage.InfoForm.index.t8': '女',
  'pages.System.EmployerManage.InfoForm.index.t9': '更换头像',
  'pages.System.EmployerManage.InfoForm.index.t10': '上传照片',
  'pages.System.EmployerManage.InfoForm.index.t11': '请选择角色！',
  'pages.System.EmployerManage.InfoForm.index.t12': '非服务人员',
  'pages.System.EmployerManage.InfoForm.index.t13': '服务人员',
  'pages.System.EmployerManage.InfoForm.index.t14': '请选择岗位性质！',
  'pages.System.EmployerManage.InfoForm.index.t15': '请选择服务团队！',
  'pages.System.EmployerManage.InfoForm.index.t16': '启用',
  'pages.System.EmployerManage.InfoForm.index.t17': '禁用',
  'pages.System.EmployerManage.InfoForm.index.t18': '取消',
  'pages.System.EmployerManage.InfoForm.index.t19': '编辑',
  'pages.System.EmployerManage.InfoForm.index.t20': '新增',
  'pages.System.EmployerManage.InfoForm.index.t21': '员工账号',
  'pages.System.OrgManage.index.t0': '删除成功',
  'pages.System.OrgManage.index.t1': '部门名称',
  'pages.System.OrgManage.index.t2': '备注',
  'pages.System.OrgManage.index.t3': '显示排序',
  'pages.System.OrgManage.index.t4': '创建时间',
  'pages.System.OrgManage.index.t5': '最近更新时间',
  'pages.System.OrgManage.index.t6': '操作',
  'pages.System.OrgManage.index.t7': '新增子级',
  'pages.System.OrgManage.index.t8': '编辑',
  'pages.System.OrgManage.index.t9': 'logo设置',
  'pages.System.OrgManage.index.t10': '删除',
  "pages.System.OrgManage.index.t11": "根据本部门的业务需要设置子级部门",
  "pages.System.OrgManage.index.t12": "点击",
  'pages.System.OrgManage.components.UpdateLogo.t0': '上传',
  'pages.System.OrgManage.components.UpdateLogo.t1': '上传中',
  'pages.System.OrgManage.components.UpdateLogo.t2': '上传成功',
  'pages.System.OrgManage.components.UpdateLogo.t3': '上传失败，请稍后重试',
  'pages.System.OrgManage.components.UpdateLogo.t4': '操作成功',
  'pages.System.OrgManage.components.UpdateLogo.t5': '操作失败，请稍后重试',
  'pages.System.OrgManage.components.UpdateLogo.t6': '预览效果',
  'pages.System.OrgManage.components.UpdateOrg.t0': '新增部门',
  'pages.System.OrgManage.components.UpdateOrg.t1': '编辑部门',
  'pages.System.OrgManage.components.UpdateOrg.t2': '新增子级部门',
  'pages.System.OrgManage.components.UpdateOrg.t3': '操作成功',
  'pages.System.OrgManage.components.UpdateOrg.t4': '操作失败，请稍后重试',
  'pages.System.OrgManage.components.UpdateOrg.t5': '请输入部门名称',
  'pages.System.OrgManage.components.UpdateOrg.t6': '请输入部门简称',
  'pages.System.OrgManage.components.UpdateOrg.t7': '请输入部门排序',
  'pages.System.RoleAdd.index.t0': '操作成功',
  'pages.System.RoleAdd.index.t1': '页面及权限',
  'pages.System.RoleAdd.index.t2': '选择',
  'pages.System.RoleAdd.index.page': '页面',
  'pages.System.RoleAdd.index.button': '按钮',
  'pages.System.RoleManage.index.t0': '删除成功',
  'pages.System.RoleManage.index.t1': '角色ID',
  'pages.System.RoleManage.index.t2': '角色名称',
  'pages.System.RoleManage.index.t3': '备注',
  'pages.System.RoleManage.index.t4': '最近更新时间',
  'pages.System.RoleManage.index.t5': '编辑',
  'pages.System.RoleManage.index.t6': '删除',
  'pages.System.RoleManage.index.t7': '新增角色',
  'pages.System.RoleManage.index.t8': '设置该角色的页面查看即操作按钮权限',
  'pages.System.RoleManage.index.t9': '点击',
  'pages.TableList.index.t0': '正在添加',
  'pages.TableList.index.t1': '添加成功',
  'pages.TableList.index.t2': '添加失败请重试！',
  'pages.TableList.index.t3': '正在配置',
  'pages.TableList.index.t4': '配置成功',
  'pages.TableList.index.t5': '配置失败请重试！',
  'pages.TableList.index.t6': '正在删除',
  'pages.TableList.index.t7': '删除成功，即将刷新',
  'pages.TableList.index.t8': '删除失败，请重试',
  'pages.TableList.index.t9': '规则名称是唯一的 key',
  'pages.TableList.components.UpdateForm.t0': '表一',
  'pages.TableList.components.UpdateForm.t1': '表二',
  'pages.TableList.components.UpdateForm.t2': '规则模板一',
  'pages.TableList.components.UpdateForm.t3': '规则模板二',
  'pages.TableList.components.UpdateForm.t4': '强',
  'pages.TableList.components.UpdateForm.t5': '弱',
  'pages.TableList.components.UpdateForm.t6': '月',
  'pages.TableList.components.UpdateForm.t7': '周',
  'pages.TaskView.BatchCreateTask.index.t0': '请选择客户',
  'pages.TaskView.BatchCreateTask.index.t1': '请创建任务计划',
  'pages.TaskView.BatchCreateTask.index.t2': '任务创建成功',
  'pages.TaskView.BatchCreateTask.index.t3': '任务创建失败，请稍后重试',
  'pages.TaskView.BatchCreateTask.index.t4': '获取任务详情失败，请稍后重试',
  'pages.TaskView.BatchCreateTask.index.t5': '序号',
  'pages.TaskView.BatchCreateTask.index.t6': '服务项目',
  'pages.TaskView.BatchCreateTask.index.t7': '计划执行者',
  'pages.TaskView.BatchCreateTask.index.t8': '计划开始时间',
  'pages.TaskView.BatchCreateTask.index.t9': '计划结束时间',
  'pages.TaskView.BatchCreateTask.index.t10': '任务次数',
  'pages.TaskView.BatchCreateTask.index.t11': '次',
  'pages.TaskView.BatchCreateTask.index.t12': '操作',
  'pages.TaskView.BatchCreateTask.index.t13': '编辑',
  'pages.TaskView.BatchCreateTask.index.t14': '确认要删除该计划吗？',
  'pages.TaskView.BatchCreateTask.index.t15': '删除',
  'pages.TaskView.BatchCreateTask.index.t16': '任务概况',
  'pages.TaskView.BatchCreateTask.index.t17': '创建相关任务',
  'pages.TaskView.BatchCreateTask.index.t18': '创建服务计划',
  'pages.TaskView.BatchCreateTask.index.t19': '创建任务',
  'pages.TaskView.BatchCreateTask.index.t20': '任务对象',
  'pages.TaskView.BatchCreateTask.index.t21': '已选择{num}人',
  'pages.TaskView.BatchCreateTask.index.t22': '选择客户',
  'pages.TaskView.BatchCreateTask.index.t23': '批量创建客户',
  'pages.TaskView.BatchCreateTask.index.t24': '任务计划',
  'pages.TaskView.BatchCreateTask.index.t25': '已添加{num}个',
  'pages.TaskView.BatchCreateTask.index.t26': '添加任务',
  'pages.TaskView.BatchCreateTask.index.t27': '提交',
  'pages.TaskView.BatchCreateTask.index.t28': '取消',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t0': '男',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t1': '女',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t2': '姓名',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t3': '客户名称',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t4': '生日',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t5': '请输入生日',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t6': '性别',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t7': '联系方式',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t8': '请输入联系方式',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t9': '请输入正确的联系方式',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t10': '登录手机号',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t11': '请输入登录名',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t12': '请输入正确的登录手机号',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t13': '操作',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t14': '创建客户',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t15': '获取任务详情失败，请稍后重试',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t16': '请输入正确格式的联系方式',
  'pages.TaskView.BatchCreateTask.components.BatchCreateCustomerModal.index.t17': '添加一行数据',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t0': '客户',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t1': '客户名称、联系电话、客户档案编号',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t2': '岁',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t3': '性别',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t4': '男',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t5': '女',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t6': '客户等级',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t7': '客户标签',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t8': '所属服务团队',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t9': '服务套餐',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t10': '关联平台',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t11': '服务客户',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t12': '潜在客户',
  'pages.TaskView.BatchCreateTask.components.ChooseCustomerModal.index.t13': '全部客户',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t0': '计划开始时间',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t1': '计划结束时间',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t2': '天前',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t3': '小时前',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t4': '编辑任务',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t5': '创建任务',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t6': '表单验证未通过，请查验后提交',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t7': '请选择服务项目',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t8': '个人',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t9': '团队',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t10': '请选择执行者类型',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t11': '请选择执行者类型',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t12': '请选择执行者',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t13': '固定时间',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t14': '重复时间',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t15': '请选择计划处理时间',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t16': '处理时间',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t17': '第一次任务计划时间',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t18': '请输入任务次数',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t19': '任务次数应该为正整数',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t20': '请输入间隔天数',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t21': '间隔天数应该为非负整数',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t22': '任务处理提醒',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t23': '添加',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t24': '按以下规则给计划执行者推送任务处理提醒的消息，支持PC端和APP的消息推送。',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t25': '时间类型',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t26': '推送时间',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t27': '操作',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t28': '请输入推送时间',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.t29': '服务记录单',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.t0': '所在部门',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.t1': '请选择部门',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.t2': '团队名称',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.t3': '请输入团队名称',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.t4': '团队成员',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.t5': '请输入团队成员名称',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.t6': '忙碌状态说明',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.t7': '忙碌',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.t8': '正在处理{num}个任务',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.t9': '请选择服务团队',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.t0': '员工',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.t1': '员工名称',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.t2': '所属部门',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.t3': '所属服务团队',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.t4': '联系电话',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.t5': '忙碌状态说明',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.t6': '忙碌',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.t7': '正在处理{num}个任务',
  'pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.t8': '请选择执行者',
  'pages.TaskView.BatchCreateTask.components.ServiceItemQuestionnaire.index.t0': '请求失败，请稍后重试',
  'pages.TaskView.BatchCreateTask.components.ServiceItemQuestionnaire.index.t1': '服务项目',
  'pages.TaskView.BatchCreateTask.components.ServiceItemQuestionnaire.index.t2': '表单填写',
  'pages.TaskView.BatchCreateTask.components.ServiceItemQuestionnaire.index.t3': '请选择客户',
  'pages.TaskView.BatchCreateTask.components.ServiceItemQuestionnaire.index.t4': '请选择客户',
  'pages.TaskView.BatchCreateTask.components.ServiceItemQuestionnaire.index.t5': '请选择客户',
  'pages.TaskView.BatchCreateTask.components.ServiceItemQuestionnaire.index.t6': '请选择客户',
  'pages.TaskView.BatchCreateTask.components.ServiceItemQuestionnaire.index.t7': '请选择客户',
  'pages.TaskView.BatchCreateTask.components.ServiceItemQuestionnaire.index.t8': '请选择客户',
  'pages.TaskView.BatchCreateTask.components.ServiceItemQuestionnaire.index.t9': '请选择客户',
  'pages.TaskView.MyTaskView.index.t0': '个人',
  'pages.TaskView.MyTaskView.index.t1': '团队',
  'pages.TaskView.MyTaskView.index.t2': '任务视图',
  'pages.TaskView.MyTaskView.index.t3': '显示模式',
  'pages.TaskView.MyTaskView.index.t4': '列表模式',
  'pages.TaskView.MyTaskView.index.t5': '日历模式',
  'pages.TaskView.MyTaskView.index.t6': '创建任务',
  'pages.TaskView.MyTaskView.index.t7': '创建客户',
  'pages.TaskView.MyTaskView.index.t8': '任务状态',
  'pages.TaskView.MyTaskView.index.t9': '昨天',
  'pages.TaskView.MyTaskView.index.t10': '今天',
  'pages.TaskView.MyTaskView.index.t11': '明天',
  'pages.TaskView.MyTaskView.index.t12': '本周',
  'pages.TaskView.MyTaskView.index.t13': '下周',
  'pages.TaskView.MyTaskView.index.t14': '全部',
  'pages.TaskView.MyTaskView.index.t15': '提交成功',
  'pages.TaskView.MyTaskView.index.t16': '指派给我和我所在的团队的',
  'pages.TaskView.MyTaskView.index.t17': '指派给我的',
  'pages.TaskView.MyTaskView.index.t18': '指派给给我所在的团队的',
  'pages.TaskView.MyTaskView.index.t19': '请选择任务类型',
  'pages.TaskView.MyTaskView.index.t20': '及时完成',
  'pages.TaskView.MyTaskView.index.t21': '逾期完成',
  'pages.TaskView.MyTaskView.index.t22': '请选择完成状态',
  'pages.TaskView.MyTaskView.index.t23': '服务项目',
  'pages.TaskView.MyTaskView.index.t24': '客户名称、联系电话、客户档案编号',
  'pages.TaskView.MyTaskView.index.t25': '所属团队',
  'pages.TaskView.MyTaskView.index.t26': '实际执行者',
  'pages.TaskView.MyTaskView.index.t27': '计划执行者',
  'pages.TaskView.MyTaskView.index.t28': '任务创建者',
  'pages.TaskView.MyTaskView.index.t29': '任务转交者',
  'pages.TaskView.MyTaskView.index.t30': '任务来源',
  'pages.TaskView.MyTaskView.index.t31': '客户等级',
  'pages.TaskView.MyTaskView.index.t32': '请选择客户标签',
  'pages.TaskView.MyTaskView.index.t33': '查询结果，共计{num}条',
  'pages.TaskView.MyTaskView.index.t34': '排序',
  'pages.TaskView.MyTaskView.components.CalendarModal.index.t0': '查询成功',
  'pages.TaskView.MyTaskView.components.CalendarModal.index.t1': '状态类型',
  'pages.TaskView.MyTaskView.components.CalendarModal.index.t2': '请选择状态类型',
  'pages.TaskView.MyTaskView.components.CalendarModal.index.t3': '服务项目',
  'pages.TaskView.MyTaskView.components.CalendarModal.index.t4': '所属团队',
  'pages.TaskView.MyTaskView.components.CalendarModal.index.t5': '客户名称、联系电话、客户档案编号',
  'pages.TaskView.MyTaskView.components.ListModal.index.t0': '计划时间',
  'pages.TaskView.MyTaskView.components.ListModal.index.t1': '实际执行时间',
  'pages.TaskView.MyTaskView.components.ListModal.index.t2': '实际执行时间',
  'pages.TaskView.MyTaskView.components.ListModal.index.t3': '任务关闭时间',
  'pages.TaskView.MyTaskView.components.ListModal.index.t4': '创建相关任务',
  'pages.TaskView.MyTaskView.components.ListModal.index.t5': '关闭成功',
  'pages.TaskView.MyTaskView.components.ListModal.index.t6': '关闭',
  'pages.TaskView.MyTaskView.components.ListModal.index.t7': '任务编号',
  'pages.TaskView.MyTaskView.components.ListModal.index.t8': '所属服务团队',
  'pages.TaskView.MyTaskView.components.ListModal.index.t9': '继续处理',
  'pages.TaskView.MyTaskView.components.ListModal.index.t10': '服务项目',
  'pages.TaskView.MyTaskView.components.ListModal.index.t11': '相关任务',
  'pages.TaskView.MyTaskView.components.ListModal.index.t12': '计划执行者',
  'pages.TaskView.MyTaskView.components.ListModal.index.t13': '实际执行者',
  'pages.TaskView.MyTaskView.components.ListModal.index.t14': '任务描述',
  'pages.TaskView.MyTaskView.components.ListModal.index.t15': '创建者',
  'pages.TaskView.MyTaskView.components.ListModal.index.t16': '转交者',
  'pages.TaskView.MyTaskView.components.ListModal.index.t17': '您确认开始处理该任务吗？',
  'pages.TaskView.MyTaskView.components.ListModal.index.t18': '您确认继续处理该任务吗？',
  'pages.TaskView.MyTaskView.components.ListModal.index.t19': '任务详情',
  'pages.TaskView.MyTaskView.components.ListModal.index.t20': '关闭',
  'pages.TaskView.MyTaskView.components.PassTask.index.t0': '提交成功',
  'pages.TaskView.MyTaskView.components.PassTask.index.t1': '提交失败',
  'pages.TaskView.MyTaskView.components.PassTask.index.t2': '转交任务',
  'pages.TaskView.MyTaskView.components.PassTask.index.t3': '任务详情',
  'pages.TaskView.MyTaskView.components.PassTask.index.t4': '服务项目',
  'pages.TaskView.MyTaskView.components.PassTask.index.t5': '计划执行者',
  'pages.TaskView.MyTaskView.components.PassTask.index.t6': '计划时间',
  'pages.TaskView.MyTaskView.components.PassTask.index.t7': '转交对象',
  'pages.TaskView.MyTaskView.components.PassTask.index.t8': '个人',
  'pages.TaskView.MyTaskView.components.PassTask.index.t9': '团队',
  'pages.TaskView.MyTaskView.components.PassTask.index.t10': '请选择执行者类型',
  'pages.TaskView.MyTaskView.components.PassTask.index.t11': '请选择执行者',
  'pages.TaskView.MyTaskView.components.PassTask.index.t12': '处理时间',
  'pages.TaskView.MyTaskView.components.PassTask.index.t13': '请选择计划处理时间',
  'pages.TaskView.Overview.components.CalendarMode.index.t0': '请求失败，请稍后重试',
  'pages.TaskView.Overview.components.CalendarMode.index.t1': '客户名称、联系电话、客户档案编号',
  'pages.TaskView.Overview.components.PopAffix.index.t0': '创建服务计划',
  'pages.TaskView.Overview.components.PopAffix.index.t1': '创建客户',
  'pages.TaskView.Overview.components.PopAffix.index.t2': '创建预约订单',
  'pages.TaskView.Overview.components.PopAffix.index.t3': '点击可新增任务、客户及预约订单',
  'pages.TaskView.Overview.components.PopAffix.index.t4': '点击',
  'pages.TaskView.Overview.components.PopAffix.index.t5': '第3步，共3步',
  'pages.TaskView.Overview.components.PopAffix.index.t6': '批量创建客户',
  'pages.TaskView.Overview.components.SearchForm.index.t0': '个人',
  'pages.TaskView.Overview.components.SearchForm.index.t1': '团队',
  'pages.TaskView.Overview.components.SearchForm.index.t2': '计划开始时间',
  'pages.TaskView.Overview.components.SearchForm.index.t3': '实际开始时间',
  'pages.TaskView.Overview.components.SearchForm.index.t4': '实际完成时间',
  'pages.TaskView.Overview.components.SearchForm.index.t5': '任务关闭时间',
  'pages.TaskView.Overview.components.SearchForm.index.t6': '指派对象：',
  'pages.TaskView.Overview.components.SearchForm.index.t7': '全部',
  'pages.TaskView.Overview.components.SearchForm.index.t8': '指派给我',
  'pages.TaskView.Overview.components.SearchForm.index.t9': '指派给我的团队',
  'pages.TaskView.Overview.components.SearchForm.index.t10': '逾期状态：',
  'pages.TaskView.Overview.components.SearchForm.index.t11': '全部',
  'pages.TaskView.Overview.components.SearchForm.index.t12': '正常',
  'pages.TaskView.Overview.components.SearchForm.index.t13': '逾期',
  'pages.TaskView.Overview.components.SearchForm.index.t14': '客户名称、联系电话、客户档案编号',
  'pages.TaskView.Overview.components.SearchForm.index.t15': '请选择客户标签',
  "pages.TaskView.Overview.components.SearchForm.index.t16": "客户信息",
  'pages.TaskView.Overview.components.SearchForm.DateRadioGroup.t0': '之前',
  'pages.TaskView.Overview.components.SearchForm.DateRadioGroup.t1': '今天',
  'pages.TaskView.Overview.components.SearchForm.DateRadioGroup.t2': '本周',
  'pages.TaskView.Overview.components.SearchForm.DateRadioGroup.t3': '本月',
  'pages.TaskView.Overview.components.SearchForm.DateRadioGroup.t4': '下月',
  'pages.TaskView.Overview.components.SearchForm.DateRadioGroup.t5': '全部',
  'pages.TaskView.Overview.components.SearchSorter.index.t0': '按计划结束时间升序',
  'pages.TaskView.Overview.components.SearchSorter.index.t1': '按计划结束时间降序',
  'pages.TaskView.Overview.components.SearchSorter.index.t2': '按创建时间升序',
  'pages.TaskView.Overview.components.SearchSorter.index.t3': '按创建时间降序',
  'pages.TaskView.Overview.components.SearchSorter.index.t4': '按计划开始时间升序',
  'pages.TaskView.Overview.components.SearchSorter.index.t5': '按计划开始时间降序',
  'pages.TaskView.Overview.components.SearchSorter.index.t6': '按计划结束时间升序',
  'pages.TaskView.Overview.components.SearchSorter.index.t7': '按计划结束时间降序',
  'pages.TaskView.Overview.components.SearchSorter.index.t8': '按创建时间升序',
  'pages.TaskView.Overview.components.SearchSorter.index.t9': '按创建时间降序',
  'pages.TaskView.Overview.components.SearchSorter.index.t10': '按实际开始时间升序',
  'pages.TaskView.Overview.components.SearchSorter.index.t11': '按实际开始时间降序',
  'pages.TaskView.Overview.components.SearchSorter.index.t12': '按实际结束时间升序',
  'pages.TaskView.Overview.components.SearchSorter.index.t13': '按实际结束时间降序',
  'pages.TaskView.Overview.components.SearchSorter.index.t14': '按创建时间升序',
  'pages.TaskView.Overview.components.SearchSorter.index.t15': '按创建时间降序',
  'pages.TaskView.Overview.components.SearchSorter.index.t16': '按任务关闭时间升序',
  'pages.TaskView.Overview.components.SearchSorter.index.t17': '按任务关闭时间降序',
  'pages.TaskView.Overview.components.SearchSorter.index.t18': '按创建时间升序',
  'pages.TaskView.Overview.components.SearchSorter.index.t19': '按创建时间降序',
  'pages.TaskView.Overview.components.StatusBar.index.t0': '切换日历模式',
  'pages.TaskView.Overview.components.StatusBar.index.t1': '切换表格模式',
  'pages.TaskView.Overview.components.TableList.index.t0': '确认开始处理',
  'pages.TaskView.Overview.components.TableList.index.t1': '您确认开始处理该任务吗？',
  'pages.TaskView.Overview.components.TableList.index.t2': '修改成功',
  'pages.TaskView.Overview.components.TableList.index.t3': '请求失败，请稍后重试',
  'pages.TaskView.Overview.components.TableList.index.t4': '计划执行者：',
  'pages.TaskView.Overview.components.TableList.index.t5': '计划开始：',
  'pages.TaskView.Overview.components.TableList.index.t6': '计划结束：',
  'pages.TaskView.Overview.components.TableList.index.t7': '实际执行者：',
  'pages.TaskView.Overview.components.TableList.index.t8': '实际开始：',
  'pages.TaskView.Overview.components.TableList.index.t9': '实际结束：',
  'pages.TaskView.Overview.components.TableList.index.t10': '无',
  'pages.TaskView.Overview.components.TableList.index.t11': '任务关闭者：',
  'pages.TaskView.Overview.components.TableList.index.t12': '关闭时间：',
  'pages.TaskView.Overview.components.TableList.index.t13': '创建相关任务',
  'pages.TaskView.Overview.components.TableList.index.t14': '关闭成功',
  'pages.TaskView.Overview.components.TableList.index.t15': '关闭',
  'pages.TaskView.Overview.components.TableList.index.t16': '任务ID',
  'pages.TaskView.Overview.components.TableList.index.t17': '服务项目',
  'pages.TaskView.Overview.components.TableList.index.t18': '服务客户',
  'pages.TaskView.Overview.components.TableList.index.t19': '客户等级：',
  'pages.TaskView.Overview.components.TableList.index.t20': '客户标签：',
  'pages.TaskView.Overview.components.TableList.index.t21': '服务地址：',
  'pages.TaskView.Overview.components.TableList.index.t22': '服务团队',
  'pages.TaskView.Overview.components.TableList.index.t23': '处理进度',
  'pages.TaskView.Overview.components.TableList.index.t24': '逾期状态',
  'pages.TaskView.Overview.components.TableList.index.t25': '查看详情',
  'pages.TaskView.Overview.components.TableList.index.t26': '开始处理',
  'pages.TaskView.Overview.components.TableList.index.t27': '继续处理',
  'pages.TaskView.Overview.components.TableList.index.t28': '点击开始处理任务，填写服务结果等',
  'pages.TaskView.Overview.components.TableList.index.t29': '点击',
  'pages.TaskView.Overview.components.TableList.index.t30': '第1步，共3步',
  'pages.TaskView.Overview.components.TableList.index.t31': '点击可转交任务、创建相关任务及关闭',
  'pages.TaskView.Overview.components.TableList.index.t32': '点击',
  'pages.TaskView.Overview.components.TableList.index.t33': '第2步，共3步',
  'pages.TaskView.Overview.components.TableList.index.t34': '岁',
  'pages.TaskView.Overview.components.TableMode.index.t0': '查询结果，共计{num}条',
  'pages.TaskView.TaskPrint.index.t0': '获取任务详情失败，请稍后重试',
  'pages.TaskView.TaskPrint.index.t1': '打印',
  'pages.TaskView.TaskPrint.index.t2': '服务项目确认单',
  'pages.TaskView.TaskPrint.index.t3': '服务基本信息',
  'pages.TaskView.TaskPrint.index.t4': '姓名',
  'pages.TaskView.TaskPrint.index.t5': '性别年龄',
  'pages.TaskView.TaskPrint.index.t6': '岁',
  'pages.TaskView.TaskPrint.index.t7': '证件号码',
  'pages.TaskView.TaskPrint.index.t8': '档案编号',
  'pages.TaskView.TaskPrint.index.t9': '联系电话',
  'pages.TaskView.TaskPrint.index.t10': '客户等级',
  'pages.TaskView.TaskPrint.index.t11': '服务团队',
  'pages.TaskView.TaskPrint.index.t12': '服务项目',
  'pages.TaskView.TaskPrint.index.t13': '计划执行者',
  'pages.TaskView.TaskPrint.index.t14': '实际执行者',
  'pages.TaskView.TaskPrint.index.t15': '实际执行时间',
  'pages.TaskView.TaskPrint.index.t16': '服务总结',
  'pages.TaskView.TaskPrint.index.t17': '服务人员签字',
  'pages.TaskView.TaskPrint.index.t18': '客户签字',
  'pages.TaskView.TaskProcess.index.t0': '获取任务详情失败，请稍后重试',
  'pages.TaskView.TaskProcess.index.t1': '血压结果未正确输入',
  'pages.TaskView.TaskProcess.index.t2': '提交成功',
  'pages.TaskView.TaskProcess.index.t3': '暂存成功',
  'pages.TaskView.TaskProcess.index.t4': '操作失败，请稍后重试',
  'pages.TaskView.TaskProcess.index.t5': '缺少任务 id',
  'pages.TaskView.TaskProcess.index.t6': '推荐可同时处理（{num}）',
  'pages.TaskView.TaskProcess.index.t7': '是指和当前处理任务',
  'pages.TaskView.TaskProcess.index.t8': '有相同客户对象',
  'pages.TaskView.TaskProcess.index.t9': '相同任务处理开始时间',
  'pages.TaskView.TaskProcess.index.t10': '相同服务条件',
  'pages.TaskView.TaskProcess.index.t11': '均为通用的任务处理页面的任务',
  'pages.TaskView.TaskProcess.index.t12': '支持同时处理',
  'pages.TaskView.TaskProcess.index.t13': '同时处理',
  'pages.TaskView.TaskProcess.index.t14': '创建相关任务',
  'pages.TaskView.TaskProcess.index.t15': '请选择服务形式',
  'pages.TaskView.TaskProcess.index.t16': '请选择服务结果',
  'pages.TaskView.TaskProcess.index.t17': '上传凭证',
  'pages.TaskView.TaskProcess.index.t18': '支持上传图片',
  'pages.TaskView.TaskProcess.index.t19': '任务详情',
  'pages.TaskView.TaskProcess.index.t20': '本次处理（{num}）',
  'pages.TaskView.TaskProcess.index.t21': '服务记录单',
  'pages.TaskView.TaskProcess.index.t22': '处理结果',
  'pages.TaskView.TaskProcess.index.t23': '客户通知',
  'pages.TaskView.TaskProcess.index.t24': '任务相关记录',
  'pages.TaskView.TaskProcess.index.t25': '常见指标录入：',
  'pages.TaskView.TaskProcess.index.t26': '请填写服务指导方案，用于指导服务人员如何服务客户的办法：',
  'pages.TaskView.TaskProcess.index.t27': '从模板库选择',
  'pages.TaskView.TaskProcess.index.t28': '提交',
  'pages.TaskView.TaskProcess.index.t29': '暂存',
  'pages.TaskView.TaskProcess.index.t30': '取消',
  'pages.TaskView.TaskProcess.index.t31': '插入成功',
  'pages.TaskView.TaskProcess.index.t32': '短信',
  'pages.TaskView.TaskProcess.index.t33': '微信',
  'pages.TaskView.TaskProcess.index.t34': '联系客户',
  'pages.TaskView.TaskProcess.components.CustomerSummary.index.t0': '客户信息',
  'pages.TaskView.TaskProcess.components.CustomerSummary.index.t1': '客户详情',
  'pages.TaskView.TaskProcess.components.CustomerSummary.index.t2': '岁',
  'pages.TaskView.TaskProcess.components.CustomerSummary.index.t3': '无',
  'pages.TaskView.TaskProcess.components.CustomerSummary.index.t4': '无',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t0': '删除成功',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t1': '请求失败，请稍后重试',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t2': '服务项目',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t3': '预约订单',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t4': '权益抵扣',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t5': '支付状态',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t6': '已支付',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t7': '免费',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t8': '待支付',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t9': '应付费用',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t10': '实付费用',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t11': '备注',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t12': '操作',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t13': '编辑',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t14': '删除',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t15': '录入本次服务过程中产生的消费情况：',
  'pages.TaskView.TaskProcess.components.ExpensesRecord.index.t16': '添加',
  'pages.TaskView.TaskProcess.components.RecommendTask.index.t0': '任务编号：',
  'pages.TaskView.TaskProcess.components.RecommendTask.index.t1': '客户对象：',
  'pages.TaskView.TaskProcess.components.RecommendTask.index.t2': '所属服务团队：',
  'pages.TaskView.TaskProcess.components.TaskCountDown.index.t0': '即将逾期',
  'pages.TaskView.TaskProcess.components.TaskDetail.index.t0': '获取任务概况失败，请稍后重试',
  'pages.TaskView.TaskProcess.components.TaskDetail.TaskRelation.t0': '任务详情',
  'pages.TaskView.TaskProcess.components.TaskDetail.TaskRelation.t1': '关闭',
  'pages.TaskView.TaskProcess.components.TaskStatus.index.t0': '待处理',
  'pages.TaskView.TaskProcess.components.TaskStatus.index.t1': '处理中',
  'pages.TaskView.TaskProcess.components.TaskStatus.index.t2': '已完成',
  'pages.TaskView.TaskProcess.components.TaskStatus.index.t3': '已关闭',
  'pages.TaskView.TaskProcessDetail.index.t0': '短信',
  'pages.TaskView.TaskProcessDetail.index.t1': '微信',
  'pages.TaskView.TaskProcessDetail.index.t2': '确认开始处理',
  'pages.TaskView.TaskProcessDetail.index.t3': '您确认开始处理该任务吗？',
  'pages.TaskView.TaskProcessDetail.index.t4': '获取任务详情失败，请稍后重试',
  'pages.TaskView.TaskProcessDetail.index.t5': '缺少任务 id',
  'pages.TaskView.TaskProcessDetail.index.t6': '开始处理',
  'pages.TaskView.TaskProcessDetail.index.t7': '继续处理',
  'pages.TaskView.TaskProcessDetail.index.t8': '处理结果',
  'pages.TaskView.TaskProcessDetail.index.t9': '客户通知',
  'pages.TaskView.TaskProcessDetail.index.t10': '任务相关记录',
  'pages.TaskView.TaskProcessDetail.index.t11': '常见指标录入：',
  'pages.TaskView.TaskProcessDetail.index.t12': '请填写服务指导方案，用于指导服务人员如何服务客户的办法：',
  'pages.TaskView.TaskProcessDetail.index.t13': '打印',
  'pages.TaskView.TaskProcessDetail.index.t14': '取消',
  'pages.TaskView.TaskProcessDetail.index.t15': '任务详情',
  'pages.TaskView.TaskProcessDetail.index.t16': '服务记录单',
  'pages.TaskView.TaskProcessDetail.index.t17': '联系客户',
  'pages.User.login.index.t0': '登录成功！',
  'pages.User.login.index.t1': '登录失败，请重试！',
  'pages.User.login.index.t2': '忘记密码',
  'pages.User.login.index.t3': '密码输入错误',
  'pages.User.login.index.t4': '获取验证码成功！',
  'pages.User.login.index.t5': '返回登录',
  'pages.User.login.index.t6': '验证码错误',
  'pages.NoFoundPage.t0': '抱歉，你访问的页面不存在',

  'pages.Customer.GroupReport.index.t0': '报告编号',
  'pages.Customer.GroupReport.index.t1': '报告名称',
  'pages.Customer.GroupReport.index.t2': '团体名称',
  'pages.Customer.GroupReport.index.t3': '到检时间段',
  'pages.Customer.GroupReport.index.t4': '登记人数',
  'pages.Customer.GroupReport.index.t5': '报告人数',
  'pages.Customer.GroupReport.index.t6': '报告状态',
  'pages.Customer.GroupReport.index.t7': '生成时间',
  'pages.Customer.GroupReport.index.t8': '操作人',
  'pages.Customer.GroupReport.index.t9': '操作',
  'pages.Customer.GroupReport.index.t10': '批次号：',
  'pages.Customer.GroupReport.index.t11': '未生成',
  'pages.Customer.GroupReport.index.t12': '已生成',
  'pages.Customer.GroupReport.index.t13': '生成中',
  'pages.Customer.GroupReport.index.t14': '创建报告',
  'pages.Customer.GroupReport.index.t15': '生成报告',
  'pages.Customer.GroupReport.index.t16': '查看报告',
  'pages.Customer.GroupReport.index.t17': '更多',
  'pages.Customer.GroupReport.index.t18': '基本信息',
  'pages.Customer.GroupReport.index.t19': '人员名单',
  'pages.Customer.GroupReport.index.t20': '重新生成',
  'pages.Customer.GroupReport.index.t21': '删除记录',
  'pages.Customer.GroupReport.index.t22': '报告设置',
  'pages.Customer.GroupReport.components.ReportModal.index.t0': '团体报告',
  'pages.Customer.GroupReport.components.ReportModal.index.t1': '报告名称',
  'pages.Customer.GroupReport.components.ReportModal.index.t2': '用于显示在报告封面',
  'pages.Customer.GroupReport.components.ReportModal.index.t3': '团体名称',
  'pages.Customer.GroupReport.components.ReportModal.index.t4': '输入本次报告所属团体的名称',
  'pages.Customer.GroupReport.components.ReportModal.index.t5': '到检时间段',
  'pages.Customer.GroupReport.components.ReportModal.index.t6': '选择时间段',
  'pages.Customer.GroupReport.components.ReportModal.index.t7': '注：请选择准确的体检时间段，生成报告时将只查找该时间段内最新的一份体检报告作为本次团体报告的分析对象。',
  'pages.Customer.GroupReport.components.ReportModal.index.t8': '备忘',
  'pages.Customer.GroupReport.components.ReportModal.index.t9': '输入备忘事项，方便后续跟进',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t0': '人员名单',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t1': '登记人数',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t2': '已出报告',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t3': '未出报告',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t4': '添加',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t5': '从文件导入',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t6': '证件号码',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t7': '姓名',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t8': '性别年龄',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t9': '到检日期',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t10': '未知',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t11': '岁',
  'pages.Customer.GroupReport.components.PersonalListDrawer.index.t12': '请先选中需要删除的人员',
  'pages.Customer.GroupReport.components.AddPersonalModal.index.t0': '人员',
  'pages.Customer.GroupReport.components.AddPersonalModal.index.t1': '企业',
  'pages.Customer.GroupReport.components.AddPersonalModal.index.t2': '园区',
  'pages.Customer.GroupReport.components.AddPersonalModal.index.t3': '所选择团体共包含 {total} 位成员，其中 {bindedCount} 人绑定了证件号码，可添加 {addCount} 人 。',
  'pages.Customer.GroupReport.components.AddPersonalModal.index.t4': '获取团体列表数据',
  'pages.Customer.GroupReport.components.AddPersonalModal.index.t5': '获取团体信息',
  'pages.Customer.GroupReport.components.AddPersonalModal.index.t6': '所选择团体共包含 ',
  'pages.Customer.GroupReport.components.AddPersonalModal.index.t7': ' 位成员，其中 ',
  'pages.Customer.GroupReport.components.AddPersonalModal.index.t8': ' 人绑定了证件号码，可添加 ',
  'pages.Customer.GroupReport.components.AddPersonalModal.index.t9': ' 人 。',
  'pages.Customer.GroupReport.components.ImportPersonalModal.index.t0': '从文件导入',
  'pages.Customer.GroupReport.components.ImportPersonalModal.index.t1': '点击或将文件拖拽到这里上传，仅支持单个excel文件上传。',
  'pages.Customer.GroupReport.components.ImportPersonalModal.index.t2': '下载导入模板',
  'pages.Customer.GroupReport.components.ImportPersonalModal.index.t3': '请先选择文件',
  'pages.Customer.GroupReport.components.GenerateReportModal.index.t0': '报告',
  'pages.Customer.GroupReport.components.GenerateReportModal.index.t1': '该团体共登记 {total} 人，实际到检（已出报告）人数为 {reportedCount} 人。',
  'pages.Customer.GroupReport.components.GenerateReportModal.index.t2': '请确认是否继续为该团体生成团检报告？',
  'pages.Customer.GroupReport.components.GenerateReportModal.index.t3': '该团体共登记 ',
  'pages.Customer.GroupReport.components.GenerateReportModal.index.t4': ' 人，实际到检（已出报告）人数为 ',
  'pages.Customer.GroupReport.components.GenerateReportModal.index.t5': ' 人。',
  'pages.Customer.GroupReport.components.GenerateReportModal.index.t6': '目前暂时无法生成团体报告，请等待个人报告生成后再操作。',
  "pages.Customer.GroupReport.components.MetricSettingDrawer.index.t0": "指标名称",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.index.t1": "参考范围",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.index.t2": "单位",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.index.t3": "开启",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.index.t4": "报告设置",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.index.t5": "分析指标设置",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t0": "指标设置",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t1": "指标名称",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t2": "区分男女",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t3": "指标单位",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t4": "通用",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t5": "参考范围",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t6": "输入格式说明：",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t7": "1、运算符可使用：",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t8": "2、也可以使用格式如“18.5-24.0”，意味着数值是>=18.5并且<24.0；",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t9": "3、不同区间所使用的表达式，注意不要跟其他区间的数值范围重叠，以免计算有误。",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t10": "格式不正确，参考格式：",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t11": "区间终止值应大于起始值",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t12": "区间分段",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t13": "2段",
  "pages.Customer.GroupReport.components.MetricSettingDrawer.ModifyConfigItemModal.t14": "3段",
  'pages.Customer.GroupReportDetail.components.FrontCover.index.t0': '团体健康管理报告',
  'pages.Customer.GroupReportDetail.components.FrontCover.index.t1': '早检早预防 健康常相伴',
  'pages.Customer.GroupReportDetail.components.FrontCover.index.t2': '报告名称：',
  'pages.Customer.GroupReportDetail.components.FrontCover.index.t3': '报告编号：',
  'pages.Customer.GroupReportDetail.components.FrontCover.index.t4': '体检日期：',
  'pages.Customer.GroupReportDetail.components.FrontCover.index.t5': '生成日期：',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t0': '前言',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t1': '本次参检基本情况',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t2': '重要指标检测结果分布',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t3': '体重指数（BMI）',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t4': '收缩压和舒张压',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t5': '空腹血糖',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t6': '血尿酸',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t7': '血脂',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t8': 'TOP10体检异常人群成分',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t9': '总体异常',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t10': '男性异常',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t11': '女性异常',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t12': 'TOP10体检异常解析及建议',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t13': 'TOP100体检异常检出率及历次对比',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t14': '本次体检项目',
  'pages.Customer.GroupReportDetail.components.Catalog.index.t15': '结束语',
  'pages.Customer.GroupReportDetail.components.Preface.index.t0': '需要注意的是：',
  'pages.Customer.GroupReportDetail.components.Preface.index.t1': '本报告是针对贵单位员工体检结果和健康调查的综合分析报告，通过本报告可以让贵单位管理者了解员工的整体身体健康状况，采取有针对性的干预和管理措施，降低员工的疾病风险，实现员工健康资产的保障、升值，提升企业的劳动生产率和可持续发展能力。',
  'pages.Customer.GroupReportDetail.components.Preface.index.t2': '本报告的参检人数是以当次参检人数为基准，参检率越高越能反映贵单位的健康状况。',
  'pages.Customer.GroupReportDetail.components.Preface.index.t3': '本报告是针对所选人群的一个健康总结，数据主要来源于体检结果。',
  'pages.Customer.GroupReportDetail.components.Preface.index.t4': '本报告中所提出的建议和指导可作为日常保健的参考',
  'pages.Customer.GroupReportDetail.components.Preface.index.t5': '健康体检是健康管理的开始，同时仍需注意身体状况的变化，改善不良生活习惯，注意生活环境和保持良好心态，才能享有高品质生活和健康快乐的人生。',
  'pages.Customer.GroupReportDetail.components.Participation.index.t0': '本次参检情况说明',
  'pages.Customer.GroupReportDetail.components.Participation.index.t1': '参检人员情况',
  'pages.Customer.GroupReportDetail.components.Participation.index.t2': '体检开始日期',
  'pages.Customer.GroupReportDetail.components.Participation.index.t3': '体检结束日期',
  'pages.Customer.GroupReportDetail.components.Participation.index.t4': '登记人数',
  'pages.Customer.GroupReportDetail.components.Participation.index.t5': '参检人数',
  'pages.Customer.GroupReportDetail.components.Participation.index.t6': '男性参检人数',
  'pages.Customer.GroupReportDetail.components.Participation.index.t7': '男性参检比例',
  'pages.Customer.GroupReportDetail.components.Participation.index.t8': '女性参检人数',
  'pages.Customer.GroupReportDetail.components.Participation.index.t9': '女性参检比例',
  'pages.Customer.GroupReportDetail.components.Participation.index.t10': '主要体检项目',
  'pages.Customer.GroupReportDetail.components.Participation.index.t11': '参检人员性别年龄分布',
  'pages.Customer.GroupReportDetail.components.Participation.index.t12': '性别占比',
  'pages.Customer.GroupReportDetail.components.Participation.index.t13': '各年龄段性别占比',
  'pages.Customer.GroupReportDetail.components.Participation.index.t14': '男性',
  'pages.Customer.GroupReportDetail.components.Participation.index.t15': '女性',
  'pages.Customer.GroupReportDetail.components.Participation.index.t16': '0-39岁',
  'pages.Customer.GroupReportDetail.components.Participation.index.t17': '40-59岁',
  'pages.Customer.GroupReportDetail.components.Participation.index.t18': '60岁以上',
  'pages.Customer.GroupReportDetail.components.Participation.index.t19': '参检人员平均年龄为{age}岁，',
  'pages.Customer.GroupReportDetail.components.Participation.index.t20': '其中男性为{age}岁，',
  'pages.Customer.GroupReportDetail.components.Participation.index.t21': '女性为{age}岁；',
  'pages.Customer.GroupReportDetail.components.Participation.index.t22': '0~39岁',
  'pages.Customer.GroupReportDetail.components.Participation.index.t23': '40~59岁',
  'pages.Customer.GroupReportDetail.components.Participation.index.t24': '各年龄段分别占总体检人数的{n1}、{n2}、{n3}；',
  'pages.Customer.GroupReportDetail.components.Participation.index.t25': '本次体检以{range}人员为主。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.bmi': '体重指数（BMI)',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.systolicPressure': '收缩压',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.diastolicPressure': '舒张压',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.fastingBloodGlucose': '空腹血糖',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.uricAcid': '血尿酸',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.bloodLipids': '血脂',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.totalCholesterol': '总胆固醇',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.triglycerides': '甘油三酯',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.hdlCholesterol': '高密度脂蛋白胆固醇',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.ldlCholesterol': '低密度脂蛋白胆固醇',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t0': '重要指标检查结果分布',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t1': '以下为重要检验指标的结果分布，若指标异常而总检未下异常结论，则可能与异常统计数不完全吻合。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t2': '体重指数BMI分类参考成人体重分布标准，体重过低BMl<18.5;体重正常18.5<BMl<24;超重24<BMl<28;肥胖BMI>28。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t3': '参检人员的体重类型分布见下表，结果显示参检人员中超重比例为{n1}、肥胖比例为{n2}。其中男性超重和肥胖的比例占{n3}，女性超重和肥胖的比例占{n4}。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t4': '体重过低',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t5': '体重正常',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t6': '超重',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t7': '肥胖',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t8': '男性',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t9': '女性',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t10': '总体',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t11': '建议',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t12': '1、组织开展体重管理的健康宣教活动。提高员工对肥胖导致多种慢性疾疾病发生的认识，从而增强对自己体重管理的主动性，即从膳食结构和运动方式和合理化调整入手。在团队的监督落实下，降低团队成员的超重例。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t13': '2、对体重指数(BMI)超出正常范围者，建议跟踪检测血压、血糖(包括空腹、餐后2小时)的变化，因BMI≥24者患高血压的危险是体重正常者的3~4倍，患糖尿病的危险的体重正常者的2~3倍。BMI≥28的肥2胖者中90%以上患上述疾病或有危险因素聚集。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t14': '3、重点提示:建议对超重、肥胖人员定期监测餐后2小时血糖及糖化血红蛋白的检查，以早期筛查糖尿病风险较高的人群，进行强化生活方式的干预，防止或延缓糖尿病的发生。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t15': '和',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t16': '收缩压和舒张压的分类主要参考高血压防治指南中血压水平的分级，偏低:收缩压<90、舒张压<60;正常:90≤收缩压<120、60≤舒张压<80;正常高值:120≤收缩压<140、80≤舒张压<90;偏高:收缩压≥140、舒张压≥90。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t17': '参检人员中收缩压正常高值的比例为{n1}、偏高的比例为{n2};舒张压正常高值的比例为{n3}、偏高的比例为{n4}。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t18': '偏低',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t19': '正常',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t20': '正常高值',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t21': '偏高',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t22': '参检人员中空腹血糖水平及结果分布见下表，与参考范围相比偏高的比例为{n1}。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t23': '偏低',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t24': '正常',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t25': '偏高',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t26': '参检人员中血尿酸水平及结果分布见下表，与参考范围相比偏高的比例为{n1}。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t27': '偏低',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t28': '正常',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t29': '偏高',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t30': '参检人员中总胆固醇水平及结果分布见下表，与参考范围相比异常的比例为{n1}。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t31': '参检人员中甘油三酯水平及结果分布见下表，与参考范围相比异常的比例为{n1}。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t32': '参检人员中高密度脂蛋白胆固醇水平及结果分布见下表，与参考范围相比异常的比例为{n1}。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t33': '参检人员中低密度脂蛋白胆固醇水平及结果分布见下表，与参考范围相比异常的比例为{n1}。',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t34': '正常',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t35': '异常',
  'pages.Customer.GroupReportDetail.components.MetricsDistribution.index.t36': '参检人员中{metric}水平及结果分布见下表，与参考范围相比异常的比例为{percent}。',
  'pages.Customer.GroupReportDetail.components.MetricComponent.index.t0': '平均值',
  'pages.Customer.GroupReportDetail.components.MetricComponent.index.t1': '人',
  'pages.Customer.GroupReportDetail.components.MetricComponent.index.t2': '男性',
  'pages.Customer.GroupReportDetail.components.MetricComponent.index.t3': '女性',
  'pages.Customer.GroupReportDetail.components.MetricComponent.index.t4': '总体',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t0': 'TOP10体检异常人群分布',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t1': '男性',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t2': '女性',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t3': '异常',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t4': '针对本次体检发现的异常进行排序，结果如下表。{gender}人群中检出率排名前三的异常是：',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t5': '人',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t6': '异常名称',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t7': '{gender}检出人数',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t8': '{gender}人数占比',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t9': '总',
  'pages.Customer.GroupReportDetail.components.AbnormalityPopulation.index.t10': '人群',
  'pages.Customer.GroupReportDetail.components.AbnormalitySuggestion.index.t0': 'TOP10 体检异常解析及建议',
  'pages.Customer.GroupReportDetail.components.AbnormalitySuggestion.index.t1': '该部分针对贵单位员工在我体检中心时，所检出最常见的部分异常情况相关分析与医疗保健建议。',
  'pages.Customer.GroupReportDetail.components.AbnormalitySuggestion.index.t2': '异常',
  'pages.Customer.GroupReportDetail.components.AbnormalitySuggestion.index.t3': '解释：',
  'pages.Customer.GroupReportDetail.components.AbnormalitySuggestion.index.t4': '建议：',
  'pages.Customer.GroupReportDetail.components.AbnormalityComparison.index.t0': 'TOP100体检异常检出率及历次对比',
  'pages.Customer.GroupReportDetail.components.AbnormalityComparison.index.t1': '异常名称',
  'pages.Customer.GroupReportDetail.components.AbnormalityComparison.index.t2': '上次检出人数/占比',
  'pages.Customer.GroupReportDetail.components.AbnormalityComparison.index.t3': '本次检出人数/占比',
  'pages.Customer.GroupReportDetail.components.AbnormalityComparison.index.t4': '人',
  'pages.Customer.GroupReportDetail.components.AbnormalityComparison.index.t5': '以下提供本次体检Top100的异常结论检出率，跟上次团检的检出率做对比。本次参检人数{n1}人，上次参检人数{n2}人。',
  'pages.Customer.GroupReportDetail.components.Conclusion.index.t0': '结束语',
  'pages.Customer.GroupReportDetail.components.Conclusion.index.t1': '影响健康的因素很多，包括遗传、日常生活习惯、社会环境、医疗资源等等，其中医疗资源,仅占影响健康因素的8%，最大的影响因素还是日常生活习惯及社会环境。',
  'pages.Customer.GroupReportDetail.components.Conclusion.index.t2': '根据世界卫生组织的数据显示，75%的癌症是已知的环境因素和不良习惯所引起，而这些因素都是可以预防的，例如抽烟、酗酒。',
  'pages.Customer.GroupReportDetail.components.Conclusion.index.t3': '世界卫生组织指出:“二十一世纪的医学不应该继续以疾病为主要研究对象，而应该以人类健康作为医学研究的主要方向。” 这个精神旨在宣告预防医学和健康保健将成为医学的主导。',
  'pages.Customer.GroupReportDetail.components.Conclusion.index.t4': '关注自己的身体健康也是对自己、亲人和社会的一种责任。定期体检是体现了单位对员工健康的关怀，但体检只是了解员工健康情况的一种手段，当发现了身体的异常问题后要引起思想上的重视和行为上的改善，做到未病先防、既病防变、已病早治，这样健康体检才可真正起到预防的作用。',
  'pages.Customer.GroupReportDetail.components.Conclusion.index.t5': '我们愿以卓越的服务、优质的技术继续为贵单位提供医疗保健服务，从体检中发现健康问题，从保健中解决健康问题。我们衷心祝愿贵单位全体员工身体更加健康，希望能与贵单位携手朝着健康的目标共同迈进。',
  'pages.Customer.GroupReportDetail.components.Conclusion.index.t6': '最后，感谢贵单位对我们的支持，别忘了定期为员工安排健康检查。',
  'pages.Customer.GroupReportDetail.components.BackCover.index.t0': '全国服务热线: ',
  'pages.Customer.Community.index.t0': '有服务',
  'pages.Customer.Community.index.t1': '无服务',
  'pages.Customer.Community.index.t2': '搜索园区',
  'pages.Customer.Community.index.t3': '新增园区',
  'pages.Customer.Community.index.t4': '省份/城市',
  'pages.Customer.Community.index.t5': '住户视图',
  'pages.Customer.Community.index.t6': '房间视图',
  'pages.Customer.Community.index.t7': '生成二维码',
  'pages.Customer.Community.index.t8': '选择客户端',
  'pages.Customer.Community.index.t9': '请选择客户端',
  'pages.Customer.Community.index.t10': '已全部加载',
  'pages.Customer.Community.index.t11': '加载更多',
  'pages.Customer.Community.components.EditCommunityModal.index.t0': '园区',
  'pages.Customer.Community.components.EditCommunityModal.index.t1': '园区名称',
  'pages.Customer.Community.components.EditCommunityModal.index.t2': '建议命名为“城市名+园区名”，如：杭州月桂花园。',
  'pages.Customer.Community.components.EditCommunityModal.index.t3': '所在地址',
  'pages.Customer.Community.components.EditCommunityModal.index.t4': '省市区街道',
  'pages.Customer.Community.components.EditCommunityModal.index.t5': '详细地址',
  'pages.Customer.Community.components.EditCommunityModal.index.t6': '物业公司',
  'pages.Customer.Community.components.EditCommunityModal.index.t7': '多级选择，可搜索，单选',
  'pages.Customer.Community.components.EditCommunityModal.index.t8': '服务设置',
  'pages.Customer.Community.components.EditCommunityModal.index.t9': '无服务',
  'pages.Customer.Community.components.EditCommunityModal.index.t10': '有服务',
  'pages.Customer.Community.components.EditCommunityModal.index.t11': '启用状态',
  'pages.Customer.Community.components.EditCommunityModal.index.t12': '正常',
  'pages.Customer.Community.components.EditCommunityModal.index.t13': '停用',
  'pages.Customer.Community.components.EditCommunityModal.index.t14': '服务团队',
  'pages.Customer.Community.components.ResidentView.index.diseaseMetric': '既往病史',
  'pages.Customer.Community.components.ResidentView.index.ms0': '未维护',
  'pages.Customer.Community.components.ResidentView.index.ms1': '已维护',
  'pages.Customer.Community.components.ResidentView.index.multiSelect': '多选',
  'pages.Customer.Community.components.ResidentView.index.liveType': '居住情况',
  'pages.Customer.Community.components.ResidentView.index.lt0': '独居',
  'pages.Customer.Community.components.ResidentView.index.lt1': '夫妇二人',
  'pages.Customer.Community.components.ResidentView.index.lt2': '夫妇子女',
  'pages.Customer.Community.components.ResidentView.index.lt3': '和父母同居',
  'pages.Customer.Community.components.ResidentView.index.lt4': '和子孙同居',
  'pages.Customer.Community.components.ResidentView.index.status': '入住状态',
  'pages.Customer.Community.components.ResidentView.index.s0': '未入住',
  'pages.Customer.Community.components.ResidentView.index.s1': '已入住',
  'pages.Customer.Community.components.ResidentView.index.auditStatus': '信息核对',
  'pages.Customer.Community.components.ResidentView.index.as0': '未核对',
  'pages.Customer.Community.components.ResidentView.index.as1': '已核对',
  'pages.Customer.Community.components.ResidentView.index.bindStatus': '账号状态',
  'pages.Customer.Community.components.ResidentView.index.bs0': '未授权',
  'pages.Customer.Community.components.ResidentView.index.bs1': '已授权',
  'pages.Customer.Community.components.ResidentView.index.resident': '住户',
  'pages.Customer.Community.components.ResidentView.index.residentTips': '住户姓名、手机号、证件号',
  'pages.Customer.Community.components.ResidentView.index.room': '房间',
  'pages.Customer.Community.components.ResidentView.index.filter': '筛选',
  'pages.Customer.Community.components.ResidentView.index.recentService': '最近服务',
  'pages.Customer.Community.components.ResidentView.index.all': '全部',
  'pages.Customer.Community.components.ResidentView.index.age': '岁',
  'pages.Customer.Community.components.ResidentView.index.maintain': '维护',
  'pages.Customer.Community.components.ResidentView.index.checkInInfo': '入住信息',
  'pages.Customer.Community.components.ResidentView.index.personalInfo': '个人信息',
  'pages.Customer.Community.components.ResidentView.index.removeResident': '迁出住户',
  'pages.Customer.Community.components.ResidentView.index.removeTips': '请确认是否要迁出该住户？',
  'pages.Customer.Community.components.ResidentView.index.removeSuccess': '迁出住户成功',
  'pages.Customer.Community.components.ResidentView.index.personalName': '姓名',
  'pages.Customer.Community.components.ResidentView.index.maintainInfo': '个人信息维护',
  'pages.Customer.Community.components.ResidentView.index.birthday': '出生日期',
  'pages.Customer.Community.components.ResidentView.index.mobile': '联系手机',
  'pages.Customer.Community.components.ResidentView.index.maritalStatus': '婚姻状态',
  'pages.Customer.Community.components.ResidentView.index.maritalStatus1': '未婚',
  'pages.Customer.Community.components.ResidentView.index.maritalStatus2': '已婚',
  'pages.Customer.Community.components.ResidentView.index.maritalStatus3': '丧偶',
  'pages.Customer.Community.components.ResidentView.index.maritalStatus4': '离婚',
  'pages.Customer.Community.components.ResidentView.index.maritalStatus5': '未知',
  'pages.Customer.Community.components.ResidentView.index.ct1': '身份证号',
  'pages.Customer.Community.components.ResidentView.index.ct2': '其他证件',
  'pages.Customer.Community.components.ResidentView.index.rt1': '户主本人',
  'pages.Customer.Community.components.ResidentView.index.rt2': '户主亲友',
  'pages.Customer.Community.components.ResidentView.index.rt3': '租户',
  'pages.Customer.Community.components.ResidentView.index.ageRange': '年龄段',
  'pages.Customer.Community.components.ResidentView.index.t0': '查询园区：',
  'pages.Customer.Community.components.ResidentView.index.t1': '，共找到{residentTotal}位住户',
  'pages.Customer.Community.components.ResidentView.index.t2': '变更',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t0': '入住信息维护',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t1': '选择园区',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t2': '请选择园区',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t3': '选择房间',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t4': '请选择房间',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t5': '登录账号',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t6': '住户姓名',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t7': '证件号码',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t8': '证件类型',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t9': '证件号码',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t10': '正确格式的身份证',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t11': '住户身份',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t12': '性别生日',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t13': '选择日期',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t14': '入住状态',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t15': '住户信息核对',
  'pages.Customer.Community.components.ResidentView.EditInfoModal.index.t16': '个人信息获取',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t0': '新增住户',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t1': '批量导入',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t2': '提交后继续创建',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t3': '选择园区',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t4': '请选择园区',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t5': '选择房间',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t6': '请选择房间',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t7': '登录账号',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t8': '请输入手机号码',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t9': '住户姓名',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t10': '证件号码',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t11': '证件类型',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t12': '证件号码',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t13': '正确格式的身份证',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t14': '住户身份',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t15': '性别生日',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t16': '选择日期',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t17': '入住状态',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t18': '住户信息核对',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t19': '点击或将文件拖拽到这里上传，仅支持单个excel文件上传。',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t20': '下载导入模板',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t21': '请先选择文件',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t22': '导入出错数据',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t23': '已成功导入{total}条，失败{errNum}条',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t24': '失败原因',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t25': '重复客户提示',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t26': '根据您输入的手机号：{account}，找到以下已存在的客户账号，您可以新增住户并绑定该账号。如客户信息跟住户信息不一致，请更换登录手机号。',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t27': '客户id',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t28': '客户详情',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t29': '姓名',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t30': '出生日期',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t31': '身份证号',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t32': '绑定',
  'pages.Customer.Community.components.ResidentView.AddResidentModal.index.t33': '请输入正确格式的手机号码',
  'pages.Customer.Community.components.ResidentView.EditPersonalModal.index.t0': '个人信息维护',
  'pages.Customer.Community.components.ResidentView.EditPersonalModal.index.t1': '姓名',
  'pages.Customer.Community.components.ResidentView.EditPersonalModal.index.t2': '出生日期',
  'pages.Customer.Community.components.ResidentView.EditPersonalModal.index.t3': '联系手机',
  'pages.Customer.Community.components.ResidentView.EditPersonalModal.index.t4': '婚姻状况',
  'pages.Customer.Community.components.ResidentView.EditPersonalModal.index.t5': '居住情况',
  'pages.Customer.Community.components.ResidentView.EditPersonalModal.index.t6': '既往病史',
  'pages.Customer.Community.components.ResidentView.EditPersonalModal.index.t7': '个人信息获取',
  'pages.Customer.Community.components.ResidentView.EditPersonalModal.index.t8': '客户标签',
  'pages.Customer.Community.components.DepartmentView.index.t0': '筛选房间',
  'pages.Customer.Community.components.DepartmentView.index.t1': '住户',
  'pages.Customer.Community.components.DepartmentView.index.t2': '房间维护',
  'pages.Customer.Community.components.DepartmentView.index.t3': '房间',
  'pages.Customer.Community.components.DepartmentView.index.t4': '共{roomNumber}个房间，{residentNumber}位住户',
  'pages.Customer.Community.components.DepartmentView.index.t5': '房间列表',
  'pages.Customer.Community.components.DepartmentView.index.t6': '第 {n1}-{n2} 条',
  'pages.Customer.Community.components.DepartmentView.index.t7': '总共{total}条',
  'pages.Customer.Community.components.DepartmentView.index.t8': '筛选住户',
  'pages.Customer.Community.components.DepartmentView.index.t9': '住户姓名、手机号、证件号',
  'pages.Customer.Community.components.DepartmentView.UnitRoomList.index.t0': '人',
  'pages.Customer.Community.components.DepartmentView.UnitRoomList.index.t1': '第 {n1}-{n2} 条',
  'pages.Customer.Community.components.DepartmentView.UnitRoomList.index.t2': '总共{total}条',
  'pages.Customer.Community.components.DepartmentView.AddRoomModal.index.t0': '导入房间数据',
  'pages.Customer.Community.components.DepartmentView.AddRoomModal.index.t1': '请先选择文件',
  'pages.Customer.Community.components.DepartmentView.AddRoomModal.index.t2': '点击或将文件拖拽到这里上传，仅支持单个excel文件上传。',
  'pages.Customer.Community.components.DepartmentView.AddRoomModal.index.t3': '下载导入模板',
  'pages.Customer.Community.components.DepartmentView.AddRoomModal.index.t4': '批量导入',
  'pages.Customer.Community.components.DepartmentView.AddRoomModal.index.t5': '导入出错数据',
  'pages.Customer.Community.components.DepartmentView.AddRoomModal.index.t6': '已成功导入{total}条，失败{errNum}条',
  'pages.Customer.Community.components.DepartmentView.AddRoomModal.index.t7': '失败原因',
  'pages.Customer.Community.components.DepartmentView.RemoveRoomModal.index.t0': '房间',
  'pages.Customer.Community.components.DepartmentView.RemoveRoomModal.index.t1': '提示：删除后将同时迁出住户',
  'pages.Customer.Community.components.DepartmentView.RemoveRoomModal.index.t2': '筛选',
  'pages.Customer.Community.components.DepartmentView.RoomResidentsModal.index.t0': '房间住户',
  'pages.Customer.Community.components.DepartmentView.RoomResidentsModal.index.t1': '住户',
  'pages.Customer.Community.components.DepartmentView.RoomResidentsModal.index.t2': '入住状态',
  'pages.Customer.Community.components.DepartmentView.RoomResidentsModal.index.t3': '信息核对',
  'pages.Customer.Community.components.DepartmentView.RoomResidentsModal.index.t4': '迁出',
  'pages.Customer.Community.components.DepartmentView.RoomResidentsModal.index.t5': '岁',
  'pages.Customer.Community.components.DepartmentView.RoomResidentsModal.index.t6': '是否确认迁出住户？',
  'pages.Customer.Community.components.DepartmentView.RoomResidentsModal.index.t7': '生成二维码',
  'pages.Customer.Community.components.DepartmentView.RoomResidentsModal.index.t8': '选择客户端',
  'pages.Customer.Community.components.DepartmentView.RoomResidentsModal.index.t9': '请选择客户端',
  'pages.Customer.Enterprise.components.EnterpriseForm.index.t0': '公司',
  'pages.Customer.Enterprise.components.EnterpriseForm.index.t1': '部门',
  'pages.Customer.Enterprise.components.EnterpriseForm.index.t2': '二维码',
  'pages.Customer.Enterprise.components.EnterpriseForm.index.t3': '顺序调整',
  'pages.Customer.Enterprise.components.EnterpriseForm.index.t4': '选择客户端',
  'pages.Customer.Enterprise.components.EnterpriseForm.index.t5': '请选择客户端',
  'pages.Customer.Enterprise.components.EnterpriseForm.index.t6': '子部门',
  'pages.Customer.Enterprise.components.EnterpriseForm.index.t7': '确认是否删除：{name}？删除此部门将会连同所有子级部门一起删除。',
  'pages.Customer.Enterprise.components.EnterpriseForm.index.t8': '请确认此部门及其所有子级部门的员工处理方案：',
  'pages.Customer.Enterprise.components.EnterpriseForm.index.t9': '请选择员工处理方案',
  'pages.Customer.Enterprise.components.EnterpriseForm._data.t0': '移到上一级部门',
  'pages.Customer.Enterprise.components.EnterpriseForm._data.t1': '移到上一级部门并批量设为离职',
  'pages.Customer.Enterprise.components.EnterpriseForm._data.t2': '批量删除',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t0': '部门',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t1': '批量导入',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t2': '提交后继续创建',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t3': '所属上级',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t4': '无上级',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t5': '名称',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t6': '相同层级的部门名称不能重复',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t7': '地址',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t8': '省/市/区/街道',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t9': '详细地址',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t10': '服务设置',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t11': '无服务',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t12': '有服务',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t13': '服务团队',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t14': '选择团队',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t15': '服务周期',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t16': '启用状态',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t17': '正常',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t18': '停用',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t19': '多级选择，可搜索，单选',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t20': '点击或将文件拖拽到这里上传，仅支持单个excel文件上传。',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t21': '下载导入模板',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t22': '已成功导入{total}条，失败{errNum}条',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t23': '失败原因',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t24': '请先选择文件',
  'pages.Customer.Enterprise.components.EnterpriseForm.AddEnterpriseModal.index.t25': '导入结果：',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t0': '编辑部门',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t1': '添加子部门',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t2': '',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t3': '所属上级',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t4': '多级选择，可搜索，单选',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t5': '公司/部门名称',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t6': '相同层级的部门名称不能重复',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t7': '地址',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t8': '省/市/区/街道',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t9': '详细地址',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t10': '启用状态',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t11': '正常',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t12': '停用',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t13': '服务设置',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t14': '无服务',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t15': '有服务',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t16': '服务团队',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t17': '选择团队',
  'pages.Customer.Enterprise.components.EnterpriseForm.EditEnterpriseModal.index.t18': '服务周期',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t0': '确认已核对信息？',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t1': '核对',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t2': '确认删除员工？',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t3': '员工姓名',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t4': '员工姓名、手机号、证件号',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t5': '筛选员工',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t6': '岁',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t7': '部门',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t8': '筛选部门',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t9': '（树形选择，每一级都可选）',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t10': '职位',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t11': '在职状态',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t12': '全部',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t13': '信息核对',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t14': '授权状态',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t15': '既往病史',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t16': '多选',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t17': '年龄段',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t18': '最近体检',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t19': '最近服务',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t20': '维护',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t21': '查询结果：',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t22': '共找到{n0}个下级部门，共计{n1}位住户',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t23': '员工',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t24': '在职状态',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t25': '核对信息',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t26': '删除员工',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t27': '核对状态',
  'pages.Customer.Enterprise.components.EnterpriseTable.index.t28': '请确认是否删除所选中的 {num} 位员工？',
  'pages.Customer.Enterprise.components.EnterpriseTable._data.t0': '离职',
  'pages.Customer.Enterprise.components.EnterpriseTable._data.t1': '在职',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t0': '添加员工',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t1': '批量导入',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t2': '提交后继续创建',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t3': '登录账号',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t4': '手机号码',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t5': '员工姓名',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t6': '员工工号',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t7': '证件号码',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t8': '证件类型',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t9': '正确格式的身份证',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t10': '部门',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t11': '多级选择，可搜索，单选',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t12': '职位',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t13': '性别生日',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t14': '选择日期',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t15': '在职状态',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t16': '信息核对',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t17': '点击或将文件拖拽到这里上传，仅支持单个excel文件上传。',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t18': '下载导入模板',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t19': '导入结果：',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t20': '已成功导入{total}条，失败{errNum}条',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t21': '失败原因',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t22': '请先选择文件',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t23': '部门',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t24': '请输入正确格式的手机号码',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t25': '重复客户提示',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t26': '根据您输入的手机号：{account}，找到以下已存在的客户账号，您可以新增员工并绑定该账号。如客户信息跟员工信息不一致，请更换登录手机号。',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t27': '客户id',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t28': '客户详情',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t29': '姓名',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t30': '出生日期',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t31': '身份证号',
  'pages.Customer.Enterprise.components.EnterpriseTable.AddEmployeeModal.t32': '绑定',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t0': '编辑员工',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t1': '登录账号',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t2': '员工姓名',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t3': '员工工号',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t4': '证件号码',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t5': '证件类型',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t6': '正确格式的身份证',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t7': '部门',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t8': '多级选择，可搜索，单选',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t9': '职位',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t10': '性别生日',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t11': '选择日期',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t12': '在职状态',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t13': '信息核对',
  'pages.Customer.Enterprise.components.EnterpriseTable.EditEmployeeModal.t14': '部门',
  "pages.Customer.ReportA4Detail.index.t0": "健康体检报告",
  "pages.Customer.ReportA4Detail.components.FrontCover.t0": "客户姓名：",
  "pages.Customer.ReportA4Detail.components.FrontCover.t1": "性别年龄：",
  "pages.Customer.ReportA4Detail.components.FrontCover.t2": "检测时间：",
  "pages.Customer.ReportA4Detail.components.FrontCover.t3": "YYYY年MM月DD日",
  "pages.Customer.ReportA4Detail.components.GeneralInspectionConclusion.t0": "总检结论",
  "pages.Customer.ReportA4Detail.components.GeneralInspectionConclusion.t1": "主要问题",
  "pages.Customer.ReportA4Detail.components.GeneralInspectionConclusion.t2": "问题描述",
  "pages.Customer.ReportA4Detail.components.GeneralInspectionConclusion.t3": "专家建议：",
  "pages.Customer.ReportA4Detail.components.GeneralInspectionConclusion.t4": "健康指导：",
  "pages.Customer.ReportA4Detail.components.DeptReport.t0": "科室小结：",
  "pages.Customer.ReportA4Detail.components.DeptReport.t1": "正常范围：",
  "pages.Customer.MyCustomer.components.IntegrateAccountModal.index.t0": "合并客户账号",
  "pages.Customer.MyCustomer.components.IntegrateAccountModal.index.t1": "请选择保留账号， 其他账号将会做删除处理，但所属个人信息将会转移给选择保留的账号。",
  "pages.TenantSettings.CustomizePage.components.PhoneTemplate.t0": "是否删除该组件?",
  "pages.TenantSettings.CustomizePage.components.ToolPanel.t0": "设置",
  "pages.TenantSettings.CustomizePage.components.ToolPanel.t1": "复制地址",
  "pages.TenantSettings.CustomizePage.components.ToolPanel.t2": "确认要删除吗？",
  "pages.TenantSettings.CustomizePage.components.ToolPanel.t3": "删除页面",
  "pages.TenantSettings.CustomizePage.components.ToolPanel.t4": "提示：",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.defaultValue.pageGlobal": "页面全局",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.defaultValue.pageName": "页面名称",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t0": "页面名称",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t1": "文字颜色",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t2": "文字大小",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t3": "请输入文字大小",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t4": "标题栏",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t5": "一直显示",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t6": "默认隐藏",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t7": "标题栏背景色",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t8": "页面背景色",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t9": "页面背景图片",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t10": "页面背景渐变",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t11": "图片位置",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t12": "顶部居中",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t13": "垂直居中",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t14": "底部居中",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t15": "图片重复",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t16": "重复",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t17": "不重复",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t18": "微信分享文案",
  "pages.TenantSettings.CustomizePage.components.TopNavbar.Tool.t19": "图片上传失败",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.t0": "跳转链接",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.t1": "请选择页面",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.t2": "请输入链接地址",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.system": "系统预设",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.customization": "自定义页面",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.other": "其他",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.homepage": "首页",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.mall": "商城主页",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.mine": "个人中心",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.n0": "服务预约主页",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.n1": "健康档案页",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.n2": "我的设备页",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.n3": "体检报告页",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.goodDetail": "商品详情页",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.apptItemDetail": "预约服务详情页",
  "pages.TenantSettings.CustomizePage.components.LinkComponent.infoDetail": "资讯详情页",
  "pages.TenantSettings.CustomizePage.componentList.TextComponent.defaultValue.text": "文本",
  "pages.TenantSettings.CustomizePage.componentList.TextComponent.defaultValue.defaultText": "默认文本",
  "pages.TenantSettings.CustomizePage.componentList.TextComponent.TextTool.t0": "标题文字",
  "pages.TenantSettings.CustomizePage.componentList.TextComponent.TextTool.t1": "请输入标题文字",
  "pages.TenantSettings.CustomizePage.componentList.TextComponent.TextTool.t2": "文字大小",
  "pages.TenantSettings.CustomizePage.componentList.TextComponent.TextTool.t3": "请输入文字大小",
  "pages.TenantSettings.CustomizePage.componentList.TextComponent.TextTool.t4": "文字颜色",
  "pages.TenantSettings.CustomizePage.componentList.TextComponent.TextTool.t5": "文字高度",
  "pages.TenantSettings.CustomizePage.componentList.TextComponent.TextTool.t6": "下边距",
  "pages.TenantSettings.CustomizePage.componentList.TextComponent.TextTool.t7": "内边距",
  "pages.TenantSettings.CustomizePage.componentList.ImageComponent.ImageTool.defaultValue.img": "图片",
  "pages.TenantSettings.CustomizePage.componentList.ImageComponent.ImageTool.t0": "图片上传失败",
  "pages.TenantSettings.CustomizePage.componentList.ImageComponent.ImageTool.t1": "上传图片",
  "pages.TenantSettings.CustomizePage.componentList.ImageComponent.ImageTool.t2": "图片宽度",
  "pages.TenantSettings.CustomizePage.componentList.ImageComponent.ImageTool.t3": "显示高度",
  "pages.TenantSettings.CustomizePage.componentList.ImageComponent.ImageTool.t4": "下边距",
  "pages.TenantSettings.CustomizePage.componentList.ImageComponent.ImageClient.t0": "请上传图片",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.defaultValue.button": "单按钮",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.defaultValue.buttonText": "按钮文字",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.ButtonTool.t0": "按钮组宽度",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.ButtonTool.t1": "按钮组高度",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.ButtonTool.t2": "边框圆角",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.ButtonTool.t3": "下边距",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.ButtonTool.t4": "底部固定",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.ButtonTool.t5": "按钮文字",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.ButtonTool.t6": "文字大小",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.ButtonTool.t7": "请输入文字大小",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.ButtonTool.t8": "文字颜色",
  "pages.TenantSettings.CustomizePage.componentList.ButtonComponent.ButtonTool.t9": "背景颜色",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.defaultValue.double_button": "双按钮",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.defaultValue.buttonText": "按钮文字",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.defaultValue.button2Text": "按钮2文字",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.DoubleButtonTool.t0": "按钮组宽度",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.DoubleButtonTool.t1": "按钮组高度",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.DoubleButtonTool.t2": "边框圆角",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.DoubleButtonTool.t3": "下边距",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.DoubleButtonTool.t4": "底部固定",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.DoubleButtonTool.t5": "按钮文字",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.DoubleButtonTool.t6": "文字大小",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.DoubleButtonTool.t7": "请输入文字大小",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.DoubleButtonTool.t8": "文字颜色",
  "pages.TenantSettings.CustomizePage.componentList.DoubleComponent.DoubleButtonTool.t9": "背景颜色",
  "pages.Service.HealthInterventionModal.index.t0": "干预模型",
  "pages.Service.HealthInterventionModal.index.t1": "模型名称",
  "pages.Service.HealthInterventionModal.index.t2": "模型分类",
  "pages.Service.HealthInterventionModal.index.t3": "模型描述",
  "pages.Service.HealthInterventionModal.index.t4": "干预天数",
  "pages.Service.HealthInterventionModal.index.t5": "使用人数",
  "pages.Service.HealthInterventionModal.index.t6": "可用状态",
  "pages.Service.HealthInterventionModal.index.t7": "启用",
  "pages.Service.HealthInterventionModal.index.t8": "禁用",
  "pages.Service.HealthInterventionModal.index.t9": "更新时间",
  "pages.Service.HealthInterventionModal.index.t10": "操作人",
  "pages.Service.HealthInterventionModal.index.t11": "操作",
  "pages.Service.HealthInterventionModal.index.t12": "服务配置",
  "pages.Service.HealthInterventionModal.index.t13": "自动规则",
  "pages.Service.HealthInterventionModal.index.t14": "创建模型",
  "pages.Service.HealthInterventionModal.index.t15": "触发场景",
  "pages.Service.HealthInterventionModal.index.t16": "干预次数",
  "pages.Service.HealthInterventionModel.components.ModelModal.t0": "创建模型",
  "pages.Service.HealthInterventionModel.components.ModelModal.t1": "编辑模型",
  "pages.Service.HealthInterventionModel.components.ModelModal.t2": "模型名称",
  "pages.Service.HealthInterventionModel.components.ModelModal.t3": "请选择",
  "pages.Service.HealthInterventionModel.components.ModelModal.t4": "模型分类",
  "pages.Service.HealthInterventionModel.components.ModelModal.t5": "请选择模型分类",
  "pages.Service.HealthInterventionModel.components.ModelModal.t6": "模型描述",
  "pages.Service.HealthInterventionModel.components.ModelModal.t7": "输入备忘事项，方便后续跟进",
  "pages.Service.HealthInterventionModel.components.ModelModal.t8": "可用状态",
  "pages.Service.HealthInterventionModel.components.ModelModal.t9": "禁用",
  "pages.Service.HealthInterventionModel.components.ModelModal.t10": "启用",
  "pages.Service.HealthInterventionModel.components.ModelModal.t11": "触发场景",
  "pages.Service.HealthInterventionModel.components.ModelModal.t12": "请选择触发场景",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t0": "服务项目",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t1": "请选择服务项目",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t2": "处理时间",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t3": "生效后 ",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t4": "距上次 ",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t5": " 天",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t6": "处理时长",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t7": "{n}天",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t8": "天",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t9": "通知设置",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t10": "设置",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t11": "操作",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t12": "删除此行？",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t13": "干预模型配置",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t14": "服务项目设置",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t15": "请选择推送时间",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t16": "请填写短信文案",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t17": "请选择推送内容类型",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t18": "请选择推送内容",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t19": "设置",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t20": "推送时间",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t21": "短信文案",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t22": "请设置短信文案",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t23": "推送内容",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t24": "请选择推送内容类型",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t25": "请选择推送内容",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t26": "请选择",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t27": "处理形式",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t28": "请设置推送时间",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t29": "立即推送",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t30": "请先保存正在编辑的服务项目",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t31": "年",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t32": "月",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t33": "天",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t34": "小时",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t35": "请设置处理时间",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t36": "推送对象",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t37": "请选择推送对象",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t38": "本人",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t39": "亲友",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t40": "服务团队",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t41": "请输入推送内容",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t42": "链接内容",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t43": "请设置处理时长",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t44": "间隔天数",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t45": "生效后即时触发",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t46": "配置信息",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t47": "通知推送时间：",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t48": "生效时间",
  "pages.Service.HealthInterventionModel.components.ServiceConfigDrawer.t49": "预计{time}{timeUnit}内完成，计划开始时间：",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t0": "添加服务项目",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t1": "修改配置",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t2": "服务项目",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t3": "请选择服务类型",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t4": "请选择服务项目",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t5": "触发时间",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t6": "按计划触发",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t7": "生效后即时触发",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t8": "请选择触发时间",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t9": "服务次数",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t10": "请输入服务次数",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t11": "间隔天数",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t12": "请输入间隔天数",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t13": "处理形式",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t14": "请选择处理形式",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t15": "服务时长",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t16": "请输入服务时长",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t17": "请选择时间单位",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t18": "服务开始时间",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t19": "请选择服务开始时间",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t20": "计划时间",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t21": "请选择计划时间",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t22": "推送文案",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t23": "推送对象",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t24": "请选择推送对象",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t25": "本人",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t26": "亲友",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t27": "健管师",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t28": "请输入推送内容",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t29": "短信链接",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t30": "推送内容",
  "pages.Service.HealthInterventionModal.components.SettingServiceItemModal.t31": "用于显示在报告封面",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t0": "自动干预设置",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t1": "配置触发条件",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t2": "条件组",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t3": "客户类型",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t4": "全部客户",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t5": "服务客户",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t6": "潜在客户",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t7": "添加条件组",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t8": "删除此条件组？",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t9": "不限性别",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t10": "数据来源",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t11": "人工录入",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t12": "设备上传",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t13": "体检报告",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t14": "年龄段",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t15": "请同时设置开始年龄和结束年龄",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.index.t16": "部分指标未完成配置，请完成配置或删除相应指标",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t0": "判断条件",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t1": "数据来源",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t2": "设备上传",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t3": "体检报告",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t4": "取值方式",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t5": "指标结果",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t6": "指标结果",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t7": "指标结论",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t8": "控制范围内",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t9": "异常范围内",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t10": "取值设置",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t11": "正则匹配（包含）",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t12": "请输入",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t13": "组合关系",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t14": "并且",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t15": "或",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t16": "删除此行？",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t17": "判断指标",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.EditableRulesTable.t18": "请选择判断指标",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.VariableComponent.t0": "指标",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.VariableComponent.t1": "性别",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.VariableComponent.t2": "年龄",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.VariableComponent.t3": "请选择指标",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.VariableComponent.t4": "请选择性别",
  "pages.Service.HealthInterventionModel.components.AutoRulesDrawer.VariableComponent.t5": "请输入年龄范围",
  "pages.Customer.PersonalHealthReportDetail.index.t0": "个人健康报告",
  "pages.Customer.PersonalHealthReportDetail.components.FrontCover.t0": "个人健康报告",
  "pages.Customer.PersonalHealthReportDetail.components.FrontCover.t1": "如家人般 关爱您的健康",
  "pages.Customer.PersonalHealthReportDetail.components.FrontCover.t2": "客户姓名：",
  "pages.Customer.PersonalHealthReportDetail.components.FrontCover.t3": "性别年龄：",
  "pages.Customer.PersonalHealthReportDetail.components.FrontCover.t4": "检测时间：",
  "pages.Customer.PersonalHealthReportDetail.components.FrontCover.t5": "YYYY年MM月DD日",
  "pages.Customer.PersonalHealthReportDetail.components.ServiceDynamic.t0": "服务动态",
  "pages.Customer.PersonalHealthReportDetail.components.ServiceDynamic.t1": "服务项目",
  "pages.Customer.PersonalHealthReportDetail.components.ServiceDynamic.t2": "服务时间",
  "pages.Customer.PersonalHealthReportDetail.components.ServiceDynamic.t3": "服务形式",
  "pages.Customer.PersonalHealthReportDetail.components.ServiceDynamic.t4": "服务结果",
  "pages.Customer.PersonalHealthReportDetail.components.ServiceDynamic.t5": "服务人员",
  "pages.Customer.PersonalHealthReportDetail.components.ServiceDynamic.t6": "暂无数据",
  "pages.Customer.PersonalHealthReportDetail.components.HealthBasicInfo.t0": "健康基础信息",
  "pages.Customer.PersonalHealthReportDetail.components.HealthBasicInfo.t1": "生活习惯",
  "pages.Customer.PersonalHealthReportDetail.components.HealthBasicInfo.t2": "既往史",
  "pages.Customer.PersonalHealthReportDetail.components.HealthBasicInfo.t3": "家族病史",
  "pages.Customer.PersonalHealthReportDetail.components.HealthBasicInfo.t4": "用药记录",
  "pages.Customer.PersonalHealthReportDetail.components.HealthBasicInfo.t5": "药品名称",
  "pages.Customer.PersonalHealthReportDetail.components.HealthBasicInfo.t6": "服药周期",
  "pages.Customer.PersonalHealthReportDetail.components.HealthBasicInfo.t7": "长期服药",
  "pages.Customer.PersonalHealthReportDetail.components.HealthBasicInfo.PersonalMedicationHistory.t0": "疾病名称",
  "pages.Customer.PersonalHealthReportDetail.components.HealthBasicInfo.PersonalMedicationHistory.t1": "确诊时间",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.index.t0": "重点关注",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.index.t1": "体重",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.index.t2": "血压",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.index.t3": "餐前血糖",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.index.t4": "餐后血糖",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.index.t5": "空腹血糖",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.CommonMetricItem.t0": "检测次数",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.CommonMetricItem.t1": "最高值",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.CommonMetricItem.t2": "最低值",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.CommonMetricItem.t3": "最新检测数据",
  "pages.Customer.PersonalHealthReportDetail.components.FocusOn.CommonMetricItem.t4": "正常范围",
  "pages.Customer.PersonalHealthReportDetail.components.HealthDetails.t0": "健康指标明细",
  "pages.Customer.PersonalHealthReportDetail.components.HealthDetails.t1": "健康体征",
  "pages.Customer.PersonalHealthReportDetail.components.HealthDetails.t2": "最新测量值",
  "pages.Customer.PersonalHealthReportDetail.components.HealthDetails.t3": "测量时间",
  "pages.Customer.PersonalHealthReportDetail.components.HealthDetails.t4": "正常范围",
  "pages.Customer.PersonalHealthReportDetail.components.HealthDetails.t5": "暂无数据",
  "pages.Customer.PersonalHealthReportDetail.components.PhysicalOverview.t0": "体检概况",
  "pages.Customer.PersonalHealthReportDetail.components.PhysicalOverview.t1": "主要问题",
  "pages.Customer.PersonalHealthReportDetail.components.PhysicalOverview.t2": "专家建议",
  "pages.Customer.PersonalHealthReportDetail.components.PhysicalOverview.t3": "暂无数据",
  "pages.Customer.PersonalHealthReportDetail.components.HealthAssessment.t0": "健康评估概况",
  "pages.Customer.PersonalHealthReportDetail.components.HealthAssessment.t1": "指标名称",
  "pages.Customer.PersonalHealthReportDetail.components.HealthAssessment.t2": "得分",
  "pages.Customer.PersonalHealthReportDetail.components.HealthAssessment.t3": "等级",
  "pages.Customer.PersonalHealthReportDetail.components.HealthAssessment.t4": "结论",
  "pages.Customer.PersonalHealthReportDetail.components.HealthAssessment.t5": "评估时间",
  "pages.MemberPoint.Setting.index.t0": "积分规则",
  "pages.MemberPoint.Setting.index.t1": "搜索标题和描述",
  "pages.MemberPoint.Setting.index.t2": "描述",
  "pages.MemberPoint.Setting.index.t3": "每日次数限制",
  "pages.MemberPoint.Setting.index.t4": "其他条件",
  "pages.MemberPoint.Setting.index.t5": "可获积分",
  "pages.MemberPoint.Setting.index.t6": "启用状态",
  "pages.MemberPoint.Setting.index.t7": "积分功能未开启",
  "pages.MemberPoint.Setting.index.t8": "不限",
  "pages.MemberPoint.Setting.index.t9": " ",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t0": "积分设置",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t1": "启用功能",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t2": "积分名称",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t3": "用于客户端显示，可改名为：“金币”，“健康分”等。",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t4": "积分",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t5": "积分有效期",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t6": "永久有效",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t7": "设定有效期",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t8": "天",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t9": "积分兑换",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t10": "不支持",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t11": "支持",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t12": "兑换比例",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t13": "积分可兑换",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t14": "每次可兑积分",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t15": "兑换渠道",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t16": "健康商城",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t17": "服务预约",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t18": "请选择兑换渠道",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t19": "规则描述",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t20": "输入备忘事项，方便后续跟进",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t21": "请输入积分有效期",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t22": "请输入每次可兑积分",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t23": "请输入兑换比例",
  "pages.MemberPoint.Setting.components.MemberPointSettingModal.t24": "请输入积分名称",
  "pages.MemberPoint.Setting.components.MemberPointEditModal.t0": "编辑规则",
  "pages.MemberPoint.Setting.components.MemberPointEditModal.t1": "规则名称",
  "pages.MemberPoint.Setting.components.MemberPointEditModal.t2": "每日可获次数",
  "pages.MemberPoint.Setting.components.MemberPointEditModal.t3": "次",
  "pages.MemberPoint.Setting.components.MemberPointEditModal.t4": "不限",
  "pages.MemberPoint.Setting.components.MemberPointEditModal.t5": "每次阅读时长",
  "pages.MemberPoint.Setting.components.MemberPointEditModal.t6": "秒",
  "pages.MemberPoint.Setting.components.MemberPointEditModal.t7": "规则描述",
  "pages.MemberPoint.Setting.components.MemberPointEditModal.t8": "可获积分",
  "pages.MemberPoint.Setting.components.MemberPointEditModal.t9": " ",

  "pages.Customer.GroupReport.t0": " ",
  "pages.Customer.GroupReport.t1": " ",
  "pages.Customer.GroupReport.t2": " ",
  "pages.Customer.GroupReport.t3": " ",
  "pages.Customer.GroupReport.t4": " ",
  "pages.Customer.GroupReport.t5": " ",
  "pages.Customer.GroupReport.t6": " ",
  "pages.Customer.GroupReport.t7": " ",
  "pages.Customer.GroupReport.t8": " ",
  "pages.Customer.GroupReport.t9": " ",
};
